webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/1Ad14d7/%3F1697287580382&title=Constance%20Spry%20Cookery%20Book&summary=One%20of%20the%20all-time%20great%20cookbooks%20receives%20a%20lavish%20update%20and%20remains%20an%20essential%20resource%20and%20inspiration%20for%20cooks%20of%20all%20levels.%20%26%23160%3B%20One%20of%20the%20greatest%20cookbooks%20of%20all%20time%2C%20The%20Constance%20Spry%20Cookery%20Book%20remains%20an%20&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/1Ad14d7/%3F1697287580382",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=One%20of%20the%20all-time%20great%20cookbooks%20receives%20a%20lavish%20update%20and%20remains%20an%20essential%20resource%20and%20inspiration%20for%20cooks%20of%20all%20levels.%0Dhttps://textcafe.co/books/1Ad14d7/%3F1697287580382&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/1Ad14d7/%3F1697287580382&posttype=link&caption=One%20of%20the%20all-time%20great%20cookbooks%20receives%20a%20lavish%20update%20and%20remains%20an%20essential%20resource%20and%20inspiration%20for%20cooks%20of%20all%20levels.%20%26%23160%3B%20One%20of%20the%20greatest%20cookbooks%20of%20all%20time%2C%20The%20Constance%20Spry%20Cookery%20Book%20remains%20an%20",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/1Ad14d7/%3F1697287580382&description=One%20of%20the%20all-time%20great%20cookbooks%20receives%20a%20lavish%20update%20and%20remains%20an%20essential%20resource%20and%20inspiration%20for%20cooks%20of%20all%20levels.%20%26%23160%3B%20One%20of%20the%20greatest%20cookbooks%20of%20all%20time%2C%20The%20Constance%20Spry%20Cookery%20Book%20remains%20an%20&media=https://textcafe.co/books/1Ad14d7/tc-custom/9781909166103.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781909166103&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=z8SIDwAAQBAJ&amp;rdid=book-z8SIDwAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781909166103').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/1Ad14d7/tc-custom/9781909166103.jpg?1697287580382',
        alt: 'Constance Spry Cookery Book'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "xhtml/01_Cover", "xhtml/02_Titlepage", "xhtml/03_Copyright", "xhtml/04_Contents", "xhtml/05_Acknowledgements", "xhtml/06_Introductory", "xhtml/07_Chapter01", "xhtml/08_Chapter02", "xhtml/09_Chapter03", "xhtml/10_Chapter04", "xhtml/11_Chapter05", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/1Ad14d7/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_xhtml_01_Cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_xhtml_01_Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_xhtml_01_Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xhtml_02_Titlepage__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xhtml_02_Titlepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_xhtml_02_Titlepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_xhtml_03_Copyright__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_xhtml_03_Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_xhtml_03_Copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_xhtml_04_Contents__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_xhtml_04_Contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_xhtml_04_Contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_xhtml_05_Acknowledgements__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_xhtml_05_Acknowledgements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_xhtml_05_Acknowledgements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_xhtml_06_Introductory__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_xhtml_06_Introductory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_xhtml_06_Introductory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_xhtml_07_Chapter01__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_xhtml_07_Chapter01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_xhtml_07_Chapter01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_xhtml_08_Chapter02__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_xhtml_08_Chapter02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_xhtml_08_Chapter02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_xhtml_09_Chapter03__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_xhtml_09_Chapter03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_xhtml_09_Chapter03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_xhtml_10_Chapter04__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_xhtml_10_Chapter04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_xhtml_10_Chapter04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_xhtml_11_Chapter05__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_xhtml_11_Chapter05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_xhtml_11_Chapter05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_xhtml_12_Chapter06__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_xhtml_12_Chapter06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_xhtml_12_Chapter06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_xhtml_13_Chapter07__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_xhtml_13_Chapter07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_xhtml_13_Chapter07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_xhtml_14_Chapter08__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_xhtml_14_Chapter08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_xhtml_14_Chapter08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_xhtml_15_Chapter09__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_xhtml_15_Chapter09___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_xhtml_15_Chapter09__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_xhtml_16_Chapter10__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_xhtml_16_Chapter10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_xhtml_16_Chapter10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_xhtml_17_Chapter11__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_xhtml_17_Chapter11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_xhtml_17_Chapter11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_xhtml_18_Chapter12__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_xhtml_18_Chapter12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_xhtml_18_Chapter12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_xhtml_19_Chapter13__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_xhtml_19_Chapter13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_xhtml_19_Chapter13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_xhtml_20_Chapter14__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_xhtml_20_Chapter14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_xhtml_20_Chapter14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_xhtml_21_Chapter15__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_xhtml_21_Chapter15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_xhtml_21_Chapter15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_xhtml_22_Chapter16__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_xhtml_22_Chapter16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_xhtml_22_Chapter16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_xhtml_23_Chapter17__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_xhtml_23_Chapter17___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_xhtml_23_Chapter17__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_xhtml_24_Chapter18__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_xhtml_24_Chapter18___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_xhtml_24_Chapter18__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_xhtml_25_Chapter19__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_xhtml_25_Chapter19___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_xhtml_25_Chapter19__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_xhtml_26_Chapter20__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_xhtml_26_Chapter20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_xhtml_26_Chapter20__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_xhtml_27_Chapter21__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_xhtml_27_Chapter21___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_xhtml_27_Chapter21__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_xhtml_28_Chapter22__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_xhtml_28_Chapter22___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_xhtml_28_Chapter22__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_xhtml_29_Chapter23__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_xhtml_29_Chapter23___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_xhtml_29_Chapter23__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_xhtml_30_Chapter24__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_xhtml_30_Chapter24___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_xhtml_30_Chapter24__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_xhtml_31_Chapter25__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_xhtml_31_Chapter25___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_xhtml_31_Chapter25__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_xhtml_32_Chapter26__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_xhtml_32_Chapter26___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_xhtml_32_Chapter26__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_xhtml_33_Chapter27__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_xhtml_33_Chapter27___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_xhtml_33_Chapter27__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_xhtml_34_Chapter28__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_xhtml_34_Chapter28___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_xhtml_34_Chapter28__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_xhtml_35_Chapter29__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_xhtml_35_Chapter29___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_xhtml_35_Chapter29__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_xhtml_36_Chapter30__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_xhtml_36_Chapter30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_xhtml_36_Chapter30__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_xhtml_37_Chapter31__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_xhtml_37_Chapter31___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_xhtml_37_Chapter31__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_xhtml_38_Chapter32__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_xhtml_38_Chapter32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_xhtml_38_Chapter32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_xhtml_39_Chapter33__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_xhtml_39_Chapter33___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_xhtml_39_Chapter33__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_xhtml_40_Chapter34__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_xhtml_40_Chapter34___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_xhtml_40_Chapter34__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_xhtml_41_Chapter35__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_xhtml_41_Chapter35___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_xhtml_41_Chapter35__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_xhtml_42_Chapter36__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_xhtml_42_Chapter36___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_xhtml_42_Chapter36__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_xhtml_43_Chapter37__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_xhtml_43_Chapter37___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_xhtml_43_Chapter37__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_xhtml_44_Appendix__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_xhtml_44_Appendix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_xhtml_44_Appendix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_xhtml_45_Index__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_xhtml_45_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_xhtml_45_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_xhtml_45_Indexa__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_xhtml_45_Indexa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_xhtml_45_Indexa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_xhtml_46_Back__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_xhtml_46_Back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_xhtml_46_Back__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_last__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_last__);
/*jshint esversion: 6 */






















































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/xhtml/01_Cover",
    "name": "xhtml/01_Cover",
    "component": __WEBPACK_IMPORTED_MODULE_4__components_xhtml_01_Cover___default.a
  }, {
    "path": "/xhtml/02_Titlepage",
    "name": "xhtml/02_Titlepage",
    "component": __WEBPACK_IMPORTED_MODULE_5__components_xhtml_02_Titlepage___default.a
  }, {
    "path": "/xhtml/03_Copyright",
    "name": "xhtml/03_Copyright",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_xhtml_03_Copyright___default.a
  }, {
    "path": "/xhtml/04_Contents",
    "name": "xhtml/04_Contents",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_xhtml_04_Contents___default.a
  }, {
    "path": "/xhtml/05_Acknowledgements",
    "name": "xhtml/05_Acknowledgements",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_xhtml_05_Acknowledgements___default.a
  }, {
    "path": "/xhtml/06_Introductory",
    "name": "xhtml/06_Introductory",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_xhtml_06_Introductory___default.a
  }, {
    "path": "/xhtml/07_Chapter01",
    "name": "xhtml/07_Chapter01",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_xhtml_07_Chapter01___default.a
  }, {
    "path": "/xhtml/08_Chapter02",
    "name": "xhtml/08_Chapter02",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_xhtml_08_Chapter02___default.a
  }, {
    "path": "/xhtml/09_Chapter03",
    "name": "xhtml/09_Chapter03",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_xhtml_09_Chapter03___default.a
  }, {
    "path": "/xhtml/10_Chapter04",
    "name": "xhtml/10_Chapter04",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_xhtml_10_Chapter04___default.a
  }, {
    "path": "/xhtml/11_Chapter05",
    "name": "xhtml/11_Chapter05",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_xhtml_11_Chapter05___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_51__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1Ad14d7/tc-custom/9781909166103.jpg?1697287580382",
      "alt": "This image is the cover for the book Constance Spry Cookery Book"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Constance Spry Cookery Book\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("One of the all-time great cookbooks receives a lavish update and remains an essential resource and inspiration for cooks of all levels.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" One of the greatest cookbooks of all time, "), _c('i', [_vm._v("The Constance Spry Cookery Book")]), _vm._v(" remains an essential kitchen bible: astonishingly informative, supremely practical, and constantly at-hand for countless home cooks and future top chefs for over fifty years. With over a thousand pages filled with recipes, cooking history, and miraculous tips, this indispensable resource has now been updated and elegantly redesigned with specially commissioned how-to line drawings."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Cooks of every level will find invaluable information on kitchen processes, soups and sauces, vegetables, meat, poultry, game, cold dishes, and pastry making. This timeless treasure is “a monument to ‘civilised living’ . . . If you can’t find a recipe for something anywhere else, it will be in Constance Spry” ("), _c('i', [_vm._v("The Guardian")]), _vm._v(")."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Cookery is vast, detailed, and lovely. The purpose of the book was to take the knowledge of culinary professionals and write it in a form that British housewives could understand and use. It was, and it remains, the British cookery [and cooking] bible.” —"), _c('i', [_vm._v("Cooking by the Book")]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Constance Spry, Rosemary Hume\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Born in Derby but brought up and educated in Ireland, Constance Spry opened a small flower shop behind Victoria Station in London in the late 1920s and in the 30s this was followed by a school of flower arranging in Mayfair. Spry's outstanding skill and creativity made her much in demand at the highest social levels and her flower decorations became famous throughout the world; she was responsible for the flower arrangements at the wedding and coronation of the Queen. She became joint principal with Rosemary Hume of the Cordon Bleu Cookery School in London and later opened Winkfield Place, a residential school near Windsor, where young women could learn the complete art of cookery and entertaining. Before she died in 1960 Constance Spry had written twelve books on cookery and flower decoration.Rosemary Hume had opened her cooking school ‘Ecole du Petit Cordon Bleu’ in London in the early 1930s having graduated from the Cordon Bleu Cookery School in Paris and in 1945 went on to become co-principal of the London school where she helped and encouraged many of the world’s best cooks. She was a leading cookery writer of her day and was awarded an MBE before her death in 1984 at the age of 76.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grub Street Cookery\n   ")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "coverpage"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "98%",
      "src": "images/cover.jpg",
      "width": "100%"
    }
  })])])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Titlepage"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "98%",
      "src": "images/title.jpg",
      "width": "100%"
    }
  })])])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "space"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("For students past and present at Winkfield Place"), _c('br'), _vm._v("\nand the Cordon Bleu Cookery School")])]), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("This new edition published in 2011 by"), _c('br'), _vm._v("\nGrub Street"), _c('br'), _vm._v("\n4 Rainham Close"), _c('br'), _vm._v("\nLondon"), _c('br'), _vm._v("\nSW11 6SS"), _c('br'), _vm._v("\nEmail: ")]), _c('a', {
    attrs: {
      "href": "mailto:food@grubstreet.co.uk"
    }
  }, [_vm._v("food@grubstreet.co.uk")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.grubstreet.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.grubstreet.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Copyright this edition © Grub Street 2011")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("First published by J.M. Dent & Sons Ltd, 1956"), _c('br'), _vm._v("\nReprinted 1957, 1958, 1960, 1961, 1964, 1967"), _c('br'), _vm._v("\nReprinted with corrections and minor revisions 1971"), _c('br'), _vm._v("\nReissued 1978, Reprinted 1983, Reissued 1990"), _c('br'), _vm._v("\nReissued by Grub Street 2004")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Designed and formatted by Sarah Driver"), _c('br'), _vm._v("\nLine Drawings by Fred van Deelen")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("British Library Cataloguing in Publication Data"), _c('br'), _vm._v("\nSpry, Constance"), _c('br'), _vm._v("\n    The Constance Spry cookery book"), _c('br'), _vm._v("\n1.  Cookery"), _c('br'), _vm._v("\nI.  Title II. Hume, Rosemary"), _c('br'), _vm._v("\n641.5")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("ISBN 978-1-908117-17-5"), _c('br'), _vm._v("\nEPUB ISBN: 9781610047142")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means,"), _c('br'), _vm._v("\nelectronic or mechanical, including photocopying, recording or any information storage and retrieval"), _c('br'), _vm._v("\nsystem, without permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('b', [_vm._v("Publisher’s note to this edition")]), _c('br'), _vm._v("\nAll that we have done to this classic cookbook is to add metric measurements to all the recipes to assist"), _c('br'), _vm._v("\nthe present day cook. The integrity of the original 1956 text remains untouched and unaltered. Hence"), _c('br'), _vm._v("\nyou will still find references to pre-decimal coinage, shops that are now long disappeared and terminology"), _c('br'), _vm._v("\nwhich may to the modern reader sound quaint and outmoded. We had no wish, nor did we"), _c('br'), _vm._v("\nfeel it necessary, to update the language of a wonderful period piece which offers a valuable insight"), _c('br'), _vm._v("\ninto a bygone age.")])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introductory"
    }
  }, [_vm._v("Introductory")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01"
    }
  }, [_vm._v("I")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01"
    }
  }, [_vm._v("The Cocktail Party")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02"
    }
  }, [_vm._v("II")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02"
    }
  }, [_vm._v("Hors-d’œuvre, First-course Dishes, and After-dinner Savouries")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03"
    }
  }, [_vm._v("III")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03"
    }
  }, [_vm._v("Kitchen Knowledge")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#h1.1"
    }
  }, [_vm._v("Tables of Weights and Measures")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter04"
    }
  }, [_vm._v("IV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter04"
    }
  }, [_vm._v("Kitchen Processes")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05"
    }
  }, [_vm._v("V")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05"
    }
  }, [_vm._v("Soups and Soup-making")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sauces")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Root Vegetables")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Vegetables")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetables: Flowers and Fruits")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetable Entrées, Dressed Vegetables, and Simple Luncheon Dishes")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eggs and Savoury Soufflés")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salads")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herbs")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rice, Risottos, Pilaffs, and Curries")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pastas, Pasta Dishes, and Batters")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fish")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meat – Beef, Mutton and Lamb, Pork, Veal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVIII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meat – Les Abats")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIX")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pièces Froides")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XX")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poultry and Game")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXI")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Force-meats, Farces, Stuffings, etc.")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Réchauffés")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Devils, Barbecues, and Marinades")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cold Savoury Mousses, Soufflés, and Aspic")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milk and Cheese")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVI")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bread and Bread-making")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cakes")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVIII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pastry")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIX")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pâtisserie, Petits Fours, Petits Gâteaux, and Gros Gâteaux")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXX")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweets, Hot and Cold")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXI")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Winkfield")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breakfast and Tea")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXIII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garniture and Presentation of Food")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXIV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Menus, Parties, and Food for Special Occasions")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Store Cupboard")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXVI")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Kitchen")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXVII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Modern Kitchen Appliances")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Wines, their Choice and Serving")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("International Conversion Tables")])])])])])])])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  })])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Acknowledgements"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("Acknowledgements")])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("To express thanks adequately for all the help received in the writing of a book such as this is difficult. In the appropriate chapters grateful acknowledgment is made of permission to quote from certain favourite volumes, but when that is done there still remain the hundreds of books read and long forgotten, the good dishes eaten in the houses of friends, the inspiring ideas about food gained from unremembered sources. And it is on such books and such experiences that knowledge of food and cooking is built up.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Rosemary and I both hope that we have not quoted from the work of other people without proper acknowledgment, and we certainly have not done so consciously. Nevertheless it is not at all uncommon among cooks to find that what we thought was our own grandmother’s exclusive recipe has already been made free to the public in more than one cookery book. Of course, in the long range of classic dishes, where it is right and proper that no change should be made in the formulae, tradition has been followed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("While we think fondly of the shades of Mrs Glasse, Sir Kenelm Digby, and all the other people who wrote recipes in such enchanting and elegant language, we want to thank warmly and in particular those contemporaries who have given us the benefit of their time and thought.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Marjorie Baron Russell and Valerie Pirie for reading, criticizing, and advising; Muriel Downes, our deputy principal at the Cordon Bleu Cookery School in London, and Jean Chaplin at Winkfield for testing, suggesting, and improving recipes; Daphne Holden for much laborious checking and sorting, various members of the staff for kindly help, and quite a few students whose questions have often revealed to us that what we thought was as clear as daylight was really not so at all, and finally, the publisher’s reader for looking after the consistent presentation of the text and preparing the index.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For the appendix, ‘Wines, their Choice and Serving,’ which is a rather specialized subject for a cookery book, Rosemary is solely responsible: Thanks are due to Major Bruce Shand for his helpful suggestions and also for reading the manuscript of this section. I also thank the owners of the copyright and the publishers Methuen and Co. Ltd, and Doubleday and Co. Inc., for permission to quote an extract from "), _c('i', [_vm._v("The Price of Love")]), _vm._v(" by Arnold Bennett, and the author, and William Collins Sons & Co. Ltd, for permission to quote an extract from "), _c('i', [_vm._v("The Sword and the Stone")]), _vm._v(" by T. H. White.")])])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  })])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Introductory"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Introductory")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In music-halls and places where they sing, it is common practice for the star to have a stooge – a ‘feed,’ I believe, is the term used in the profession – and it is his job to underline and illumine, as it were, the qualities of the star. In preparing a book of this kind it is not a bad idea to have a stooge, and that is the part that vis-à-vis Rosemary I have tried to play; if I have done so properly I believe that the plan will have served to make clear a lot of things that professionals, in their knowledge and experience, take for granted, matters which cookery books do not always mention, and things that you aren’t born knowing. I really wanted to call this book "), _c('i', [_vm._v("The Reason Why")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But whatever the title, this book is an offering from Rosemary and me to the students of Winkfield Place and the Cordon Bleu Cookery School in London. She and I planned it, thinking it might provide an answer to any question left over when, their training finished, they scattered themselves over the world, as indeed they have done.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I have had the pleasure of gathering up the material and stringing it together, but the technical knowledge, the technique, and most of the recipes are hers, and anything I know that is worth knowing I have gained from her. Sometimes knowledge pours from her as she talks about cooking, sometimes on the other hand I’ve battered her with questions about things second nature to her, but mysteries to me.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I am sometimes asked, and I am sure she is too, how it comes that she, a professional cook, and I, whose primary interest lies in flowers, have become allied in this way; and I should like to tell you how it happened.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Before the war each of us was ploughing her respective though not lonely furrow – Rosemary had her ‘Au Petit Cordon Bleu’ restaurant and its attached school and I a shop and a flower school. Like snow in summer students melted away at the proclamation of war, but before the very last of mine disappeared into the war machine, an idea was voiced which bore fruit. ‘After the war,’ said one of them, as though that relief were just round the corner, ‘could you not add cookery lessons to our flower programme?’ and then added thoughtfully: ‘I think we shall need it’; showing in this constructive suggestion a prophetic vision.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("So when the end of war was in sight there came, like an echo from the past, the question: ‘What about that promised cookery and flower school?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When I began to sketch a curriculum I quickly realized that if I carried it out I should merely be following the trail blazed earlier by Rosemary in her school, which had also become a war casualty. Full of doubts and nervous apprehension, I went off to see how she felt about it. The result was an enthusiastic and practical co-operation that has resulted in the London and Winkfield schools and now in collaboration over a book which her real knowledge and experience of food and cooking has made possible.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Little did I realize what was at stake when I went to see her, for I did not realize, nor do I think did ")]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_vm._v("she, what a big part cookery was to play in the lives of women after the war. I was the amateur with homely ideas and limited knowledge, enough perhaps to meet simple war-time demands, but completely inadequate to deal with the overwhelming demand for and need of knowledge which have since become manifest. She was the professional, and I often wonder with a cold shiver, generally around two o’clock in the morning, what would have happened if I had gone on without the inestimable benefit of her cooperation, without what seems to me to be an inexhaustible mine of information.")])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("That is how this combination of professional and amateur has come about; and I hope you will find the recipe a practical one. You see, what is clear as day and foolproof to Rosemary is often not so for me, and in writing this book I have been a pestilential ‘why man’. ‘But Rose, why not? Why can’t you? Why do you?’– until I couldn’t have blamed her if she had rationed me to five tiresome questions a day, or deflected her rolling-pin from her puff pastry to me, and with equal vigour.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Collecting the material has been fun; it has also been hard work, and I am praying that not many slips will escape into print – not many, for instance, like the one I lighted on when half a saltspoon of cayenne had been translated by a typist into half a pound. Until you have tried it you cannot think how many snares there are in cooking parlance; it has a verb all its own, and now and then I have found myself instructing you to stand in a bain-marie till dinner-time, to cook the saucepan, and to pour the pudding over the sauce, and I have clearly accredited you with three hands.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The incidence of French words is no snobbery, or I hope not. It is sometimes difficult to find a suitable English equivalent for them; if you try you will find that often the English words lack nicety of description. Sometimes a translation sounds downright unappetizing. Do you like the sound of ‘paste of fat liver’? Would you not laugh if instructed to stand a pan in Mary’s bath? Of course many French words have become part of our cooking language.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Impatient youth may criticize the frequent, almost nagging repetition of some words and instructions, words such as ‘gently and slowly,’ for example; yet judging from the often misapplied verve and dash to be witnessed in the kitchen, the emphasis is not really out of place. Rosemary says will I please add the word spooning to the list. This is not a joke; she says that all too often she sees a pan of sauce being sloshed over a dish so that the food is afloat. She also says that I must add in letters of fire "), _c('i', [_vm._v("Please read your recipe")]), _vm._v(", and she says it with so much pathos that I wish modern printing made this possible.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To the over-meticulous, or to those who think cooking can be reduced to a series of scientific formulae, the word ‘approximately’ may be an irritation. The fact is that cooking is a combination of science, art, invention, and a few other things; it calls for individual taste and latitude in adjustment of the formulae. There is another word to be underlined – taste – taste of course in both its meanings, of discrimination of quality and perception of flavour, but primarily here the latter. If you won’t taste as you work you will never be a first-class cook; what other possible guide have you to rely on for nicety of seasoning and flavouring and all the subtleties of a dish – even of what you may be pleased to call good, plain food? There can be a smug sound about these words as sometimes uttered, especially when they are used to cover the bad cooking that produces overcooked meat, gluey gravy, waterlogged vegetables, and heavy puddings. Good plain food can be the best, the apotheosis of good fare; it can be very expensive and still plain. Good cooking owes a great deal to attention to detail, whatever the exponents of a more slapdash method may aver.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_vm._v("Cooking is an art; it demands hard and sometimes distasteful work, but on the whole it is the creative side that prevails. The kitchen should be raised to the status of a studio, as indeed it is in some homes where the mistress of the house is a cook. If it should ever become universally so regarded, then to earn a living in a domestic kitchen would become a more attractive calling to young, educated, qualified ")]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("cooks, who at present are more attracted to posts in commercial and institutional kitchens. This is a pity, for it is in the private kitchen that opportunity presents itself for experiment and invention. As it is, the contemporary cook-hostess has the best of it, for she sees her efforts appreciated and hears the dishes discussed, which is a pleasant innovation, for talk about food used to be taboo.")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Something else is new too: the immensely better and fairer distribution of food among all grades of society. This is due to a variety of causes, not the least of which was the rationing system at which we grumbled so incessantly and to which we so thankfully said good-bye. Remembering as I do the days of immensely long, boring, wasteful dinners, remembering too the starvation which was all too often at our very doors, I cannot forbear to remind you how much respect ought to be paid to food, how carefully it should be treated, how shameful waste is. Forgive me for this, but you see it is fortunately unlikely that your hearts will be wrung or your consciences nudged by the sight of starving people.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Since it would seem to be the simple duty of any woman with a home to run, of those with any son of civic conscience to understand about food and cooking, it is strange how low the subject ranks in the estimation of many academically minded people. The influence of good food in the bringing up of children, its importance in the building up of a strong people, the contribution it may make to the harmonious running of a home, may be acknowledged theoretically, but there is still a tendency to consider the subject suitable primarily either for girls who cannot make the grade for a university or for those who intend to become teachers. As a training for home life, as a necessity for civilized living, as a serious consideration for the mentally clever girls, it is not always accorded approval. Possibly many scholarly women remember, as I do, the fight made for equality in education, and it may be natural for them to see only certain of the bright facets of learning. In gaining so much, and gaining it with courage and tenacity, the homelier arts may have been eclipsed for a short space of time, but surely now intelligent people recognize them for what they are, the basis of balanced living.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There is a lot of nonsense thought and said about French cooking. There is an idea that it is ‘high-falutin fancy,’ overdressed and not suitable for good sound English taste. The fact is that Frenchwomen, for various economic and historic reasons, are good housekeepers and good shoppers, cooking with skill, economy, and imagination, wasting nothing, disregarding nothing that may be turned pleasantly and profitably to account. It is because of this, because of their attention to detail, that Rosemary and I both think French cooking the best basis for teaching and practice. This does not preclude appreciation of all that is good in English and other traditions. The marriage of our excellent materials to French methods is a good union.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It will be seen that we have used the word butter in a great many of the recipes. This is a policy of perfection and is not intended to indicate that no substitute is ever to be considered. Where butter is essential – a substitute really undesirable – this has been made clear.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For the most part the quantities given in the recipes are for 4-5 people.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The following is a translation of a letter written by a Frenchwoman to a young Arab cook entering the service of some friends in Tunisia, and because it expresses so much of the spirit of the subject of this book, Rosemary and I felt we must let you read it.")]), _vm._v(" "), _c('p', {
    staticClass: "righta"
  }, [_vm._v("Constance Spry")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Winkfield Place, Windsor Forest")])]), _c('p', {
    staticClass: "h1-para"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("My friend and fellow cook,")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I should like to offer you some advice, and write down a few hints for you, because your career as a cook is only just beginning, and it rests with your own native intelligence to make it interesting, and even exciting.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cooking is a multi-faceted art. It is as old as the hills, and yet there is always something new to be learned – something new to be invented.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Since the dawn of history kings and potentates have been interested in cooking, and Good King Henry IV of Navarre is always remembered in France as a good-tempered king and one who loved good food and wine … throughout the ages all sorts and conditions of men have delighted to gather their friends around them and spoil them by cooking delicious dishes for them, with the result that their guests, even if comparative strangers, would go on their way well fed and comforted, calling down blessings on their kind host in whose house they had found the spirit of order, of hard work, and of peace.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cooking is a complicated art: not everybody understands it. Keep your ears open and be humble; keep your eyes open too. Think: for the more you learn, the more full of interest life becomes. You can always go on learning, and so you ought to do. For you are the stuff that good cooks are made of; you have a receptive mind, and it is for this reason that I am putting down a few remarks that may be of help to you.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A good cook is always exact, always clean, and above all conscientious. It is a matter of pride with him to keep his kitchen in spotless order. As it happens, your kitchen is big, clean, well lighted, and comfortable. You do not know how lucky you are, for it is a comparatively simple matter to turn out marvellous dishes when the right equipment is available.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A good cook is economical. He goes to endless trouble to turn out his best efforts without wasting a crumb… waste is a grievous sin, which fills the heart of the honest man or the good cook with horror. To make sure of using up everything to good effect it is absolutely essential for him to be able to plan ahead.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As soon as the washing up is done each evening, he should run his eye over his provisions. Opening the door of his Frigidaire, he stands in front of it, and thinks. He thinks rapidly, but that moment’s reflection is absolutely necessary. How much butter is there? How much meat is left? How much cheese? What is there in the way of left-overs? At least twice each week he should go right through his capacious Frigidaire, and make as much space as he can afford for the needs of the morrow. His kitchen companions should be made to understand that he is the absolute master of the Frigidaire, and he must insist that everything in it shall be kept in absolute order. Raw fish must not be left for days in the refrigerator, dripping on top of a custard; no plates or bowls must be lodged in such a way that they will fall and break when the door is opened. A chef proves his worth by the scrupulous order in which he keeps his refrigerator, for which he is solely responsible.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As a result of his nocturnal meditation beside the Frigidaire the cook should have a mental grasp of everything that is needed for to-morrow’s meals. He must make a mental note of anything that is missing, for he cannot afford to run short, seeing that he is responsible for the comfort of his masters. If he loves them and respects them, it is up to him to see that all goes well and smoothly… .")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In a well-run kitchen common sense is just as important as organization, and there is always plenty for everyone to do. But what a reward it is for a cook when he is sufficiently master of his trade to be able to send at will to his master’s table beautiful dishes, cleverly planned and perfectly cooked. Quick, quiet service at the table, as in the kitchen, everything well planned in advance, a carefully considered menu, fine food when guests are present, good wholesome fare for the family every day – all these are the responsibility of the good cook. His basic axiom should be the old French proverb, ‘Le Bonheur c’est l’Ordre.’")])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter01"
    }
  }, [_c('p', {
    staticClass: "ch-num"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("I")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_vm._v("The Cocktail Party")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Perhaps a cookery book should start in a less frivolous fashion than with a chapter headed ‘The Cocktail Party,’ and should show in its initial stages a proper seriousness of purpose and general sober-mindedness. But I had an idea that perhaps a light-hearted approach might present a more immediate appeal. One never knows, indeed, what trifle may awaken the enthusiasm necessary to carry one beyond the early arduous tasks connected with cooking into those realms in which cookery is an art and a pleasure. Rosemary Hume and I have noticed that a lesson or a demonstration on cocktail savouries is always popular, conjuring up as it does a vista of successful parties to be held in the future, and imparting a touch of glamour to the basic realities of the kitchen. Well, if the desire to excel in making good bouchées encourages a student to achieve mastery with pastry, all is well. Maybe this chapter should be regarded as the jam with the powder, the carrot before the donkey, but no matter if it serves to lure anyone on in the kitchen. It is only fair to admit that neither R. H. nor I set great store by cocktails or their accompanying savouries, regarding them, as it were, as menaces to the appreciation of good food.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Some cocktails, particularly the more potent of them, may blunt the palate, and preliminary savouries the appetite. The basic idea that a cocktail is intended to stimulate the appetite loses its point when one considers the profusion of food and drink usually presented at a cocktail party. At this point I am reminded of a paragraph that struck me in one of three articles written by Rebecca West for the "), _c('i', [_vm._v("New Yorker")]), _vm._v(" early in 1953. The articles were called ‘The Annals of Treason’ and dealt with the case of William Martin Marshall, the radio telegraphist, who became involved with a Soviet agent in London and was tried for espionage. His parents felt that the whole trouble had started in Russia, where they thought he had followed a life to which he was not accustomed, and Rebecca West goes on:")]), _vm._v(" "), _c('div', {
    staticClass: "disp-quote"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("There were continual parties. Cocktail parties. The sharp sound of the words, flung out after a preparatory pause, recalled that there was an age not so long ago when a cocktail was considered an immoral drink, as different from sherry as concubinage is from marriage, and a cocktail party meant an assembly of people who had abandoned normal restraints. A change in custom in one group may take a very long time to become known in other groups. There was, indeed, no reason for a household like this, which drank either beer or, more probably, only soft drinks, ever to have learned that cocktails had long since become respectable, and that cocktail parties had for many people moved up to the position, formerly occupied by tea parties, of social functions too stereotyped to be anything but tedious.")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Whether one likes such parties or not, it appears that for the moment at any rate they have come to stay and have their uses, and that being so, if you give one at all let it be of the best, a best which is not necessarily achieved by serving too many or too strong drinks.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("When in England we first adopted the cocktail party we were inclined to timidity, and the range of savouries offered was conservative as to size and variety. Even yet there is a tendency in this direction. Too many little mouthfuls, canapés, bouchées and suchlike, can be monotonous. I personally like better to have one or two main dishes of undeniable popularity, every bit of which will be eaten, and which will send no one home feeling blown up with starch. For instance, if I were feeling extravagant I should choose perhaps as my "), _c('i', [_vm._v("pièce de résistance")]), _vm._v(" the prawn dish with Alabama sauce, or if economically bent the cream cheese dish; and I should moderate the number of small savouries accordingly. One must of course differentiate between the various occasions for which cocktail savouries are required, and they may fall under the following headings:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("(a) Small savouries served with drinks before a dinner party. These should not be too substantial and need not be greatly varied, and such things as nuts, olives, small cheese biscuits, and tiny canapés are adequate. The canapés should be of a size that can comfortably be eaten in one mouthful.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("(b) Savouries for the cocktail party lasting perhaps from six to eight o’clock, at which may be offered a certain number of fairly substantial items.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("(c) Savouries for the pre-theatre cocktail party, when you know your guests will not be eating seriously until much later, and a few fairly solid savouries will be welcome.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("It may well be emphasized at the outset that the success of this type of food depends more on seasoning, flavouring, and pleasing contrast of texture than on elaborate and expensive materials, and that particular consideration should be given to presentation, and ease of serving and eating. Remembering the worst and the best of such parties clarifies my ideas, and I will tell of those features which made or marred them for me. On a less successful occasion I remember thinking it a great mistake to have so large a number of savouries of one type. The labour-saving device resorted to for this party of making one large batch of pastry and ringing the changes on the filling might possibly have been all right if some more refreshing and contrasting items had been offered, but the addition of filled bridge rolls and bread sandwiches to an array of pastry cases did not produce happy results. The sum total was stuffy and starchy. Too many similar textures are also tiresome; creamy fillings in bouchées and creamy spreads for canapés become extremely cloying. So bearing in mind the need for refreshment for the palate, it is well to vary the pastry, bread, or biscuit theme of these savouries, perhaps with celery as in the recipe on ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#page_6"
    }
  }, [_vm._v("page 6")]), _vm._v(", or by offering stuffed grapes or cherries; or by having a large bowl of raw vegetables – "), _c('i', [_vm._v("les crudités –")]), _vm._v(" which are a feature of one popular Paris restaurant in particular, where you may find a few small mushrooms among the young carrots, celery, radishes, spring onions, lettuce, and chicory. A bowl of rough salt should be at hand if this refreshment appears on the cocktail table. If it is chosen as a first course for luncheon on a hot day, it calls for fresh French or home-made rolls with ice-cold curls of butter.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At one of the best cocktail parties I remember, attention was centred on two large dishes, one hot and one cold. There was an adequate supply of these and there were not a great many little savouries, though there were a few: grapes filled with cream cheese, for instance, celery with Stilton cheese and so on; but the main attention had been focused on one or two popular things which proved successful.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The presentation of food at a cocktail party has importance. The larger dishes should look and taste exciting and are generally eaten to the last morsel. The smaller savouries, bouchées, canapés and so forth, may be arranged like a wheel on large platters, and this is at once more convenient and nicer to look at than a number of small plates. Small plates covered perhaps with paper doilies have a way of looking "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("derelict as soon as the party is under way. Cheese sticks, sablés, and biscuits can be aligned on wire trays which emphasize that they are fresh from the oven. Filled bridge rolls and sandwiches also look well on trays. Those items of food speared on small wooden sticks – olives, stuffed cherries, cheese or fish marbles and so on – may be conveniently collected for serving by using firm hearts of red and green cabbage into which the picks are stuck, presenting a porcupine-like aspect. The cabbages should be trimmed at the base and the lower leaves turned out, so that the whole stands firm. Polished apples, grape-fruit, lemons, and small marrows may be used in the same way. It is convenient, too, to have one main table on which the dishes are assembled, and by the way they are presented you may add to the gaiety and interest of the party.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("If you should decide on having no main dish, but choose instead a diversity of small things, these are best assembled in a generous way, avoiding too many small dishes. However many odds and ends you may choose to have, bear in mind the importance of contrast both of flavour and texture. Olives, nuts, and potato chips are always popular. The nuts should be freshly prepared and the chips properly heated through and salted. Certain types of savoury suitable for a cocktail party are equally suitable for serving as an after-dinner savoury, and the subject of this final course to a meal will be dealt with later. But the following general points may apply to both types of savoury and so I will give them here.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("1. When toast is used as a basis, the bread should be evenly sliced and about three-eighths of an inch thick. It should be toasted to a good brown and the crusts removed. It should be made at the last possible moment and dried off a little to allow the steam to evaporate before buttering.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("2. Fried canapés should be cut from evenly sliced rounds of bread about a quarter of an inch thick. They may be fried in shallow fat, in either butter or oil, according to the rules for shallow frying, i.e. the rounds should be turned once only. If they are fried in deep fat, they should be plunged into the smoking fat and turned about with a slice. Care should be taken not to let them become over-brown, or they will be hard and chippy.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("3. Where bacon rashers are used they should be streaky and cut very thin; a number three cut on the grocer’s bacon slicer is suitable. The rind is then removed with scissors and the rashers trimmed and spread out with the flat of a knife on a board. Half a rasher for each savoury is usually enough.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("4. Where anchovy fillets are called for they may well be soaked for some hours in milk, particularly if they have been preserved in brine, or have become hard and dry. If they have been preserved in brine they must be washed before being soaked. Picked shrimps may be treated in similar fashion.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("5. Cheese for grating should be dry, and the best all-round cheese is a dry, well-matured cheddar, or a mixture of gruyère and Parmesan. For Welsh rabbit or other toasted cheese dishes cheddar is most suitable.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("MAIN DISHES (HOT)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The keeping of these really hot does present a problem to the cook-hostess, for although one may serve them on a large hot fireproof dish, the savouries obviously will not retain heat for long. A chafing-dish is a valuable possession, and a hot-plate will help. Recently there have come on the English market deep dishes holding night-lights and covered with a perforated metal lid; these are less expensive than the two foregoing.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("A large hot fireproof dish filled with small mixed fritters is excellent, but it is difficult to keep them small enough to uphold the idea of ‘No two bites at a cocktail savoury.’ They should be made as small as is conveniently possible and reserved for a party where more substantial items are called for. They may be of vegetables, sprigs of herbs, prawns, mushrooms, onion rings and so forth. They should be ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("well flavoured and seasoned individually, dipped in a light fritter batter, and fried in deep fat. Piquant sauce may be served apart in a bowl into which the fritters are dipped. For this purpose they should be speared on picks. The recipe for a fritto misto of vegetables given on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10#page_236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 236")]), _vm._v(" will serve for this dish, and anyone of the really piquant sauces may be chosen; in particular I think the one called Alabama sauce is very good, as is the alternative given on "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#page_5"
    }
  }, [_vm._v("page 5")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If you want a small dish of one kind of fritter, I would choose mushrooms, for which you take small button mushrooms, season them well with salt and pepper and a dash of lemon juice, dip them into the fritter batter given below, and then fry them in deep fat to a golden brown. These again are served with a piquant sauce. Or your dish may be half these and half watercress puffs, for which you take sprigs of well-dried watercress, dip them in the batter, and fry.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Prawns, pieces of crawfish tail, and lobster may all be treated in the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Small, dry, well-seasoned fishcakes containing a touch of curry-powder or paste are a popular hot dish. Like the fritters these may be served on picks and dipped into a bowl of suitable sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("A LIGHT FRITTER BATTER FOR THE VEGETABLE AND HERB FRITTERS")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("150g/5 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a level teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("yeast about the size of a walnut")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("about 150ml/¼ pint water")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("When yeast is not available a substitute may be made of 1–2 tablespoons brown ale, in which event the amount of water may be reduced. The mixture should have the consistency of thick cream. Sift the flour and salt, dissolving the yeast in a little of the slightly warmed water and beating it into the flour with the remaining liquid.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here is a recipe for the small fishcakes:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PETITES CROQUETTES DE POISSON")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("cold fish that has been cooked in court bouillon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225ml/8 fl oz milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz breadcrumbs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt, pepper, nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a dash of curry-powder")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("egg and breadcrumbs for coating")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Flake the fish, remove all skin and bone. Melt the butter, add the flour, and cook gently for a short time. Pour in boiling milk and whisk until the sauce thickens, add fish and breadcrumbs, season well with salt, pepper, nutmeg, and curry-powder. Spread the mixture on a plate to cool. Make into small croquettes, coat with egg and breadcrumbs, and fry golden brown in hot fat. Drain and serve hot.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("MAIN DISHES (COLD)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("One of the best of these I met with in Alabama. For this a large dish was filled with crushed ice, a hollow in the centre holding a glass bowl filled with Alabama sauce; all around, stuck in the ice, were picks holding Dublin Bay prawns; the prawns were dipped into the sauce and eaten. This is an admirable dish but by no means economical; however, the prawns may be replaced by the Norwegian frozen prawns, which are excellent, by pieces of crayfish or lobster, or even by dry, very well-seasoned fishcakes, "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("such as those already given.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("A recipe for Alabama sauce will be found on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06#page_154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 154")]), _vm._v("; the following is an alternative:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("AN ALTERNATIVE SAUCE TO ALABAMA TO SERVE WITH FRITTERS OR SHELL-FISH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Make a good cream dressing or mayonnaise and add to it 1 dessertspoon wine vinegar, 1 tablespoon salad-oil, salt, freshly ground black pepper and made mustard to taste, 1 heaped teaspoon sugar, 2 teaspoons grated horseradish, chopped chives and spring onions, a squeeze of lemon juice, and a dash of tomato ketchup. Beat all together and add finely chopped gherkins, capers, or sweet pickles.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Another good main dish is made with a form of home-made cheese beaten to a light cream, piled lightly on a dish, surrounded by chipped potatoes, radishes, gherkins, olives and so forth, and accompanied by a separate dish of plain hot biscuits, preferably salted. The cheese is either spooned on to the biscuits or scooped up with potato chips. The cheese for this dish may be made in a variety of ways, and here is one simple recipe:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("HOME-MADE ‘CREAM’ CHEESE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("cheddar cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("butter up to an equal quantity with the cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("hot milk, cream, or yoghourt, or a mixture of all three, may be used in place of part or all of the butter. Additional bulk may be given by the incorporation of home-made sour-milk cheese, as given on "), _c('span', {
    staticClass: "color1",
    attrs: {
      "href": "#/xhtml/31_Chapter25#page_648",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 648")]), _vm._v(" in the milk and cheese chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("flavourings added to taste: a dash of anchovy essence and/or Worcestershire sauce, chopped capers, olives, gherkins, sweet pickle, chives, crushed garlic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasonings: salt, paprika, freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Grate the cheese and pound, or put it through a wire sieve. Beat it well, adding the other ingredients. Taste for seasoning and flavouring. If this cheese is to be used in quantities as a main dish the flavouring should be fairly restrained. If, however, it is wanted for canapés the stronger form of it known as Liptauer may be made. See "), _c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter25#page_649",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 649")]), _vm._v(" of the milk and cheese chapter or the good luncheon cheese given on "), _c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter25#page_649",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 649")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("SMALLER SAVOURIES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cheese enters into many cocktail savouries, ranging from tiny Welsh rabbits to sables and cheese creams for filling savoury éclairs and choux, and recipes for some of these savouries are now given.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CAMEMBERT SAVOURY")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("trimmings of puff pastry")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("olives")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt, pepper, and cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Camembert cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Roll the puff paste thin and cut in strips. Bake light brown in a hot oven, and sandwich with Camembert cheese worked with an equal quantity of whipped cream, seasoned with salt and pepper and a dash of cayenne, and mixed with a few stoned, chopped olives. Serve hot or cold.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("CREAM CHEESE CANAPÉS (1)")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Make a rich short crust with 75g/3 oz flour, 50g/2 oz butter, 25g/1 oz cheese, 1 egg yolk, and seasoning. Roll and stamp into rounds the size of half a crown and bake for 7 minutes. Pipe on to these, or put on with a teaspoon, a good creamed cheese such as Liptauer. Into this you may put chopped chives, pounded anchovies, tomato purée, and paprika to taste. Decorate the canapés with black olives, pickled walnuts, pickled onions, or gherkins.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CREAM CHEESE CANAPÉS (2)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Beat demi-sel or home-made cheese with a little cream to the consistency of whipped cream. Season well, pipe on to small rounds of cheese sables (see recipe below), decorate with red-currant jelly or pickled cucumber.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("A recipe for Cheese Marbles (Hot) will be found on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter12#page_309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 309")]), _vm._v(" (Salads).")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CÉLERI FARCI")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1-2 heads of first quality celery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25-50g/1-2 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("brown bread and butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50-75g/2-3 oz Stilton cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("pimento")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut the root off the celery, carefully detach the stems, and wash well. Discard any stringy or discoloured stems. Put the remainder into cold water and leave to become crisp. Meanwhile cream or pound the Stilton with enough butter to make it taste mild and good – the quantity depends on the ripeness of the cheese – and season well with salt and pepper. Dry each stem of celery well, and with a small palette-knife spread the cheese mixture inside the stems, starting with the smallest and reshaping the stalks into two or three ‘heads,’ according to the size of savoury desired. Wrap each ‘head’ in grease-proof paper and put aside in a cool place to become firm. Then cut each ‘head’ crossways into slices about 5mm/¼ inch thick, and set each on a round of brown bread and butter stamped out to exactly the same size as the slice of celery. Garnish with a very small round of canned pimento put in the middle of each slice. The nozzle of a forcing-pipe about 5mm/¼ inch in diameter is a good cutter for the pimento.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("N.B. Chicory may take the place of celery when the latter is not in season, but it is not so crisp.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CHEESE SABLÉS")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz grated cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Rub the butter into the flour and add the grated cheese and seasoning. Leave in a cool place for 10 minutes. Roll out to 5mm/¼-inch thickness and cut into wide strips, then into triangles. Bake 10 minutes in a fairly hot oven.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Almond sables filled with a creamy filling are delicious, and a recipe for them will be found in the milk and cheese chapter ("), _c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter25#page_655",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 655")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("WALNUT SABLÉS")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz grated cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("beaten egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("coarsely chopped walnuts")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("rock-salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Rub the butter into the sifted flour and add the cheese with the seasoning. Knead together into a paste. Roll out thinly. Cut into strips about 5cm/2 inches wide. Brush over with beaten egg and sprinkle thickly with the walnuts. Grind a little salt over this and cut each strip into triangles. Bake on a tin lined with grease-proof paper in a moderately hot oven till golden brown, about 10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CHEESE STRAWS")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("175g/6 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("85g/3½ oz butter or margarine")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz grated Parmesan or Parmesan and gruyère cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt, pepper, and cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("yolk of 1 egg or a little beaten egg")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Rub in the fat lightly, add the grated cheese and seasoning, and bind with the egg yolk or beaten egg, and a spoonful of water if necessary. Roll out and shape into a rectangle; cut across into strips and bake on a paper-lined baking-sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A range of cocktail savouries made with choux pastry maybe light, agreeable, and easy to vary:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TARTELETTES À LA MARJOLAINE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Line very small tartlet moulds with a savoury short pastry. Prick the bottom of each case and line with paper and beans to keep the shape. Bake 10–15 minutes in a hot oven.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Prepare a choux paste in the usual way (see ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter28#page_732",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 732")]), _vm._v(") with the addition of 50g/2 oz grated cheese at the last. Fill this into a bag with a small round pipe, and pipe round the bottom and sides of the tartlets so as to form a small well in the middle. Fill in with a thick creamy béchamel sauce, well seasoned, and with grated cheese added. Put the tartlets into a moderate oven for another 10–15 minutes, in order to cook the choux paste gently whilst browning the middle of the tartlets. Serve very hot, and immediately, when they become like a soufflé. In larger tartlet moulds these make a good savoury.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "h3-italic"
  }, [_vm._v("Béchamel sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Bring 150ml/¼ pint milk slowly to the boil with a bay-leaf, a slice of onion, and a blade of mace. Strain carefully on to a roux of a good 15g/½ oz each of flour and butter. Stir till boiling, simmer a minute or two, add cheese to taste, and plenty of seasoning.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As well as the following recipes there is one for Beignets Soufflés au Fromage in the milk and cheese chapter on "), _c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter25#page_655",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 655")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SAVOURY ÉCLAIRS OR CHOUX")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Prepare a choux paste with 150ml/¼ pint water, 50g/2 oz butter, 60g/2½ oz flour, seasoning, and 2 eggs (for method see "), _c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter28#page_732",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 732")]), _vm._v("). Lightly grease a baking-sheet and put the mixture on it in small teaspoons. Sprinkle with chopped almonds or grated cheese and bake until crisp, or you may mix savoury "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("ingredients in the paste:")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Choux paste as above, season with salt (no sugar), mix with a little chopped lean ham or, more delicious, smoked ham and shredded browned almonds, and fry in deep fat.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Or you may fill cooked choux paste:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bake the paste plain as choux, or pipe into little éclairs, split and fill with cheese cream or other savoury mixture. Or you may like to incorporate a little cheese with the mixture to give added interest.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In Edwardian days these savoury éclairs and choux were called carolines when shaped like éclairs, and duchesses when formed like choux à la crème; they were finished off, after being filled, by a coating of chaudfroid sauce or by a light brushing of aspic jelly just on the point of setting, and they were then sprinkled with finely chopped pistachios or other salted nuts. This finish is not often carried out to-day and is indeed a job for experts. The addition of sauce or aspic, of course, makes these savouries suitable for the dinner table rather than the cocktail party. Some of the fillings used for them, however, will serve our purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Chicken.")]), _vm._v(" Cold chicken, shredded and pounded in a mortar, mixed with an equal quantity of butter and seasoned with salt, freshly ground black pepper, a squeeze of lemon juice, and a few drops of tabasco. Finely chopped herbs, such as tarragon, chervil, and parsley, can be worked into the mixture to taste.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Ham.")]), _vm._v(" Lean ham, with a very little fat added, shredded and pounded with enough hot chutney to flavour, a drop or two of Worcestershire sauce, some French mustard, and an equal quantity of butter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Tongue,")]), _vm._v(" shredded and pounded with a tablespoon of Cumberland sauce, salt and pepper, a touch of made mustard, and an equal quantity of butter. Chopped orange or lemon rind added to taste.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Salmon.")]), _vm._v(" Fresh or smoked salmon, pounded and mixed with horseradish sauce, seasoned with salt, pepper, and lemon juice.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Sardine.")]), _vm._v(" Boned and skinned sardines pounded with lemon juice, plenty of freshly ground black pepper, a little salt, and a teaspoon or more of Worcestershire sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("N.B. Instead of butter, a small quantity of good béchamel or demi-glace sauce, according to the other elements chosen, may be used with these purées.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("In the following three fillings cream is given as a binding medium. This is classic, but in these days, when the general range of foods is much less rich, it is advisable to consider a good béchamel in its place. This produces a lighter and to some people a more agreeable texture.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Smoked salmon.")]), _vm._v(" Well pounded and mixed with 2 tablespoons of thick cream to every 110g/4 oz of salmon. Passed through a fine sieve, seasoned with lemon juice and freshly ground black pepper. If the mixture tastes too strong, a little more whipped cream may be added.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Tunny.")]), _vm._v(" Well pounded and mixed with the same proportion of thick cream or butter as the previous filling. Passed through a fine sieve and seasoned with black pepper, salt, and a little anchovy essence; garnished with chopped fennel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Chicken, ham, and tongue.")]), _vm._v(" Made according to the same proportions, seasoned and flavoured as for smoked salmon, passed through a fine sieve and mixed with a little extra whipped cream.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SAVOURY FRITTERS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Prepare a choux paste as described on 732. When well beaten, add to this 50g/2 oz finely shredded lean ham and 40g/1½ oz shredded browned almonds. Fry in hot fat in ½-teaspoons. When well risen and firm, drain on soft paper and serve at once.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("TOASTED SARDINE SANDWICH")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Skin, bone, and mash up a small tin of sardines and add 4 tablespoons good thick cream salad-dressing, coleslaw, or well-flavoured mayonnaise. Add ½ dessertspoon Worcestershire sauce, a dash of tabasco, ½ teaspoon finely chopped chives, 4–5 tablespoons finely chopped celery or cucumber, a tablespoon of finely chopped green peppers, ½ teaspoon lemon juice, salt and pepper. Mix this all together, beat it up, and spread it thickly between rounds of bread, then toast under a grill, turning carefully and toasting on each side; or the whole may be cooked in a frying-pan in butter.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("The grilled sardines mentioned in the section on after-dinner savouries (")]), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#page_27"
    }
  }, [_vm._v("page 27")]), _vm._v(") may be made in small size and are an excellent hot cocktail savoury.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SARDINE CANAPÉS")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("small croûtes or rounds of brown bread and butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("sardines")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("slices of hard-boiled egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("slices of lemon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chopped capers")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Bone and skin the sardines and lay one on each croûte, cover with a slice of egg and a slice of peeled lemon. Dust with chopped parsley and chopped capers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Here is a refreshing mixture for canapés:")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 cream cheese the size of a demi-sel")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 tablespoons thick cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("12 olives, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon green peppers, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon Worcestershire sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Beat together and put on croûtes or biscuits or ice wafers brushed with butter and crisped in the oven.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("ANCHOVY ROLLS")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("fillets of anchovy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("dry grated cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("thin white bread and butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("mustard and seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("melted butter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut the crusts off the bread and butter, spread each slice with mustard, sprinkle with seasoning and cheese, lay on a fillet of anchovy, and roll up. Set on a tin, sprinkle lightly with melted butter, and bake in a hot oven for 7 minutes to a golden brown. Serve very hot. These must be cut to an even size, and the slice should be medium-sized to small, so that each roll is not too ‘bready.’")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("ANCHOVY AIGRETTES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Prepare a French dressing with plenty of herbs, oil, and vinegar, chives and parsley. Marinade with this for as long as possible anchovy fillets, then drain, dip into fritter batter, and fry at once in deep fat. Or the fillets may be laid on thin pieces of short or puff pastry and turned over to form "), _c('i', [_vm._v("allumettes")]), _vm._v(". They are painted with beaten egg and baked.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("The following shell-fish canapés may serve either as cocktail savoury or first course for dinner according to their size. The recipes may be interchanged or used with other shell-fish. The difference between them is that the one given for crab is creamy and bland and that for lobster much more piquant.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("CRAB CANAPÉS")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 shallot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a scant 25g/1 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 tablespoons cream or creamy milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("fingers of toast or fried bread")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("paprika")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz crab meat")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon grated cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("watercress to garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Chop the shallot finely, make 15g/½ oz butter hot in a frying-pan, and cook the shallot gently until light brown. Add the flour, off the heat, and blend well. Pour in the cream or milk and bring to the boil, add the flaked crab and season well with salt, pepper, cayenne, and lemon juice. Stir until boiling-point is reached. Spread the fingers of toast or fried bread with the mixture, work the cheese and the rest of the butter together to a paste with a fork or a palette-knife, and add plenty of paprika to make the paste a good red colour. Spread a little of this paste on top of each. Put for a second or two under a hot grill, and garnish the dish with bunches of picked watercress.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("LOBSTER CANAPÉS (COLD)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("the meat from 1 small lobster,")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("or a small tin of lobster")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("French dressing")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 sprigs of parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 rasher of bacon, thinly cut")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("mayonnaise or boiled dressing")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 sticks of celery, finely chopped, or a good tablespoon chopped celeriac")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("6 chives")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("fingers of toast or fried bread")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("lettuce to garnish")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Break up the lobster meat into small pieces with two forks and marinade for an hour or more in well-seasoned French dressing, to which a pinch of sugar has been added. Add the finely chopped celery or celeriac, the chives cut small with kitchen scissors, and finely chopped parsley. Cut rind from bacon, grill until brown and crisp, and break in small pieces. Add these to the lobster mixture when cold, and mix with mayonnaise or dressing. Season with salt and freshly ground black pepper. Pile on fingers of fried bread or toast and garnish with small lettuce leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SHRIMP CANAPÉS (HOT OR COLD)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Simmer shrimps in a little butter with a pinch of curry-powder and a dash of cayenne. Arrange on croûtes and put a little chilli sauce on top.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("DEVILLED CROQUETTES OR KROMESKI (1)")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Cod’s roe or devilled crab shaped into small balls and sandwiched between two halves of a walnut, floured, egged and crumbed, and fried in deep fat. (See also ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#page_31"
    }
  }, [_vm._v("page 31")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("DEVILLED KROMESKI (2)")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("10–12 large prunes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chutney")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("fillets of anchovy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("bacon rashers")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("batter of 2 tablespoons flour, salt and pepper, and a piece of yeast the size of a pea")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Soak the prunes overnight and simmer until just tender in a little good stock. Remove the stones carefully. Stuff with the anchovy fillets and a good ½ teaspoon of chutney. Make a batter by dissolving the yeast in 2 or 3 tablespoons warm water, then beating in the flour with a little cold water to make a thick cream. Leave the batter for 15 minutes in a warm place before it is used. Roll the prunes in a piece of bacon, dip in the batter one by one, and then drop into smoking deep fat. Fry to a golden brown. Serve very hot in a napkin.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("DEVILLED CHESTNUTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These may be used as cocktail savouries or as a hot hors-d’œuvre. Take large chestnuts, scald them, and remove the outer peel and every bit of the inner skin without breaking the chestnuts. Stew gently in milk with a little salt, till they are soft enough to penetrate with a skewer without losing their shape. Roll each nut in oiled butter and then cheese mixed with a good sprinkling of pepper, salt, and cayenne. Roll in butter once more and then in fried breadcrumbs. Place on a dish in a fairly hot oven, pour a little oiled butter carefully over them, and leave them to brown, which takes a few minutes. Serve in little paper cases and sprinkle at the last minute with a little chopped chervil and a dust of cayenne. Serve very hot. This is one of the most popular of cocktail savouries.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CHESTNUT CROQUETTES")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("See ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter20#page_559",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 559")]), _vm._v(" in poultry chapter. These are excellent as a hot cocktail savoury and very popular.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MUSHROOM ROLLS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Take thin slices of streaky bacon, cut off the rind, flatten with a knife, and spread with a well-seasoned mushroom purée. Roll up, brush with beaten egg, dip in breadcrumbs or oatmeal, and fry in deep fat.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "h3-italic"
  }, [_vm._v("Purée")])]), _vm._v(" "), _c('div', {
    staticClass: "space1"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz shallots")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz mushrooms, washed, peeled, and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz white breadcrumbs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cook first four ingredients gently for 10 minutes. Add breadcrumbs and chopped parsley.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If mushroom rolls are to be served as a savoury course at the end of a meal, they may be accompanied by watercress tossed in sharp French dressing.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BACON ROLLS IN DROPPED SCONES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Roll a thin rasher of bacon, or part of one, round a pickled onion, and cook until the bacon is thoroughly done. Make small, thin, unsweetened drop scones and fold them round the roll, holding together with a wooden skewer.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Small, unsweetened drop scones, freshly made, may be filled in a variety of ways, or spread with savoury pastes, such as Gentleman’s Relish or good bloater paste, and served rolled up. They are excellent, if not economical, filled with pâté de foie gras.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("There is one particularly delicious cocktail savoury, Guacamole, which one serves in this country only when avocado pears can be bought inexpensively, which sometimes happens, particularly in the French market in London in the summer. For this the flesh of the avocado pear is beaten up with sour cream, onion juice, lemon juice, and seasoning, then well chilled and served with brown bread and butter on which it is spread, or with a dish of potato chips beside the bowl for dipping into the mixture. This is a particularly delicious and epicurean dish.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CUCUMBER AND TUNNY FISH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Peel a large cucumber, cut in half (not lengthwise), scoop out seeds. Fill with mashed tunny fish flavoured with mayonnaise, paprika, and Worcestershire sauce. Pack in well with a spoon handle. Leave several hours in the refrigerator. Cut in ½-inch slices. Serve on lettuce moistened with French dressing.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CUCUMBER FARCI")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Pieces of cucumber stuffed with a cream cheese or mushroom purée and set on rounds of brown bread and butter.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("STUFFED GRAPES")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Pip large grapes. Make a paper cornet (see ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#page_44"
    }
  }, [_vm._v("page 44")]), _vm._v("). With this fill each grape with a soft cheese cream, well seasoned with black pepper and salt. Allow the cheese cream to come well above the top and dip this into salted browned almonds. Serve on picks or in small paper cases.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("STUFFED PRUNES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Soak the prunes well overnight, then remove the stones. Finely chop together 3 shallots, a chicken liver, and 25g/1 oz fat bacon. Heat a nut of butter in a small sauté pan, add the onion, bacon, and liver, and simmer for about 5 minutes. Season well, adding plenty of finely chopped parsley and sage or savory. Bind together with the yolk of an egg and stuff into the prunes. These may be served hot.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SALTED AND DEVILLED NUTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Almonds and filberts are blanched, peanuts are slipped from their thin brown skins before salting. Walnuts when fresh must not have the skin left on as it is very bitter. The nuts are lightly fried in butter, then drained and tossed in salt sprinkled on kitchen paper; for devilled nuts, cayenne is added to the salt.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("COCKTAIL SAUSAGES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These are always popular and are interesting if they are treated as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cook chipolatas, make an incision lengthways, but do not quite cut through. Spread inside with French mustard and fill with cream cheese well flavoured with chutney or with devil sauce. Roll the edge in browned chopped almonds.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Tiny Vienna smoked sausages (bought in jars) may be wrapped in wafer-thin puff paste, baked, and served on picks, or one may take chipolatas, splitting them and encasing them in pastry in the same way. They are baked and served cut in short lengths, on picks.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("FILLED ROLLS")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("There is a whole range of filled rolls, minute, medium, or sizable, according to the occasion, which are good as long as they are not overdone. Assembled in one large dish they may, if you so wish, make a central feature of the table. The fillings for them are capable of great variation and are a matter for the imaginative. If one chooses tiny French or homemade rolls these are easily handled, but it must be acknowledged that savouries are lighter and less bready if one uses starch-less rolls bought in packets and called Energen. The trouble here is that even half of one of these is on the large side and they are inclined to crumble, and perhaps savouries made with these find a better place as a first course for luncheon or dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("From the rolls cut off a slice and hollow slightly; brush inside and out with flavoured butter, garlic-flavoured if you like. After brushing put them into a sharp oven until golden brown, and then they may be filled in a variety of ways: pieces of chicken in devil or curry sauce; crab with a sharp dressing of oil, vinegar, plenty of mustard, salt and pepper; devilled mushrooms, cheese, or anyone of a variety of fillings you may choose. The great point about these rolls is that they shall be very crisp and the filling well seasoned. They may of course be lavish or economical as your purse allows.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Another kind of filled roll is made by making tiny home-made croissants and filling them before they are baked – that is to say the roll and filling are baked together. The filling may be of ham, mushroom, devilled hard-boiled egg, or anything you may choose.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Here is a good devil sauce for binding together such things as hard-boiled eggs, diced chicken, mushrooms, etc., for filling rolls.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("DEVIL SAUCE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("4 tablespoons Harvey’s sauce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 level teaspoon made English mustard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 tablespoons tomato sauce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a good pinch of cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a dash of anchovy essence")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("brown sauce, béchamel, or")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("mayonnaise")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cook all ingredients but the last together to make a sauce of coating consistency which tastes both sweet and sharp. Add to this mixture 150ml/¼ pint of béchamel, or if to be served cold use a small quantity of mayonnaise sufficient to bind, or a thick brown sauce. Mix this with the hard-boiled egg or chicken, cut fairly coarsely, and put a dessertspoon of the mixture in each roll, putting back the top at an angle. The rolls may then be heated in a hot oven for 7-10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTATO STICKS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Potato sticks are excellent to eat by themselves or with cheese or salad, and they are liked by children as well as older people.")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz freshly cooked sieved potato")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt, pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("beaten egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("dill or caraway seed")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Work the potato, butter, and flour to a soft dough, with plenty of salt and pepper. Then leave for half an hour to chill. Roll out, brush with beaten egg, sprinkle well with dill seed, cut into sticks. Bake in a moderate oven 10-15 minutes.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("CHUTNEY BISCUITS")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Take thin water-biscuits or the ‘last-minute’ biscuits given on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter26#page_683",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 683")]), _vm._v(". Make a mixture of a little butter worked well with Worcestershire sauce, a teaspoon of sieved chutney, and a dash of paprika. Spread this mixture on the biscuits and bake in a quick oven for about 5 minutes. Serve very hot. With these may be served in a separate dish ice-cold mint and apple chutney which one spoons on to the biscuit. This contrast in temperatures is excellent.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The following biscuit has a covering of thin, highly seasoned jelly or aspic. It can be most refreshing in flavour and a good contrast in texture to other savouries, but the jelly must be really hotly seasoned.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BISCUITS WITH SAVOURY DEVILLED JELLY")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("150ml/¼ pint chilli, tomato, or A1 sauce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a dash of Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("small thin water-biscuits")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon powdered gelatine")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt, pepper, and cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("stoned olives stuffed with anchovy butter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Dissolve the gelatine in a tablespoon of water, and mix it with the bottled tomato, A1, or chilli sauce. Add a dash of Worcestershire sauce and season with salt, pepper, and a spot of cayenne. Pour on to a wet plate to set. When quite firm, cut in rounds with a pastry cutter, and put each round of jelly on a small round cheese biscuit. In the middle set a stoned olive stuffed with anchovy butter.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PIN-WHEELS OR ROULADES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These are made by taking small pieces of pastry left over from other bakings and rolling them out extremely thinly. The pastry is then spread with anchovy or bloater paste, or a highly seasoned paste such as Gentleman’s Relish, and rolled up like a small Swiss roll. This should be allowed to chill thoroughly and then be finely sliced, the slices being baked in the oven. This is a useful type of simple cocktail savoury for everyday use, for if the roll is wrapped in grease-proof paper and kept in the refrigerator it will keep for days and may be sliced and used as required.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BOUCHÉE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("puff pastry")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("lean ham")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("beaten egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("piquant sauce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("parsley")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Roll out the pastry, brush over with beaten egg, stamp out into rounds about the size of a five-shilling piece. To imitate the appearance of larger bouchées mark a well-defined circle with a smaller cutter in the centre (these little bouchées are split for filling instead of being filled like the larger ones). Bake in a hot oven till well risen and crisp. In the meantime, chop the ham, mix it well with the chopped parsley and enough piquant sauce to moisten well. Split the bouchées in two and fill well with the mixture. Serve hot or cold.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Small tartlet cases filled in various ways are attractive. Tunny-fish cream makes a good filling and the finish may be of a turned olive, or of a turned olive stuffed with pimento. Olives associate particularly well with tunny fish, now generally available, and are most suitable for cocktail savouries of many kinds.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There is no need to set out a list of fillings for bouchées as a choice may be made from those already suggested, chicken, hard-boiled eggs, lobster, mushroom, etc., bound together by a good béchamel.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("SAVOURY BUTTERS")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This seems a not entirely unsuitable place to mention savoury butters. These are of course used in many dishes in what R. H. calls ‘proper cooking,’ but as they are often useful for some of the foregoing kickshaws they may reasonably come in here.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MAÎTRE D’HÔTEL BUTTER")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon finely chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cream the butter well on a plate with a palette-knife, work in the lemon juice a few drops at a time with the parsley and seasoning. When all is thoroughly mixed, form into pats or spread out on a small plate and cut into squares when hard. Leave to harden well before using.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A pat is put on grilled sole, cutlets, tournedos, poached eggs, etc., immediately before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MONTPELLIER BUTTER")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 hard-boiled egg yolk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 or 3 leaves of spinach")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 sprigs of tarragon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 fillets of anchovy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a small handful of parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Boil the herbs together for 5 minutes, drain, press, and pass through a wire sieve or strainer. Pound or sieve the yolk with the anchovy, work into the butter, adding the herb purée by degrees; the butter should be quite green. Season rather well.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Use as a sandwich filling, or with eggs, fried fish, and as maître d’hôtel butter.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("ANCHOVY BUTTER")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("anchovy essence")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 fillets of anchovy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ clove of garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Work the butter on a plate with a palette-knife until creamy; pound the anchovies and add to the butter with the pepper and enough essence to colour a delicate pink and strengthen the flavour. Crush the garlic to a cream with a pinch of salt, and mix in thoroughly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For boiled, grilled, fried, or poached fish, and for adding to a béchamel or velouté sauce to form sauce aux anchois. In this case, omit the garlic and use finely ground white pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("ORANGE BUTTER")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("finely grated rind of 1 orange, preferably blood")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon paprika pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon or more orange juice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 slice of shallot well crushed with a pinch of salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cream the butter thoroughly and work in the other ingredients by degrees. Leave to harden and use as for maître d’hôtel, but principally for grilled sole. It is also good with stuffed chipolatas.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("GARLIC BUTTER")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Blanch 25g/1 oz garlic, pound in a mortar, work in 25g/1 oz butter and put through a fine sieve. Use for flavouring sauces, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CHIVRY OR RAVIGOTE BUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Pound in a mortar 75g/3 oz (altogether) of parsley, chervil, tarragon, and chives, blanched for a few minutes, refreshed, and squeezed. Pound also 1 shallot, chopped and blanched. Add 40g/1½ oz butter and put through a fine sieve.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SHRIMP BUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Pound peeled shrimps in a mortar to a paste. Add an equal quantity of butter, season with a squeeze of lemon juice, and pass through a fine sieve.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TARRAGON BUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Blanch 25g/1 oz tarragon leaves for 2 minutes, drain, refresh, and squeeze. Pound them with 50g/2 oz butter and pass through a fine sieve.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MUSTARD BUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Add 1½ tablespoons French mustard to 110g/4 oz softened butter, work together, and keep in a cool place. For fish, grilled ham, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PAPRIKA BUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Soften in butter a tablespoon of finely chopped onion. Add a dessertspoon of paprika, work into 50g/2 oz butter, and pass through a fine sieve.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PIMENTO BUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Pound 1 red pimento, tinned, cut in small pieces, with 75g/3 oz butter, salt, pepper, and cayenne, 1 tablespoon thick cream, and a squeeze of lemon juice. Pass through a fine sieve.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BEURRE À L’INDIENNE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Pound a good tablespoon of mango chutney with a teaspoon of curry-powder, add a teaspoon of made mustard, 75g/3 oz butter, a squeeze of lemon juice, salt, pepper, and a spot of cayenne. Add a few drops of Worcestershire sauce and spread on the bread or toast used for chicken sandwiches.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("LOBSTER BUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Pound together equal parts of the coral from a cooked lobster and butter. Season and press through a nylon sieve. Sometimes a recipe calls for lobster butter made from uncooked coral; the method is the same.")])]), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("FRUIT COCKTAILS")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The selection and mixing of cocktails is outside the proper scope of this book; there are other more suitable sources of information. It is a good plan to have one short drink that is non-alcoholic and the most generally popular is tomato juice. Recipes for making this follow. Often a tin of a good brand of tomato juice is used and seasoning and lemon juice added to this.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TOMATO JUICE COCKTAIL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Simmer 12 tomatoes in ½ cup water with a sliced onion, a small stick of celery (or celery salt), ½ bay-leaf, 3 sprigs of parsley, and 4 sprays of basil. Strain and season with salt, paprika, a little sugar, a dash of Worcestershire sauce (optional), and a squeeze of lemon juice. Chill well.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TOMATO COCKTAIL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("To 600ml/1 pint good strong tomato juice, made from ripe tomatoes, add the pared rind and juice of half a lemon, a teaspoon of mint-flavoured vinegar, a teaspoon of Worcestershire sauce, sugar, salt, and freshly ground pepper to taste, and a grating of nutmeg. Chill for an hour or two in the refrigerator before removing the lemon rind.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("ORANGE AND TOMATO COCKTAIL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Bruise 3 or 4 sprigs of pineapple mint, put into a jug and pour over them 600ml/1 pint good tomato juice, add 225ml/8 fl oz freshly strained orange juice, a good pinch of salt, and sugar to taste. Chill thoroughly and allow to infuse for at least an hour before straining.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Other recipes for fruit cocktails will be found on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter37#page_1027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 1027")]), _vm._v("-"), _c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter37#page_1028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1028")]), _vm._v(".")])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter02"
    }
  }, [_c('p', {
    staticClass: "ch-num"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("II")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "ch-title1"
  }, [_vm._v("Hors‐d’Oeuvre, First‐course Dishes, and After‐dinner Savouries")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The preparation and selection of mixed hors-d’oeuvre as a first course is an interesting affair and calls for discrimination. Such a course may be stimulating to the palate and delicious, but it may also be dull as ditchwater, too acid or "), _c('i', [_vm._v("fade")]), _vm._v(", and indigestibly heavy. In some hotels and restaurants it can also be unimaginative and boringly repetitive. A good selection of hors-d’œuvre, which by the way need not be many in number, should present a reasonable contrast in texture and should have sharp dishes offset by bland ones. The oiliness of such fish as sardines, anchovies, and herrings needs a sharp accompaniment. Fruit has come to play a much bigger part in the selection of hors-d’œuvre than was once the case, and a wide variety of vegetables is now included. With experience the selection becomes a simple matter.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The most usual way of serving hors-d’œuvre is of course to put a selection of them in small dishes, assembled together on one large dish or tray, but some of the choicer of them may be arranged with more imagination. For instance, a melon hors-d’oeuvre may be served in the scooped-out half of a small melon, or a salad of finely shredded cabbage, apple, and celery looks well served in a hollowed-out heart of a good firm cabbage. In serving just as with choosing and preparing hors-d’œuvre there is scope for imagination. One point should be made and emphasized: there is nearly always a certain amount left over from an hors-d’œuvre course, and some of these dishes will keep perfectly well for a few days, while others, particularly those containing potato and other vegetables, will in hot weather be inclined to ferment. The early stages of fermentation are not entirely easy to detect, and care should therefore be taken that hors-d’œuvre are served fresh.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("MIXED HORS-D’ŒUVRE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Although a selection of recipes follow it should be remembered that there is an infinite variety of ways in which these may be presented. The bland or sharp quality of a dish may be controlled by the dressing chosen and varied greatly by flavourings. French dressing may be softened by the addition of cream or mayonnaise and well flavoured with French and English mustard. The yolk of an egg is an excellent addition and holds oil and vinegar in an emulsified condition.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In addition to the dishes made in the kitchen it is customary to serve such items as filleted anchovies, sardines, smoked herrings and so forth. One may of course use fillets of home-soused herring, and a recipe for good herring salad is given.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("MARINADED ONIONS")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Take large mild onions and slice thinly. Make a brine with a tablespoon of salt to 150ml/¼ pint of water. Soak the onion rings in this for an hour or so, then drain well. Soak for another hour in a mixture of vinegar and cider or, if you prefer it, vinegar only, then drain the onions and chill well. Arrange on a dish, sprinkle with freshly grated pepper. These are a good accompaniment to a fish hors-d’œuvre.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SWEDISH CUCUMBER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Peel a cucumber and slice thinly. Salt well and leave for half an hour; drain and cover with a French dressing, sprinkle with dill seeds or freshly chopped dill.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MASHED POTATO SALAD")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("to be served hot or cold")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Boil some potatoes and mash in the proper way, through a fine wire sieve on to a cloth, beat up with cream and vinegar: mix in chopped chives or the green top of an onion, some capers or gherkin. Chopped or sieved cooked beetroot may be added to the potato.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MARINADED MUSHROOMS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Peel and trim 450g/1 lb small mushrooms, simmer 5 minutes in just enough salted water to cover, add the juice of a lemon. Cook together for 5 minutes 1 cup vinegar, ½ clove of crushed garlic, 1 bay-leaf, thyme, a pinch of salt, a pinch of ground pepper, and 2 shallots, sliced finely. Cool, remove the garlic, add 3 or 4 tablespoons olive oil and 1 tablespoon tomato ketchup. Drain the mushrooms, marinade in the above mixture, and keep in the ice-box for several hours. Arrange in a dish and sprinkle with chopped chervil, strain a little of the dressing over them.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("STUFFED BRUSSELS SPROUTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Choose large firm sprouts and cook them very gently without allowing them to break. Scoop out the centres, put in a few drops of French dressing, fill with the following mixture: a little well-seasoned mashed hard-boiled egg, pounded, chopped chives, and chopped pickles, bound together with a little cream or good sauce. The sprouts may be served cold, or dipped in batter and fried.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TOMATO AND ORANGE SALAD")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Take the smallest possible tomatoes, peel and quarter, season, and use with an equal quantity of orange quarters from which skin and pith have been removed, i.e. use the flesh only. Serve with a delicate dressing and with brown bread and butter.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CURRIED POTATO SALAD")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Take small new potatoes, boil, and while hot dress with a good French dressing, allow to cool, and cover with a light mayonnaise or cream dressing, well flavoured with curry.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BEETROOT")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Beetroot as an hors-d’œuvre is sometimes served in a very harsh way, that is to say cut into cubes and served with a sharp dressing. The delicate and melting beetroot salad mentioned on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter12#page_294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 294")]), _vm._v(" is suitable, and even more so are the whole small filled beetroots given on "), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter12#page_295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 295")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("SOUSED HERRING SALAD")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Souse the herrings in the way described on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter16#page_440",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 440")]), _vm._v(". Lift off and arrange fillets in a dish; place round them chopped salted cucumber and a little grated onion. Sprinkle with chopped dill or fennel.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SPRING ONION AND SWEET CORN SALAD")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Take sweet corn, well flavoured with lemon juice and seasoned with salt and pepper. Add cream and finely chopped spring onion. Garnish the dish with spring onions and slices of pimento.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("COLESLAW")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Very finely shredded heart of cabbage as given in the recipe on "), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter12#page_290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 290")]), _vm._v(" (Coleslaw Salad) is dressed with cream dressing and may well be served in a scooped-out heart of cabbage. Suitable additions to it are shredded or sliced dessert apple, celery or celeriac, nuts, and orange. The dressing should be plentiful and the cabbage really shaved rather than shredded.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Aubergines Robert as given on "), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#page_24"
    }
  }, [_vm._v("page 24")]), _vm._v(" is another good hors-d’œuvre, and some of the salads in the salad chapter may be adapted.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("FRUIT HORS-D’ŒUVRE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Hors-d’œuvre of fresh fruits are among the most delicious, and are generally so good that one serves them as a first course alone rather than among a selection of mixed items; and it is in the next section of this chapter that detailed reference to them will be found. Nevertheless a dish of celery and orange or celery and shredded pineapple may suitably find its place in mixed hors-d’œuvre, as may apple, nut, and celery and sliced ripe pears and orange.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("SOME DISHES OF THE HORS-D’ŒUVRE TYPE")]), _vm._v(" "), _c('p', {
    staticClass: "h4a"
  }, [_vm._v("suitable for serving as the single dish for a first course of a luncheon or a dinner")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I suppose the most popular of first dishes in restaurants might be considered to be caviar, smoked salmon, and smoked trout, and although they are accepted luxuries and probably more often eaten out than at home, it is as well to know how to serve them.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CAVIAR")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("There are two principal kinds of caviar, the black or grey and the red. The former is more widely known in this country and is by far the more expensive; it should be eaten well chilled with hot toast, fresh butter, and quarters of lemon. It is often served in a deep dish of crushed ice; the fresh toast is handed separately, and sometimes a small dish of finely chopped onion and roughly ground black pepper. The red caviar, the flavour of which does not compare with that of the black, is naturally the less expensive, and it is well suited to the making of cocktail savouries. It may be served on rounds of toast or in small pastry boats. Properly, of course, caviar should be served with blinis, small buckwheat pancakes made with yeast.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "h3-italic"
  }, [_vm._v("Blinis")])]), _vm._v(" "), _c('div', {
    staticClass: "space1"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("between 10g/¼ oz and 15g/½ oz yeast")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz buckwheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a warm mixture of milk and water")])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("225g/8 oz white flour")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("2 small eggs or 1 large")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("level teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("milk or milk and water")])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cream yeast and sugar together. Add to the buckwheat with enough milk and water to make a thick cream. Put to rise in a warm place for 20 minutes. Meanwhile make a thick batter with the white flour, egg yolks, melted butter, salt, and milk. Combine the two mixtures, and allow to rise in room temperature for 2 hours. Whip whites to a firm snow and fold into the mixture. Heat a small pancake or omelette pan, drop in a nut of butter, add a good spoonful of the mixture. Cook as for pancakes. Spread with butter and/or sour cream and stack one on top of the other. Serve hot with caviar.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Smoked salmon.")]), _vm._v(" I once knew a young cook who, owing to the war, had not met with smoked salmon. She boiled it, with horrible results.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Smoked salmon is bought ready sliced from a good delicatessen store or fishmonger. It should be moist because dryness may indicate saltiness; allow about 40-50g/1½-2 oz per person according to how lavish you wish to be. The very thin slices are served directly on individual plates and accompanied by quartered lemon and brown bread and butter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Smoked eel")]), _vm._v(" is extremely good although rather rich, and it should not be eaten in large quantities. It may be bought from a good delicatessen shop, and it is prepared by skinning and detaching the fillets. It is served with quarters of lemon or, in some cases, with a sharp vinaigrette sauce, and brown bread and butter should accompany it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Smoked cod’s roe")]), _vm._v(" is becoming more popular, as indeed is smoked eel. It is served just as it comes from the delicatessen shop, the halves being slit lengthways and cut across into two or three pieces. It should be served on individual plates, one or two pieces per person being laid on a crisp lettuce leaf. It may be accompanied by quarters of lemon and fresh toast or brown bread and butter. Cod’s roe can also be bought in small jars; in this form it is less wasteful for use as savouries and sandwiches.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Gulls’eggs")]), _vm._v(" are an admirable and popular first course for luncheon; they may be served in a strawberry punnet lined with moss or in a nest made of moss. They are bought from the fishmonger already boiled and should be served with powdered rock-salt, mixed with paprika, and brown bread and butter. Allow as a minimum two per person.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Smoked trout")]), _vm._v(" is also bought ready prepared and is good served with quarters of lemon or a delicate horse-radish sauce, well seasoned with mustard, salt, pepper, and lemon juice, piled up in a scooped-out cup of cucumber. To serve it is usual to remove the head of the trout, peel off the skin, and gently lift out the backbone. Serve with brown bread and butter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Dublin Bay prawns")]), _vm._v(" are another popular course. These are usually bought ready cooked. Allow five or six per person, according to size, and slit down the underside with scissors to loosen the shells, so making them easier to handle at table. Heap them in a large dish and serve with a good sharp sauce. Alabama sauce is excellent for this. Serve also quarters of lemon and brown bread and butter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following two pâtés are good and suitable for serving as a first course:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CHICKEN LIVER PÂTÉ")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 medium-sized onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz chickens’ livers")])])]), _c('div', {
    staticClass: "space"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("parsley, bay-leaf, and a few sprigs of thyme or savory")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a dessertspoon brandy")])])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Chop the onion, crush the garlic, and soften in 25g/1 oz of the butter, add the chickens’ livers and sauté for 2 or 3 minutes. Sprinkle with the chopped herbs and seasoning, cook again for about a minute, cool, chop, and then pound well. Stir in the remaining butter melted and a dessertspoon of brandy. Pack into a mould, chill, then turn out and serve with fresh toast, and butter separately.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("LIVER PÂTÉ")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("350g/12 oz liver")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz fat bacon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 fillets of anchovy or 1 teaspoon anchovy essence")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3–4 thin rashers of streaky bacon and a good pinch of salt")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "h3-italic"
  }, [_vm._v("Béchamel sauce")])]), _vm._v(" "), _c('div', {
    staticClass: "space1"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 slice of onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1–2 blades of mace")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 bay-leaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3-4 peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("300ml/½ pint milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("20g/¾ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Infuse the onion, spices, and bay-leaf in the milk until it is well flavoured. Make a roux of the butter and flour. Add the strained milk, and stir over a moderate fire until boiling. Season well and turn into a bowl to cool.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mince the liver and bacon twice, pound the anchovies, garlic, and salt, add to the liver with the sauce, beat well, adjusting the seasoning. Line a terrine or bowl with the bacon rashers, fill with the mixture and set in a tin of hot water, cover with buttered paper and bake in a slow oven for 40–50 minutes. Press lightly and allow to cool. Serve when completely cold with hot toast and fresh butter. Run a little clarified butter over the top if not for immediate use.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("GOOSE PÂTÉ")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("See Winkfield chapter, ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31#page_850",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 850")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("SOME FIRST COURSES OF VEGETABLES")]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_vm._v("STUFFED RED PIMENTOS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These pimentos are bought in tins and have a delicate flavour. Take some well-boiled cold rice, mix with a spoonful or so of thick cream, finely chopped chives, and capers. Season with lemon juice, black pepper, and salt. Satisfy yourself that the rice itself is sufficiently piquant and well flavoured, then fill the pimentos. Serve with French dressing mixed with a little cream and chill well.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MUSHROOMS IN ROLLS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Take either light French rolls or the starchless Energen rolls. Cut a slice off the top, hollow out, brush inside with flavoured butter, and put in the oven till crisp. Fill with mushroom filling:")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("1 clove of garlic crushed with a little salt")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 good 25g/1 oz. butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb mushrooms, peeled, washed, and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 dessertspoon flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225ml/8 fl oz cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon finely chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("lemon juice")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Melt the butter, stir in the garlic, add the mushrooms, and cook gently. Stir in the flour and cook for a few minutes, then add the cream, parsley, seasoning, and lemon juice.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("FILLED ROLLS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Take light French rolls or starchless Energen rolls as before. Cut a slice off the top, hollow French rolls completely, Energen rolls slightly. Brush inside and out with flavoured butter and put in a hot oven till crisp. Fill with sautéd mushrooms well seasoned, with a squeeze of lemon juice added, or with a whole cooked tomato, sprinkled with a little onion juice, pepper, and salt.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("STUFFED TOMATOES (1) (TOMATES FARCIES PROVENÇALES)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Allow 1 tomato for each person.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "h3-italic"
  }, [_vm._v("Filling (for 4 tomatoes)")])]), _vm._v(" "), _c('div', {
    staticClass: "space1"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 clove of garlic, crushed")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ cup breadcrumbs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and freshly ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 anchovy fillets soaked in milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a level teaspoon each of chopped parsley, tarragon, and marjoram")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut the tops off the tomatoes and put them aside. Scoop the insides of the tomatoes into a basin. Make the butter hot in a frying-pan and cook the chopped onion and garlic over gentle heat until quite soft, but do not let them colour. The cooking should take about 15 minutes. Add the scooped-out flesh of the tomatoes and cook until quite soft. Add the breadcrumbs, season well, mash the anchovy fillets with a fork and stir them into the mixture together with the herbs. Fill the tomatoes and put on their tops. Put them into a moderate oven for 20–30 minutes and serve hot.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("STUFFED TOMATOES (2)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Fillings for tomatoes are numerous – far too many to give in detail here.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pineapple, apple, shredded ham, shredded chicken, cheese, olives, or whatever you may have or like may be mixed together, bound with a suitable sauce, and used as a filling. Only be sure that everything is really well seasoned and fairly sharp, or the dish will be dull.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Filling I")]), _vm._v(" Slice the tops off the tomatoes, scoop out seeds, and drain. Fill with a mixture of finely chopped cucumber, chopped celery, walnuts, and a little pickled onion. Toss the filling in either a French or cream dressing to which you have added a drop of Worcestershire sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Filling II")]), _vm._v(" Make a mixture with some finely chopped fresh or tinned pineapple, finely chopped celery, and chopped cocktail onion or gherkin. Add a little rice, a little whipped cream, and enough cream dressing or mayonnaise to sharpen.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Filling III")]), _vm._v(" Finely diced cucumber, chopped mint, and French dressing.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Filling IV")]), _vm._v(" Diced potato, bound with mayonnaise and flavoured with horse-radish.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("MARINADED MUSHROOMS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut mushrooms in quarters and sauté quickly in butter. Add 5 tablespoons burgundy or claret with salt and freshly ground pepper. Cook rapidly until completely reduced. Marinade in a vinaigrette dressing for a few hours before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("AUBERGINES (AUBERGINES ROBERT)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Slice the aubergines thinly, soak for an hour or two in olive oil, then grill them. Lay them in a dish, sprinkle well with chopped chives and a good French dressing, put in the oven for a minute, take them out, allow to get cold, and chill thoroughly.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("See also Aubergines Caviar in Winkfield chapter, ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31#page_850",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 850")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("FRUIT FIRST COURSES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Besides the ubiquitous grape-fruit with a glacé cherry in the middle there are many fruits suitable as hors-d’oeuvre. If grape-fruit is to be served it should be well and truly prepared, and the sections should be cut in the way described on "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#page_39"
    }
  }, [_vm._v("page 39")]), _vm._v(". It may be served plain or with a little kirsch and sugar, or you may use the skin-free sections with orange or pineapple to make a coupe. If you wish to be particularly elegant and they are in season, you may take those tiny oranges called cumquats, chop them, skin and all, and mix them with the grape-fruit sections. Ripe plums, ripe dessert pears, peaches, or nectarines, peeled and dressed with one of the dressings given below (under Melon 1 and Melon 2) or the delicate dressing for fresh fruit given on "), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter12#page_316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 316")]), _vm._v(" – all are excellent. Ripe pomegranates make one of the nicest hors-d’œuvre. The seeds of the pomegranate must be carefully extracted from the skin and every fraction of the yellow bitter membrane taken away. A well-seasoned, well-flavoured French dressing, softened with a little cream, may be poured over the fruit and the whole chilled.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But the thought of fruit hors-d’œuvre takes me back in memory to the refreshment of eye and palate provided by those at the Embassy Club. Not only were they prepared by an artist, but they were arranged by one of real imagination, so when, in 1934, Herbert Jenkins Ltd published "), _c('i', [_vm._v("150 Hors-d’œuvre Recipes")]), _vm._v(", by ‘Pin’ Baglioni, many people were delighted to be let into Mr Baglioni’s secrets.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Remembering this, when I got to this chapter I wrote to find out if the book was still in print. Alas! It is not, so one’s only hope of having all the recipes is to search among the books of second-hand dealers or to advertise. I then wrote to Mr Baglioni himself and obtained leave to publish some of his recipes. Among the six chosen there is a preponderance of those made with fruit, because among so many first-rate hors-d’œuvre these were memorably good.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The following six recipes are from "), _c('i', [_vm._v("150 Hors d’oeuvre Recipes")]), _vm._v(", by ‘Pin’ Baglioni.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MELON (‘PIN’ SPECIAL) (1)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut a honey-dew melon in basket shape. This is easily performed by cutting each side right across to about half an inch from centre. Make two perpendicular cuts downwards to meet previous incisions – this forms the handle of a basket. Extract all pips and scoop out flesh. Cut same in inch squares and soak in vinegar for 15 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Make a dressing: 1 dessertspoonful curry-powder, 2 tablespoonfuls vinegar, the juice of half a lemon. Mix well together. Squeeze this preparation through a muslin into a cupful of slightly whipped cream and add sugar to taste.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Place melon in basket after draining vinegar and pour dressing over.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("(If one finds the making of the basket too difficult use an ordinary dish or glass bowl.)")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MELON (‘PIN’ SPECIAL) (2)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut cantaloupe melon in half, extract pips and scoop out flesh, dice and replace in melon.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Make a sauce: 1 dessertspoonful curry-powder, 1 teaspoonful ginger, 1 small glass of port, 1 dessertspoonful kirsch. Stir well and pass through muslin. Add 4 tablespoonfuls whipped cream, 1 tablespoonful apricot purée, sugar to taste; mix well and pour over melon.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POMEGRANATE (‘PIN’ SPECIAL)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut a slice off stalk end, extract all pips and separate them. Mix them with 2 diced gherkins.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Make a dressing: 2 yolks of hard-boiled eggs crushed with knife blade, 1 dessertspoonful red-currant jelly, 2 teaspoonfuls French mustard, 3 tablespoonfuls vinegar, a suspicion of Worcestershire sauce. Stir well and mix dressing with first preparation.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fill pomegranate with mixture.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("HAM AND PINEAPPLE (‘PIN’ SPECIAL)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Shred: 2 slices of York ham, 2 pickled walnuts, 1 slice of pineapple.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mix well together.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Make a dressing: 2 tablespoonfuls whipped cream, 1 dessertspoonful tomato ketchup, the squeeze of quarter of a lemon.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Season with cayenne pepper, stir well and mix with salad.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Place in dish over crisp Romaine salad leaves. Serve very cold.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("GRAPE-FRUIT (‘PIN’ SPECIAL)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut grape-fruit in basket shape. Extract interior and squeeze out all its juice, use same mixed with 1 dessertspoonful fresh cream, add sugar to taste.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Take some tinned sweet corn, add equal quantity of chopped celery and apple (enough of the three to fill grape-fruit).")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mix this well with the prepared grape-fruit juice and cream and fill basket.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("VEGETABLE SALAD (‘PIN’ SPECIAL)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Take 4 peeled raw tomatoes cut in quarters and 2 peeled oranges cut in sections, add 2 sliced pickled walnuts, season with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Make a dressing: 2 tablespoonfuls walnut juice, add 1 dessertspoonful olive oil, 1 teaspoonful French mustard. Stir well and mix with salad.")])]), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("FIRST COURSES FOR A SUMMER DINNER")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Melon prepared in a variety of ways makes one of the most popular first courses, and the two recipes of Mr Baglioni mentioned above are admirable.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It has long been a fashion to hand powdered ginger with melon, but I would say that if you choose to eat ginger with your melon, do be careful that every bit of it is well moistened before you put the melon into your mouth. People have had embarrassing choking attacks through a speck of dry ginger catching in the throat. Quarters of lemon are a pleasant accompaniment to a well-chilled melon. There are, however, more exciting ways of dealing with this fruit as a first course than this. In particular, if you are fortunate enough to have small hothouse melons, allow half for each person, and serve with quartered limes. Hand sugar and a pepper-mill: freshly ground black pepper brings out the flavour of the melon just as it does with strawberries. Larger melons may be treated in a variety of ways: the cubes may be served in some cases in the shell of the melon itself, and in others in glass cups, or they may be handed in a glass dish with suitably flavoured cream dressings. As well as those given by Mr Baglioni we like one in which the flavour of fresh tarragon predominates.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Thick slices of honey-dew melon, with the centre cut out, may be the receptacle for a mint ice, which is one of the nicest courses for a hot night. The recipe for Mint Ice is given on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31#page_856",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 856")]), _vm._v(", and you may serve with this also, if you like, a half-slice of lime, sprinkling the juice over the circle of melon.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Another recipe. Cut a melon in half, removing the seeds, scoop out the flesh, and either cut it in dice or use a ball cutter. Put the pieces of melon into a bowl, add delicate fresh fruits such as raspberries, strawberries, peaches, or nectarines cut up into suitable pieces. Dress with sugar and a liqueur, Cointreau or sherry and a dash of maraschino. Chill this mixture well, and replace it in the half of the melon. Equally well, you may cut up your melon, dress it with a plain French dressing, and serve it with brown bread and butter. Melon and orange salad is excellent treated in the same way. When the small, inexpensive pineapples begin to come into the market, there is an excellent starting course to be made with these. Allow one small pineapple for every two people, cut in two, and scoop out the flesh, removing the hard and pithy centre. Mix the flesh with a little orange or any other fruit-raspberries, sliced strawberries, or whatever you may have at hand. Return to the halves of pineapple, which have been trimmed so that they will stand. Dress with either a delicate cream or a French dressing and a little lemon juice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Into our summer markets now come, more plentifully, avocado pears – delicious things if properly dressed. In the countries where they grow I believe the ripe flesh is of so nutty and delicious a flavour that only a sprinkling of salt and perhaps a touch of fresh lime is called for. In this country they seem to need a more decisive accompaniment, and perhaps the simplest and nicest way of serving them is to cut them in two without removing the peel and lifting out the central nut and filling the hollow with a sharp French dressing. Brown bread and butter may accompany them. The pears should be served ice-cold. Another method is to scoop out the flesh, crush it, then dress it with a salad-dressing and replace it in the pear. Some people like these pears dressed with rum and powdered sugar. Allow half a pear for each person unless the fruit is very small. Some books suggest mayonnaise as a dressing, but the smooth texture, with that of the pear, can be unpleasing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the Winkfield chapter will be found a good first course of melon, cucumber, tomatoes, and avocado pears ("), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31#page_853",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 853")]), _vm._v(") and another of fresh pears and cream cheese ("), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31#page_853",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 853")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SHELL-FISH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A recipe for potting shrimps at home is given on "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter16#page_431",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 431")]), _vm._v(". These may be served with fresh hot toast, with butter served separately, and freshly ground pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("In place of potted shrimps one may use nowadays the Norwegian frozen prawns which have been introduced into this country. They are excellent. A pound packet for ten shillings was bought as an experiment and found to be extremely sweet, and smelling of the sea, and these were potted and made enough to serve between sixteen and twenty people at a party. The prawns, already cooked, merely need to be heated through in butter which is seasoned with a pinch of paprika, ground mace, and a little freshly ground black pepper. They are then packed into jars and a little butter added to that in the pan, which is poured over them to seal them off. These are admirable for fillings for bouchées or as a first course with fresh toast.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("SHELL-FISH COCKTAIL (1)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Break up the meat of prawns, crabs, or lobsters. Prepare a good French dressing well seasoned with English and French mustard, and well-crushed garlic. Put the flaked fish to marinade in this for an hour or so, then drain the fish and mix it lightly in the following sauce: a teacup of cream dressing or mayonnaise, mixed with a tablespoon of A1 or other piquant sauce or tomato ketchup, and a good tablespoon of grated horseradish. Finally, fold in a cup of chopped celery, and serve in glasses or on glass plates, garnished with watercress, and accompanied by hot fresh rolls or brown bread and butter.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("A RATHER RICH SHELL-FISH COCKTAIL (2)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("To 3-4 tablespoons mayonnaise or cream dressing add 2 tablespoons good tomato ketchup and a dash of Worcestershire sauce. Season well with salt and pepper, then add cream to taste and a dash of lemon juice. When you are satisfied with the seasoning and sharpness of your sauce, put it to chill while you prepare the fish. Flake up lobster meat, crab, or Dublin Bay prawns, fold these into the cream mixture and put into glasses. Serve with brown bread and butter and quarters of lemon.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("For other dishes suitable for first courses see ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31#page_847",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 847")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31#page_856",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("856")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("AFTER-DINNER SAVOURIES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This course, which used inevitably to follow the sweet course in my young days, sometimes now takes the place of this, particularly for those whose taste lies in a savoury direction.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The savouries should be fresh, very hot, if to be hot, and well seasoned. Many after-dinner savouries resemble cocktail savouries and sometimes they resemble hors-d’œuvre, but they are more substantial in size. Sardines on toast, toasted cheese, cheese-straws, angels on horseback, devils on horseback, were, and still are, popular, though they more often find their place in an English menu than a French one.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SOFT ROES ON TOAST")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Work together ½ teaspoon English mustard, a saltspoon of salt, and a large knob of butter. Melt this, lay in it the soft herring roes, and cook gently for 5–10 minutes, according to size. Have ready hot buttered toast, and when the roes are ready lay them on this and serve piping hot.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("DEVILLED SOFT ROES")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("25-40g/1-1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz soft roes lightly rolled in a little seasoned flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt, pepper, cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("hot buttered toast")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Heat pan, drop in butter, and when this foams, put in floured roes. Dust with a little of the seasoning. When brown on one side turn and brown on the other, sprinkle again with seasoning. Squeeze lemon juice over the roes; arrange on toast and serve at once.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("HERRINGS ON TOAST")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Clean, bone, and fillet the herrings. Butter a frying-pan, lay in the fillets, cover with buttered paper, and cook gently. Toast slices of bread, remove the crust, spread with butter with which is mixed a little mustard and pepper. Lay the fillets on top of the toast and sprinkle with freshly ground pepper. Serve very hot.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SARDINES ON TOAST")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Instead of the usual sardines on toast, try the following:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Make the toast, cut in suitable pieces. Make a paste as follows: Skin and bone 6-8 sardines, add a teaspoon of scraped onion, a teaspoon of French mustard, 3 teaspoons butter, a teaspoon of vinegar, and a pinch of salt. Spread this mixture on the toast, then lay a boned and skinned whole sardine on top of it. Finish off under the grill, and add a sprinkling of finely chopped fennel and some freshly ground black pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("FINNAN-HADDOCK")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Flaked finnan-haddock, mixed with a little butter or cream, highly seasoned, put on buttered toast, and finished off in the same way as the sardines is excellent.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Or it may be pounded, very well seasoned, bound together with butter and a beaten egg, shaped into tiny cakes, rolled in egg and breadcrumbs, and fried in deep fat. A good accompaniment to these is fried parsley. Aberdeen smokies are a greater delicacy than the ordinary finnan-haddock, and these should be flaked, mixed with butter, seasoned with black pepper, and served on hot buttered toast, with a knob of butter put on top at the last minute.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CHEESE SAVOURIES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Some of the best of these are made with Camembert. On a hot night iced Camembert, served on a bed of crushed ice and accompanied by water-biscuits which have been heated up in the oven, is delicious; but even better perhaps are pieces of Camembert, taken not too ripe, sieved, mixed with butter, reshaped, dipped in egg and breadcrumbs, and fried in deep fat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("These Camembert Croquettes are one of the best of all savouries:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CAMEMBERT CROQUETTES")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 medium ripe Camembert")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("300ml/½ pint milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt, pepper, cayenne or dash of tabasco sauce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 egg yolk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("beaten egg, dry white breadcrumbs and deep fat for frying")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("grated Parmesan cheese")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Scrape rind from the cheese; press through a wire sieve. Melt butter, add flour, then milk; stir until boiling, season well, and allow to cool. Work in the Camembert and lastly the yolk. Turn on to a plate and when absolutely cold shape into pieces the size of a walnut on a floured board. Dip into or brush ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("with beaten egg and roll in the crumbs. Fry in deep fat until golden brown. Serve very hot, dusted with grated Parmesan cheese.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("CAMEMBERT EN SURPRISE (ICED CAMEMBERT)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 medium ripe Camembert")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz creamed butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 tablespoons dry white breadcrumbs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 tablespoons (or ¾ wine glass) dry white wine")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1-2 tablespoons cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt, pepper, and cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("paprika")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("watercress, etc., for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("pretzels or small salted water-biscuits")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Scrape most of the rind from the cheese and press through a sieve. Work into the butter, adding the wine by degrees, and the crumbs. Moisten with enough cream to make the mixture the consistency of a cake batter. Season highly. Turn into a lightly oiled mould, or flan ring, smooth the top, and chill in a refrigerator or on ice till firm. Turn out and coat all over with the Parmesan cheese, mixed with a little paprika. Mark the top with the back of a knife.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Set on a serving plate and surround with the biscuits. Garnish with ‘bouquets’ of watercress and, if liked, radishes cut into rosettes and black olives.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This can be made into quite a decorative dish for a lunch.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("LADY MACDONALD’S CHEESE BISCUITS")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz grated cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("yolks of 2 eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix the above together. Stir over a gentle heat until it thickens. Have ready plain ice wafer biscuits crisped in the oven. Put a layer of the cheese mixture between them and serve at once.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TOASTED CHEESE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz grated cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("beer or cider")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix to a paste, season well with made mustard and freshly ground pepper. Spread on to buttered toast and grill to a golden brown.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("HAM CORNUCOPIAS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Roll strips of good short crust round small cornet moulds, brush lightly with beaten egg, and bake to a golden brown in a hot oven. When cool fill with creamed ham, well seasoned, and sprinkle the top with chopped truffle.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("HOT CHICKEN CROÛTES")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("150ml/¼ pint good béchamel sauce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon curry-paste")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 tablespoons cold chicken, diced")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 tablespoons cold ham or tongue, diced")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt, pepper, and cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("lemon juice")])])]), _c('div', {
    staticClass: "space"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("fried bread")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon grated Parmesan and gruyère cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("fried parsley to garnish")])])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Make the béchamel sauce (see ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06#page_130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 130")]), _vm._v("), add the curry-paste, and mix in the diced chicken and ham or tongue. Season with salt, pepper, a spot of cayenne, and a squeeze of lemon juice. Heap the mixture on small rounds of fried bread, put another round of fried bread on top, and spread over the cheese and butter, worked together to a paste. Brown quickly under a hot grill and serve hot, garnished with a heap of fried parsley.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("DEVILS ON HORSEBACK")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("12 large prunes or French plums")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ bay-leaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("water or red wine to cover")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ thin rasher of bacon for each prune")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("buttered toast")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("watercress")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "h3-italic"
  }, [_vm._v("stuffings of:")])]), _vm._v(" "), _c('div', {
    staticClass: "space1"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("(a) a fillet of anchovy curled round an almond,"), _c('br'), _c('i', [_vm._v("or")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("(b) chopped mango chutney,")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("or")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("(c) an olive stoned and stuffed with pimento")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Pour boiling water or hot red wine over the prunes; leave half an hour. Simmer in same liquid with half a bay-leaf till tender. If wine is used allow it to be absorbed by the prunes until it has practically disappeared. Cool prunes and stone. Fill with any one of the fillings given.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Flatten each half-rasher on a board and wrap round a prune. Set on a tin, bake in a hot oven 7-10 minutes. Set each on a piece of hot buttered toast. Arrange a bunch of watercress in the centre of the dish.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("ANGELS ON HORSEBACK")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These are oysters rolled in bacon, fastened with a skewer, and either grilled or baked in a quick oven 5-6 minutes. Two rolls may be allowed per person and they are served on hot buttered toast.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The following recipe is substantial for an after-dinner savoury. It may be increased, by the addition of kidney, to a luncheon dish, and it is an economical way of using kidneys.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PRUNE AND DATE KEBABS")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("good prunes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("dates")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("walnuts or almonds")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chutney")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("thin rashers of streaky bacon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("dessert apple")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("bay-leaves")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("stale bread")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("watercress")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Steam or poach the prunes, then stone them. Stone the dates. Brown nuts and chop coarsely, then mix with chutney. Fill into the fruit and wrap each one in a thin piece of streaky bacon.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Arrange on skewers with slices of apple and pieces of bay-leaf in between. Brush with melted butter.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Meanwhile grate or shred coarsely some stale bread, dry lightly in the oven, then fry in butter until crisp. Now grill the kebabs, pile on a hot dish with the crumbs, and garnish with watercress.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("KROMESKI")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These are a creamy mixture of diced cooked meat, ham, chicken, mushrooms, oysters, and hard-boiled egg, bound with a well-seasoned béchamel sauce and egg yolk. A little chutney or chopped herbs may be added to make them more piquant.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A teaspoon of the mixture is enclosed in a rasher (or half-rasher) of bacon, rolled up, dipped in fritter batter, and fried at once in deep fat.")])])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  })])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter03"
    }
  }, [_c('p', {
    staticClass: "ch-num"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("III")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_vm._v("Kitchen Knowledge")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It is sometimes assumed that a woman, by virtue of her sex, will know instinctively the meaning of technical terms in cookery, as though a girl child should have trailed along with her cloud of glory an embryonic knowledge of cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Instructions such as make a purée, clarify the fat, reduce the gravy, make a roux, blanch this, glaze that, are not always amplified and to the novice in the kitchen can be puzzling.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If as a child you were allowed in the kitchen you probably imbibed some useful first-hand knowledge. While you sieved the breadcrumbs, or turned the ice machine, you were no doubt registering a good deal of all that went on around you. The penetrating observation of an intelligent child seems to be acceptable to the cagiest of cooks, even to those who regard with suspicion innocent questions from adults. You perhaps were fortunate and free to learn as much as you liked or could, so that it is probably said now that, to you, cooking comes naturally.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Many of the present generation have missed such early experience, and it is for those who suffered this deprivation that the following notes have been compiled.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If one is possessed of certain basic information the use of recipe books is simplified and causes of failure more readily identified. It is hoped, therefore, that no apology is called for by reason of the elementary nature and detail of the information offered. The notes are divided in two portions; the first half concerns everyday processes and the second is devoted to necessary but less commonplace kitchen operations.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BREADCRUMBS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A jar each of dried white and of browned breadcrumbs should be kept in every kitchen. Dried white crumbs should be used for coating for frying. Browned breadcrumbs are for covering the surface of ham, for frying and serving with game (they have a good nutty taste), and for gratinés.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fresh white crumbs are used for panades, for fish, meat, and vegetable creams, for stuffings and bread sauce, and for certain sweets and cakes. They will not keep as they soon become mouldy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Fresh white breadcrumbs")]), _vm._v(" are prepared from stale bread: it must be at least a day old. The crust is cut off and the remainder rubbed through a wire sieve with the palm of the hand.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Dried white breadcrumbs")]), _vm._v(" are made by slow and thorough drying of fresh crumbs. This may be done in a slow oven provided they are not allowed to colour. A better way is to set them in a warm place, say on the rack over a stove, cover them with a piece of kitchen paper, and leave them there, even for a day or so, until completely dry. They will keep for some weeks stored in a screw-top jar.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Browned breadcrumbs")]), _vm._v(" should be prepared by drying and browning crusts of bread in the oven. These are then put through a cheese-grater or crushed with a rolling-pin; the crumbs are then sifted through ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("a sieve and stored in a jar.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Egging and crumbing.")]), _vm._v(" This is done with dried white crumbs, fresh ones being too absorbent. In a shallow dish or soup-plate beat an egg lightly, just until yolk and white are well mixed, season with pepper and salt, and add a little salad-oil and a spoonful of milk. Have a well-floured board and a piece of clean paper covered with a layer of the crumbs. Set these three alongside, first flour, then egg, then crumbs. With the aim of obtaining a dry surface turn whatever is to be coated in the flour on the board. In the case of croquettes the final shaping is now done. Fish should be well dried with a cloth and turned on the board, patted and rolled lightly in flour, and then shaken well. Avoid a thick coating of flour; it should be as thin as possible. Set whatever you are coating on a clean plate and brush it with the beaten egg, turning it with the aid of a palette-knife so that no part of the surface is missed, and, lifting it on the palette-knife, allowing any surplus egg to drain back on to the egg plate. Transfer it to the crumbs, and by gentle movement of the edges of the paper roll it about sufficiently to cover the entire surface with a thin crust. Avoid touching with the fingers. Pat the surface gently but firmly with the palette-knife to help the crumbs to adhere. Renew the supply of crumbs in the paper as required.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If from any cause the egg soaks through the surface of the crumbs it may be necessary to give another light coating. This is not a good thing as the result may be an over-thick, over-resistant surface.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TO GLAZE WITH BEATEN EGG")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Egg-wash is the term given to a mixture of egg and salt used for glazing pastry, bread, and buns when a shiny surface is required. One egg with ½ teaspoon salt is lightly beaten with a fork. The salt has the effect of making the egg more liquid, clear, and easy to apply.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("EGGS")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("For notes on eggs see ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter11#page_244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 244")]), _vm._v(" in egg chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("DUXELLES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This is a paste or mince made of mushrooms, or mushroom peelings and stalks. It is used for flavouring sauces, soups, ragoûts, stuffings, stews and so forth. One or more handfuls of mushrooms, not necessarily of the best quality (or stalks and peelings only), are washed well, squeezed to dry as much as possible, and finely chopped. Chopped herbs may be added for flavouring. A small piece of butter or other fat is melted in a sauté pan, salt and pepper added, and the chopped mushroom cooked till dry. Stirring must be constant to avoid burning. The duxelles is then turned into a small jar, pressed down, covered, and kept in a cool place until wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MIREPOIX")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This is a mixture of vegetables, cut in dice and used either as a basis or a "), _c('i', [_vm._v("fond")]), _vm._v(" for a braise, or cut slightly smaller (about 3mm/"), _c('span', {
    staticClass: "entity"
  }, [_vm._v("⅛")]), _vm._v(" inch) and used as a garnish for cutlets or for a fish dish (see Filets de Sole Sylvette in fish chapter on "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter16#page_410",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 410")]), _vm._v("). It should consist of such vegetables as onions, carrots, parsnips, leeks, peas, Brussels sprouts, etc., which must be arranged so that no one flavour predominates. The mixture of vegetables is put into the braising-pan, as indicated in the recipe. If the mirepoix is to be served as a garnish, the mixture is put into a sauce or stew-pan with a little melted butter. Seasoning is added, the pan covered, and the mixture cooked on a slow heat for 5-6 minutes. One to two tomatoes, skinned, pipped, and chopped, are then put in, a piece of buttered paper pressed down on the vegetables, the pan tightly covered, and the whole put into a moderate oven for 20-30 minutes, or until the vegetables are tender.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("BRUNOISE")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This is also a mirepoix, but consists of very finely diced vegetables, usually carrots, shallots, beans, and turnips, rissoled gently in a nut of butter. Used mostly as a soup garnish.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("JULIENNE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Julienne is a term usually applied to vegetables cut into small, narrow strips about 3mm/"), _c('span', {
    staticClass: "entity"
  }, [_vm._v("⅛")]), _vm._v(" inch wide and 5cm/2 inches long. They are used as a garnish for a clear soup, or for an entrée. A julienne of vegetables consists of carrot, turnip, leek, and celery. It is cooked in much the same way as a brunoise, i.e. rissoled in a nut of butter until just beginning to change colour. A very small quantity of liquid is then added, and the vegetables are gently simmered until cooked.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("FAT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In the first flush of enthusiasm over the possession of a country cottage, a friend, inexperienced in farming, reared and killed a pig, proceeded to cure it (in his London flat), then, finding it so fat as to be inedible, gave it away to his friends; and this at a time when to collect enough fat for deep frying was almost impossible. ‘To render down fat’ meant nothing to him.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To render down fat.")]), _vm._v(" Cut fat in small cubes, remove coarse skin and gristle. Put in a strong iron saucepan, cover, and cook steadily over a slow heat. At first when it heats the fat sizzles and makes a noise; when this ceases one must watch that it does not burn. The process should be slow and steady. When the contents of the pan have become a clear liquid remove from fire and pan and press through a strainer lined with muslin. The scraps which remain should have very little substance. The process may also be carried out in an uncovered baking-tin in a slow oven.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To clarify fat (1).")]), _vm._v(" Put fat into an iron saucepan and cover with water. (Do not put on a lid, for this reason: the water boils, the fat forms a coating, the steam is trapped, and there may be enough pressure to blow the lid off.) Bring to the boil, allow to simmer a short time. Remove from fire, allow to get cold, lift off solid fat, scrape the underside free of impurities and you have now a solid block of purified fat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To clarify fat (2).")]), _vm._v(" The collection of drippings from baking-pans and from stock and soup skimmings will not keep sweet for long or be suitable for frying until clarified. Put the drippings into a pan with a cup of water. Allow to boil for 20 minutes. Strain off into a basin. The fat will then rise to the top and all impurities will be left below in the water. The fat thus obtained is more suitable for shallow than for deep fat frying, but may at need be added to the deep fat fryer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To clarify fat (3)")]), _vm._v(" (Quick method). Slice a large potato. Put into the fat, bring the fat up to boiling-point, and allow to simmer until it becomes absolutely still. The potato will by now be dark brown. Strain off. Any impurities will have been absorbed by the potato. This also has the effect of removing flavours imparted by strongly flavoured foods.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("These processes should be carried out on the top of the stove and not in an oven.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("THE BLANCHING OF BACON AND SALT PORK")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Bacon is blanched to remove excess of salt and to render it entirely clean before it is added to such dishes as ragouts or braises; if this is not done the whole is apt to taste too strongly of bacon. Salt pork, which is sometimes used in place of bacon, is always blanched.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("The bacon is put into cold water and brought slowly to boiling-point. It is then simmered gently 2-3 minutes according to the degree of saltiness, then turned into a strainer and cold water run over it; it ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("is drained well and, if the bacon is to be browned, dried completely.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Lardons, described under larding (see ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#page_58"
    }
  }, [_vm._v("page 58")]), _vm._v("), should be cut in the way described before being blanched and drained.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TO PREPARE BACON FOR FRYING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("If bacon is so salty that it must be blanched, it must then be thoroughly dried. The rinds are first cut off with kitchen scissors and the rashers flattened out with the blade of a knife.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TO SCRAPE BACON FAT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Sometimes a recipe calls for the use of bacon fat in such a fine state that it has to be scraped. This is done by scraping the surface of the bacon with a short, strong knife until the required amount is obtained. It is easier to do this from a fair-sized slab of fat bacon than from a slice.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BLANCHING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The process of blanching is applied sometimes to kippers, if these are not of the finest quality, and to sweetbreads and calf’s head.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Blanching of Sweetbreads and Calf’s Head.")]), _vm._v(" This is done with the object of making the flesh firm and clean. They are covered with cold water which is brought slowly to boiling-point; they are then drained and washed in cold water.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("THE CLARIFICATION OF MARGARINE AND BUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Margarine is clarified in order to eliminate moisture. Salted butter is clarified with the object of eliminating salt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To clarify margarine.")]), _vm._v(" An ounce and a half of margarine will render approximately 25g/1 oz when clarified. It is simpler therefore to clarify say 225g/8 oz at a time, and to keep it in a jar in a cool place so that the quantity called for in a recipe is immediately available in net weight.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Heat the margarine in a small pan; after a short time the initial sizzling will cease and at this moment care must be taken to avoid burning. The contents of the pan will now present the appearance of a clear oil. Strain this through a piece of muslin, allow to cool a little, and pour into a jar.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To clarify butter.")]), _vm._v(" (This process is not applied to fresh, unsalted butter; it is unnecessary and the good fresh taste would be lost.) Clarified butter, as well as being called for in recipes, is used for sealing off potted shrimps, potted meats, duxelles and so forth.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Melt the butter in a stew-pan and cook gently without allowing it to colour, skimming off all scum and impurity as it rises to the top. Strain through a strainer, lined with muslin, leave it in a basin to settle, then pour it gently into another basin, leaving the sediment behind.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To soften butter.")]), _vm._v(" Warm an earthenware bowl by pouring boiling water into it, emptying it, and drying it well. Avoid heating the bowl by placing it on the stove. This heats the bottom only, and every part of it should be warmed. Put in the butter, cut up in small pieces. Work it with a wooden spatula until it reaches the condition of a cream, smooth, even, and entirely without lumps.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To desalt butter.")]), _vm._v(" Put it into a basin and pour boiling water over it. Leave it to become quite cold. The butter rises to the top of the water (which has washed out all the salt), and can be lifted off.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To flavour butter.")]), _vm._v(" Soften as directed above, and incorporate the flavouring required by working it into the butter, either in a mortar or by manipulating the mixture with a palette-knife or a fork.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("‘Monter au beurre,’ or to add butter to cooked dishes.")]), _vm._v(" A recipe sometimes requires that butter be added at the last moment to a sauce or a soup. It should in these circumstances be added off the fire, divided into small pieces and well incorporated. No sauce should ever be reboiled after the butter has been added. Such heat reduces the butter to oil, and the good flavour is lost. Therefore the dish in question should be quite ready for serving, and boiling hot, before the butter is added. If it is absolutely necessary to delay before serving, the sauce must be kept hot in such a way that the butter will not oil (for example in a bain-marie).")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To improve the taste of tinned or slightly rancid butter.")]), _vm._v(" Break the butter into quite small pieces. Put these into fresh cold milk and leave for an hour, then wash in cold salted water.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TO OIL A MOULD")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Oiled moulds are essential for certain cold dishes such as set creams, bavaroises, and parfaits, because oil does not set when cold. Tasteless oil is called for. This is applied with a brush as evenly as possible and with especial attention to corners, crevices, and indentations of fancy moulds. The mould should be turned upside-down and left so for a short time in order that any surplus oil may drain away.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CREAM")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To whip cream.")]), _vm._v(" Pour the cream into a cool basin, whip gently at first, until the cream is light and frothy. Use a wire whisk and whip faster as the cream begins to thicken. Be careful not to over-whip; as soon as the cream is stiff enough to stand in a point, put it aside in a cool place until needed, or use at once.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Crème chantilly.")]), _vm._v(" The term chantilly indicates a slightly sweetened whipped cream, flavoured with vanilla. The sugar should be sweetened with real vanilla pod (see paragraph on the use of vanilla, ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#page_38"
    }
  }, [_vm._v("page 38")]), _vm._v("). By reason of the presence of specks of vanilla in the sugar this cream may present a slightly speckled appearance. Sometimes to a rich and thick chantilly whipped white of egg is added, one white to a pint of cream; this has the effect of lightening the cream and may be used when it is to be piled on top of a sweet dish. If the cream is to be piped the egg white should not be used.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To whip evaporated milk.")]), _vm._v(" The best method is to boil the tin for 20 minutes, chill it, open, pour out the milk, and whip vigorously. This will be firm enough for folding into creams and soufflés, but if something stiffer is required, add a level teaspoon of gelatine dissolved in a spoonful of water to the milk whilst still warm. Then whip over ice.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To make cream from fat and milk with a machine.")]), _vm._v(" This can only be done with an emulsifying machine, through which a mixture of milk and unsalted butter or margarine is forced. Unsalted margarine makes excellent cream for cooking purposes. To make just under half a pint of cream, take 110g/4 oz unsalted butter or margarine, melt it in 150ml/¼ pint of milk. Cool the mixture by pouring it backwards and forwards from the pan to a jug until it is at blood-heat. Pour it into the bowl of the emulsifying machine until the bowl is half full. Pump with quick, hard strokes. The cream will come through into a basin placed underneath the machine. Stir it well with a fork, and leave it in the refrigerator to get quite cold. Stir again, before using, as the thicker part of the cream rises to the top.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("For successful cream-making:")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Keep exact proportions, as given above.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Keep the mixture at an even temperature, i.e. blood-heat or 37°C/98°F.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pump hard and evenly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Stir well before using.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Cream made with an emulsifying machine is not easy to whip. It can be made of the right consistency by adding to the amount given above, a sheet of gelatine or a teaspoon of powdered gelatine, dissolved in a spoonful of water and added to the milk before the butter or margarine is melted. The cream should be allowed to become quite cold, stirred, then whisked as directed above.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To reduce milk.")]), _vm._v(" This is done to make the milk richer in quality, and is a process called for in certain sauces and soups where it is used as a substitute for cream. In an uncovered pan the milk is simmered until the required reduction in quantity is reached.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("GELATINE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("The use of gelatine.")]), _vm._v(" So great is the improvement in the type of gelatine now obtainable that a note on this may seem unnecessary; yet some cooks retain an impression of difficulty. The old-fashioned thick sheets of this substance were slow to dissolve and it was possible to burn them during the process. Now, with gelatine in fine powder or extremely thin sheets, one can hardly go wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Only the best kind should be used; cheap, poor gelatine has an unpleasant taste. This substance is generally used in small quantities. It should be thin, transparent, and brittle and be kept in an air-tight tin. Leaf gelatine should be washed in cold water before use, then soaked in a basin of cold water till soft. It is then dissolved in the quantity of liquid called for in the recipe by being placed in a small saucepan and gently warmed (it should not boil). It may then be strained through a fine wire strainer or a piece of muslin.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Powdered or granulated gelatine is soaked in the quantity of cold water or liquid indicated in the recipe and then dissolved over gentle heat. Gelatine is usually added to the substance it is required to set when this is lukewarm, and it is necessary to stir the whole gently until it reaches the point of setting. The following list of equivalent weights may be of use to the novice.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PROPORTIONS OF GELATINE USED FOR THE SETTING OF VARIOUS LIQUIDS")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("(a)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("For thin liquids such as fruit juices:")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("French leaf gelatine: 45-50g/1¾-2 oz to set 1.2L/2 pints liquid.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Powdered gelatine: 50g/2 oz to set 1.2L/2 pints liquid.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Strip gelatine (a coarser variety): 40g/1½ oz to set 1.2L/2 pints liquid.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("(b)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("For moulded creams composed of eggs and cream, a smaller proportion, as little as half the above amounts. Reference should be made to individual recipes.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("(c)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("For thick fruit purées: 15g/½ oz gelatine to the pint.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In hot weather, and without the aid of an ice-box, it may be necessary to increase slightly the above amounts.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Instructions about gelatine vary in their wording in different books, and the following note may be of use:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("6 medium sheets of gelatine as now sold, or")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("2 old-fashioned thick sheets, or")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("2 level tablespoons granulated gelatine")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("all equal 25g/1 oz")])]), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("FLAVOURINGS AND SEASONINGS")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Proper use and care of a vanilla pod.")]), _vm._v(" When buying choose those covered with white crystals, which indicate freshness. Keep in a covered jar containing sugar, which will then become flavoured with vanilla.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To use: a small piece may be cut off, or half a pod may be taken, according to the amount of liquid to be flavoured. Split the pod, scrape out some of the seeds, put both seeds and pod into the liquid, e.g. milk for custards and ice-cream mixtures. When the liquid is well flavoured remove pod, dip in warm water, dry, and return to sugar jar. In this way a pod will last two or three weeks at least.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Vanilla essence.")]), _vm._v(" Always buy the very best, which unfortunately is expensive, and use with economy.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SALT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Pure block salt should be used in the kitchen, as ‘table’ salt contains other substances included specially by the manufacturers to keep it free-running; block salt, therefore, may be more accurately measured and is the purer article. It is bought in bars or blocks of about 1.5kg/3 lb or more and should be grated or ground down and stored in a covered jar for use as required. It is ground down:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("(a) by using a coarse grater on the surface of the block, or")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("(b) by cutting the block in half and rubbing each half against the other.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Rock-salt.")]), _vm._v(" This may be bought from a chemist or a French or Italian grocer and consists of salt crystals for use in small wooden salt grinders. ‘Freezing’ salt, which is obtainable from a fishmonger, is also a rock-salt, but is less refined and is used principally with ice for freezing purposes.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PEPPER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A substitute for pepper, consisting of a mixture of other highly flavoured spices, is now widely sold in place of pepper, owing to the very high cost of peppercorns; but pure ground pepper, white and black, may still be bought. White pepper should be used in white or fine sauces and black for other savoury dishes where a more spicy and robust flavour is called for and where the colour is not so noticeable. White pepper (or white peppercorns) has a more delicate flavour than black. Peppercorns should always be at hand in the kitchen, either for use whole or for grinding in a peppermill. Pepper ground from a mill is excellent for many dishes, salad-dressings and so forth, but is not quite fine enough for adding to white or fine sauces, so a pure ground pepper is also necessary. For table use it is best to have ground white pepper in the pot, and a black pepper in the mill.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PAPRIKA")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This is a red pepper ground from sweet red peppers or pimentos. It is spicy and only slightly hot. It is best to buy it loose in small quantities from a good store; comparatively large quantities may be used in dishes. The best paprika comes from Hungary.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CAYENNE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cayenne is ground from red chillies and is very hot. A pinch or a "), _c('i', [_vm._v("point")]), _vm._v(" only is called for in a dish and it should be bought in very small quantities.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("ALLSPICE (PIMENTO)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This is sometimes called Jamaican pepper. It is a spiced pepper and may be used whole or ground. It is mild and spicy in flavour and is used mainly for pickling and spicing, in pies, ragouts, devils and so forth.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("JUNIPER BERRIES")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These are sold dried and may be finely crushed and added to a dish or put into a muslin bag with other spices for infusion. They are used principally for game sautés, marinades, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SALTPETRE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This is nitrate of potash and is used for pickling meat, rendering it a reddish colour.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CLOVES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cloves are very pungent and aromatic and should be used with care, usually not more than one or two in any dish. They are traditional in this country as a flavouring for apple tart and bread sauces, and in certain cases they may also be included in a bouquet garni. They are bought ground for use in conjunction with other spices in fruit cakes, and they are used also in a wide range of other dishes, such as jugged hare, cream soups, and strawberry jam.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("GINGER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This is obtained ground or in root form. Root ginger is used whole, chiefly in pickles and chutneys, though in some curried dishes it may be grated and pounded; a root is sometimes known as a ‘race’ of ginger.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ground ginger is widely used, mostly for puddings and cakes. Ginger in syrup and glacé and crystallized ginger are dessert sweetmeats and are used also for flavouring sweet sauces and garnishing cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POT-HERBS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This is an old-fashioned term for mixed vegetables used as flavouring. They consist of onions, carrots, turnips, swedes and so forth. Sometimes in northern towns one may still see them offered for sale by the pound, ready sliced, in small vegetable shops or on market stalls.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("THE PREPARATION OF FRUIT AND VEGETABLES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To prepare grape-fruit for breakfast.")]), _vm._v(" Cut fruit in half; take a curved saw-edged knife, cut round the outside of the fruit next to the skin and then in between each section. Slip the knife underneath the fruit and cut away the attachment of the core. Lift the core out, pushing the flesh well down. If you have not a saw-edged knife, take a stainless steel knife and cut between the sections and the membrane first, before cutting round, otherwise the knife will slip.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To cut grape-fruit and orange for fruit compôte or salad.")]), _vm._v(" This is made easier by a preliminary chilling of the fruit in the ice-box. Use a very sharp knife. Hold the grape-fruit firmly in the left hand with the tips of the fingers. Then begin to remove the peel at the top in a sawing circular movement, taking pith as well as peel. As you saw turn the grape-fruit in your fingers. When all peel is removed, if any bits of white pith remain saw these off, and if the fruit is soft it may now be chilled again. Now carefully cut each section free of membrane and lift it out. As you do so, put the layers of membrane together like the leaves of a book. This method is only suitable for grape-fruit and large oranges. When a small orange must be cut for a compôte proceed as follows: peel, removing as much of the pith as possible, as before. Cut in four vertically, then slice downwards the length of the quarters, so that the line of white membrane comes away and it is easy to remove the pips.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To cut lemons for serving with pancakes or fried fish.")]), _vm._v(" Wipe the lemon and cut it in four lengthways. ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Remove the line of white pith as before and the pips. If the lemon is large the quarters will probably need to be cut again. This is a convenient way of cutting a lemon, because the juice is directed, by the formation of the lemon, downward on to the food, and does not spurt all over the place.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Poaching and peeling of peaches for compôtes.")]), _vm._v(" Put the peaches into a bowl and pour boiling water over them. Leave up to a minute. Pour off the water and pour on cold. The skin may now be easily removed, using a silver or stainless steel knife. The peaches are then ready for poaching in thick syrup, and are either left whole or halved according to their ripeness and size.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To cut pineapple for compôte.")]), _vm._v(" With a sharp knife take slanting cuts downwards, between the eyes. It is then easy to remove the eyes with the skin. The pineapple is then cut in slices with a stainless steel knife and the core removed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To cut pineapple for dessert.")]), _vm._v(" For dessert a pineapple should be torn apart with two silver forks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To stone a cherry.")]), _vm._v(" There are cherry-stoners on the market; failing one of these the simplest way is to take a very small vegetable scoop and scoop out the stone, or fix a hairpin into a cork and scoop it out with the rounded end.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Zest of orange and tangerine.")]), _vm._v(" Take rough lumps of sugar and rub thoroughly all over the skin of the fruit until they are completely soaked with oil, roughly one or two lumps of sugar for each orange or tangerine. The sugar may be crushed and incorporated into butter for orange butter, or put into milk when it has reached boiling-point for the making of custard. After the addition of the orange-soaked sugar to the milk, avoid boiling or the flavour will be spoilt. Sometimes the sugar is added to a hot custard and allowed to dissolve in it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To ‘turn’ an olive.")]), _vm._v(" This applies only to green olives. Hold the olive in the fingers of the left hand and with a small vegetable knife cut the pointed top nearly three-quarters through, then pare round the stone until the stalk end is reached, rather like peeling an apple. Then cut straight across the bottom. Carefully detach from the stone and reshape. Black olives are merely partly split and the stone removed.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To peel, slice, and chop an onion.")]), _vm._v(" See ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter07#page_169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 169")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To cut a radish for decoration.")]), _vm._v(" There are two ways of cutting a radish: the first is to make four cross cuts after having cleaned it, cut off the root, and left on about 5mm/¼ inch of the green tip; if the radish is then left in iced water it will open like a flower.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The second and nicer way is to make small uneven cuts all round the outside of the radish; it is then left in iced water to open.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To curl celery.")]), _vm._v(" With a potato-peeler take off slivers of celery about 5-7cm/2-3 inches long. Put these into iced water for an hour or two. Or choose tender stalks and make five or six incisions at the top for about a third of the length; or short pieces may be so cut at both ends. Put in iced water and allow to stand overnight in a cold place, preferably in the ice-box.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TO BLANCH ALMONDS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("See "), _c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter29#page_741",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 741")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TO PEEL CHESTNUTS (TWO METHODS)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("(a) Put nuts into cold water and bring quickly to the boil, remove from fire, lift out with a spoon one or two nuts at a time. The outer and inner skins may then be removed easily, but do not take all the chestnuts out of the water and let them get cold. Do not keep the water on the boil. It may be brought back to the boil if it gets too cold. Any nut from which the inner peel cannot be removed may be replaced "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("in the hot water.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("(b) Cut a tiny piece off the top of the nut, put the nut into a frying bath and dip into smoking hot fat for half a minute. Both skins are then easily removed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When a particularly dry purée is wanted for piping, for example for a Mont Blanc, the chestnuts may be baked. A slit is made in the skin, the nuts baked in the oven till tender, the inside then scooped out and sieved.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TRUFFLES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These tuber-like fungi are expensive luxuries and are generally reserved for special dishes and occasions. They are found in some parts of France and Italy and grow a few inches below the surface of the ground in the vicinity of oak-trees. Périgord is famous for the black truffle and from Piedmont comes a white variety. Truffles are sometimes found in England, but one rarely comes across a native truffle. Their size varies from a walnut to a hen’s egg. If French truffles are available – and they are sometimes imported into this country in autumn and early winter – the rough skin is pared off and they are then stewed till tender. It is more usual for us to buy them in tins or bottles ready for use. They have a unique flavour which is readily imparted and the black slices also have a decorative quality. A traditional delicacy is a chicken or turkey "), _c('i', [_vm._v("en demideuil")]), _vm._v(", for which thin slices of truffle are carefully inserted under the skin of an uncooked bird, which is then left overnight so that the flavour may penetrate the flesh before the bird is stuffed with veal force-meat and roasted.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PREPARATION OF SHRIMPS OR PRAWNS FOR GARNISH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Prawns or shrimps used for garnish have the tail or body shell carefully pulled off and the head left on. If to accompany a hot dish the heads may be lightly brushed or rubbed with oil, if for a cold dish brushed with cool aspic.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TO SKIN SAUSAGES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("With a sharp-pointed knife draw a thin line down the length of the sausage and so split the skin. It may then be easily ripped off.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TO MAKE CROUSTADES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut rounds of stale bread 5cm/2 inches thick and about 7cm/3 inches in diameter; with a smaller cutter make an incision, taking care not to go through to the base; this will facilitate the removal of the centre after frying. Fry to a golden brown in deep fat, drain, scoop out the centre to form a hollow case. Fill with the mixture indicated in the recipe.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TO FRY PARSLEY")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Unless it is absolutely necessary refrain from washing the parsley. If it is necessary to do so, do it some hours beforehand and see that it is perfectly dry before putting into the hot fat, otherwise the fat splashes in a violent way and is dangerous. Pick the sprigs from the main stalks of the parsley. Allow a really large handful of sprigs for four people. Put into a frying basket, and when the fat shows a faint blue haze plunge into the fat bath. Do not be deterred by the noise it makes. As soon as the hissing stops, lift out the parsley, which should be bright green.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("TO IMPROVE CHOPPED PARSLEY")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("To make chopped parsley easy to sprinkle and a good colour, put it, after chopping, into a corner of a clean cloth or piece of muslin. Gather it up and hold for a few minutes under the cold tap or in a bowl of water, working it well with your fingers. Then squeeze it dry, and shake the parsley out of the cloth. It will be a brilliant green.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PREPARATION OF WATERCRESS FOR A GARNISH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Open the bunch and throw into plenty of cold water containing a little salt. Lift out and shake well. Lay on a clean cloth and dab dry, pick over, discarding faulty leaves and any white rootlets high on the stem. Lay all the stems in the same direction, arrange the sprigs in small bunches, shorten the stems a little so that you have neat little bunches of perfect sprigs. At the last moment dip each bunch in French dressing, shake gently to remove surplus, and put them on the dish with the grill or whatever food the garnish is to accompany. Do not return to the oven.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If the bunches are really young and good they may be washed as they are without being untied; the stalks are then shortened and little bouquets of the sprigs are picked out from the bunch.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SIEVING AND SIEVES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Wire sieves and hair sieves (or nylon which has now taken the place of hair) have each their proper uses and are not, generally speaking, interchangeable. The primary use of each is for the making of purées. A hair or nylon sieve produces the finer purée, but this is not invariably desirable. For acid fruits, when contact with the metal would cause discoloration, or when a very smooth purée is called for, a hair or nylon sieve is required. Sometimes the operation of making a fine purée may be expedited by making a preliminary coarser purée with a wire sieve and finishing it off through the finer medium.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Within reason a large sieve is more practical than a small one. It is easy to confine the material to the central part of the sieve and more comfortable to have plenty of space.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Speedy work is essential because it is easier to pass hot materials through a sieve than cold. A wooden spoon is suitable for this work, with the fingers placed in the bowl of it in order to exert adequate pressure. A specially curved wooden spoon is obtainable for this purpose, and also a presser known as a "), _c('i', [_vm._v("champignon")]), _vm._v(" which is frequently used for sieving potatoes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The operation is one of crushing rather than rubbing, though this applies more to some substances than others; in the case of potatoes, for instance, rubbing will produce a gluey consistency, but with berried fruits short, sharp strokes from back to front of the sieve are required.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("The sieve, shallow side uppermost, should fit easily over bowl or dish and be in no danger of slipping. When a dry purée is required, of potatoes, lentils, or chestnuts, a clean dry cloth may replace bowl or dish with advantage; it will absorb a certain amount of surplus moisture (see also Drying a Purée, ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#page_43"
    }
  }, [_vm._v("page 43")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sieve and saucepan should be close together, the contents of the latter being taken out in small quantities and the lid replaced each time. With certain materials, berried fruits for instance, the operation is helped by the addition from time to time of a little of the liquid in which they were cooked. At intervals, and of course at the end, the underpart of the sieve should be scraped free of purée with a metal spoon, palette-knife, or rubber scraper – not with the wooden spoon in use. Sometimes, if skins of fruit or dried vegetables accumulate on top of the sieve, impeding progress, they should be scraped together and discarded. It is perhaps unnecessary to point out that a strainer, either the pointed or round type, cannot suitably be substituted for a sieve. This utensil is for draining and straining, and it is unwise to try to make it do more than this, and the result in any case will be unsatisfactory.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("DRYING A PURÉE")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("For certain dishes, for example for mashed potatoes, turnips, haricots, and other dried vegetables, a dry purée is required, and all possible moisture has to be driven off. To do this the purée should be gathered up in a cloth on to which it has been sieved, returned to a hot, wide-based saucepan, and set on good heat. The wider the base of the pan the thinner the layer of purée and the easier the process of drying.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The purée should be stirred with a square-tipped wooden spoon, turned steadily, and pressed first against the base of the pan and then at once turned all over again. Superfluous moisture is thus driven off in steam and the purée becomes increasingly thick. It is now ready for the incorporating of other ingredients such as butter, milk, or sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CHOPPING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Such an everyday process hardly seems worthy of a note, yet if one watches a class of students it is surprising to see the degrees of apt and inept work. One will bang away with a knife, making little impression on the material, another will be moving her knife to and fro in a rhythmical rocking motion, reducing whatever is under it to fine shreds. A proper chopping-knife, by its shape, graduating from broad blade to narrow point, facilitates the action. If, for instance, a bunch of herbs is to be chopped, these should first be gathered together and roughly shredded. Then, holding down the tip of the knife in the left hand (the point used as the fulcrum of a lever), move the knife rapidly up and down with the right. A level board is, of course, essential. In big kitchens where work is done on a large scale a curved chopping-knife with two handles is used, and this, in combination with a chopping-block, is most efficient.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("USE OF A MINCING-MACHINE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A mincer has many uses, apart from the mincing of meat. It can be used for chopping raw or dried fruits, apples, pears, stoned prunes, figs, sultanas, and raisins, particularly when such fruits are to be made into chutney, pickle, or bottled sauces. Baked crusts may be put through a coarse mincer, sieved, and used for raspings. This is a quicker and easier way than crushing them with a rolling-pin. Vegetables may be minced in this way, but experienced cooks prefer to grate or chop them, for then they are less crushed and less juice is extracted. Potatoes and artichokes become discoloured if put through a mincing-machine.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A cheese-grater is useful; it can be fastened on to the edge of the kitchen table in the same way as the mincing-machine, and it is used for nuts, cheese, crumbs, and other things.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SKIMMING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("With certain classic sauces, soups, and stocks, perfection can only be attained by lengthy and meticulous skimming. This is carried out when the liquid has been gradually brought to the boil. It is at this point that impurities rise to the surface. To facilitate skimming a saucepan should be chosen which the liquid will fill almost to the brim.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("When the liquid comes to the boil, it is drawn aside from the heat and any scum or grease that comes to the surface lifted off. From time to time a spoonful or two of cold water or reserved stock is added, which will bring more matter to the surface to be skimmed off. The pan should then be placed in such a manner that the heat gives rise to a gentle bubbling in one part of the saucepan only, and always at the same place. The pan should be left uncovered while the skimming is done from time to time. This is the process meant by the word "), _c('i', [_vm._v("dépouiller")]), _vm._v(", (See also Sauce Demiglace, ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06#page_120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 120")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("REDUCING")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("It is sometimes necessary, in order to strengthen flavour or produce a thicker consistency, to reduce the quantity of a sauce or syrup. This is effected by boiling the liquid quickly in an uncovered pan. (See also general notes in chapter on sauces, ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#page_14"
    }
  }, [_vm._v("page 14")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("GLAZING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A dish coated with sauce which has been glazed presents a lacquer-like surface. The operation has to be accomplished speedily so that the food is not subjected to further real cooking. Certain sauces would be spoiled if this were allowed. A shallow dish is desirable; the glazing is done by subjection to strong heat over the surface, a gas or electric grill or very hot oven.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Glazing cold meats such as galantines, brawn, etc., is a different process. In this case melted meat glaze or savoury jelly is brushed over the surface with a glaze brush. Each coat is allowed to dry before another is added. The process is repeated, coat upon coat, until the required thickness is obtained.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sweet glazing for such dishes as flans and tartlets is done in much the same way. A thick purée of well-boiled apricot jam or melted red-currant jelly is applied to the surface with a brush. In this way a much more even coating is obtained (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter29#page_743",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 743")]), _vm._v("). The more homely way of pouring the glazing mixture over the fruit in the flan will often leave salads of uncovered fruit.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For oiling and greasing of tins see chapter on cakes, "), _c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter27#page_700",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 700")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("THE FORCING-BAG")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This is a bag made of strong cotton, shaped like a cornet with the tip cut off. A short metal tube or nozzle fits into the open point. It is used for squeezing certain mixtures such as choux or meringue paste into the required shape on the baking-sheet. The mixture is transferred by the spoonful from bowl to bag, which should "), _c('i', [_vm._v("only")]), _vm._v(" be three-quarters filled. The top of the bag is held securely in the right hand and the weight is supported by the left, and it is the left hand which guides and steadies the bag. It should be lightly squeezed from the top by the right hand. The tip of the pipe or nozzle should be kept close to the baking-sheet. For a round shape the pipe is kept still while pressure is exerted, and for éclairs a line is drawn.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For icing (either royal or butter cream) it is usual to make a forcing-bag or cornet of paper to take the place of the forcing-bag described above. The opening at the top of the cone may be cut to the appropriate size and used with the various nozzles and pipes. For drawing a thin line of jelly or cream the cone may be used without a nozzle, but the paper would not be strong enough without the nozzle to support heavy icing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To make the cornet proceed as follows: Take a double layer of best quality grease-proof paper and cut into a square. Fold diagonally to form a triangle. Holding this with the point uppermost fold the right-hand edges over to meet the centre line. Then take the left edges and bring them right over and round to the back until the two points of paper lie over one another. Tuck the flap thus formed inside the cone. Cut the point to the size required. For use, half fill the bag, and fold over the top of the bag so that the contents are enclosed, pressing a little so that the bottom of the bag is solidly filled. Pressure should be exerted steadily from the top.")]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("Making a Paper Piping Bag")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_45.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("SOME TERMS FREQUENTLY USED IN COOKING")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("(N.B. These terms are defined in the culinary sense. Their actual meaning, generally speaking, is not the same.)")]), _vm._v(" "), _c('div', {
    staticClass: "tablea"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Arroser")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to baste, to add liquid.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Aspic")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(a) a savoury jelly.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(b) cold entremets set in jelly, e.g. aspic de pommes.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Au blanc")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to cook without colouring, as a rule in a white sauce or a velouté, e.g. poulet au blanc, or in a ‘blanc,’ a sort of white bouillon.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-paraa"
  }, [_vm._v("Au bleu")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1a"
  }, [_vm._v("to cook freshly caught trout in court bouillon so that the fish looks bluish, having been cooked without scaling.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Au gras")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("cooked with meat or meat stock.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Au gratin")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("method of cooking which usually gives a brown surface; the dish is covered with sauce, breadcrumbs, sometimes with grated cheese, and served in the vessel used for cooking.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Au maigre")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("cooked without any meat or meat stock.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Bain-marie")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(a) a square or oblong vessel that will hold a number of smaller pans standing in hot water. Used to keep sauces, soups, etc., hot without further cooking. Temperature about 54-60°C/130-140°F.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(b) a baking-tin half filled with hot water in which steamed soufflés, custards, etc., stand while cooking at a temperature of about 82-88°C/180-190°F.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Beignets")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("fritters.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Beignets soufflés")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("fritters made of choux pastry.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Beurre manié")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("butter and flour worked together to a paste. One of the liaisons.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Blanchir")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(a) to put into boiling water for a moment, e.g. sweetbread, or scallops, to make firm before cooking.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(b) to put in cold water and bring to the boil, in order to whiten or to reduce strong flavour.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(c) to make less salt, and to clean, e.g. bacon or salt pork.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(d) to cook partly, e.g. some vegetables.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Bouchées")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("small cases of puff pastry.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Bouillon")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("consommé, unclarified, or beef broth, veal broth.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Bouquet garni")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a bouquet of herbs, usually parsley, thyme, and bay-leaf, tied together and used to flavour sauce, soup, etc. Other herbs may be called for by the recipe.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Canapé")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a small platform of fried or toasted bread used as the foundation of a savoury or hors-d’œuvre.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Chaudfroid")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("cooked chicken or game or other meats, coated with brown or white chaud-froid sauce, then with aspic jelly.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Chinois")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a wire strainer, conical in shape.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Concasser")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("literally to pound, crush, or grind. In cookery, to chop roughly.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Coulis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("concentrated liquid, the result of long, slow cooking.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Couronne")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_c('i', [_vm._v("dresser en couronne")]), _vm._v(", to arrange in a ring.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("Court bouillon")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("liquid used for cooking fish, made from boiling salted water, wine, or vinegar, carrots, onion, and bouquet garni.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Croquettes")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("cork shapes or cones, made of minced meat, fish, eggs, or vegetables, egged and crumbed and fried in deep fat.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Croustade")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("case of fried bread or pastry in which chicken, game, or minced meat may be served.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Croûte")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("crust, i.e. pastry or a crust of bread, fried, baked, or toasted light brown and used for serving small birds or for an entrée.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Croûtons")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("small dice or other shapes of fried or toasted bread, used to garnish some soups and other dishes.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Cuisson")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("the liquor in which something has been cooked, or which has been produced in the cooking process.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Dariole")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("dariole mould: a small mould in which a little pudding is steamed or baked – a dariole is a small pâté.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Déglacer")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to dissolve with hot liquid, usually water, the solids at the bottom of a roasting or sauté pan.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Dégorger")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to soak meat or fish, vegetables or fruit in water, to improve their colour, or to take away too strong a flavour. Often applied to aubergines and cucumbers, which are sprinkled with salt and left for some time so that harmful juices may be drawn out and washed away. This is said to make these vegetables taste better and to make them easier to digest.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Dégraisser")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to skim off fat, or to remove superfluous fat from meat.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Demi-glace")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("brown sauce, semi-clear and syrupy in texture.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Dépouiller")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to skim off every trace of fat while a sauce, soup, or stock is cooking.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Dorer")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to gild or brown with beaten egg.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Entrée")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("side-dish, hot or cold, which is complete in itself, having vegetables and sauce or gravy on the same dish.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Entremets")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("sweet dishes.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Escalope")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a thin slice of meat.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Étuver")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to cook under cover with little or no liquid.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Faire revenir")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to cook something so that it takes colour lightly without being completely cooked.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Farce")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("stuffing.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Fécule")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("potato flour, cornflour, or arrowroot.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Flan")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("open tart, cooked in a ring.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Fleurons, feuilletons")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("small pieces of puff pastry, usually crescents, used as garnish.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Fonds de braise")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("fat bacon, sliced carrots, and onion, etc., used with bouquet garni to line a braisière.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Fontaine")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_c('i', [_vm._v("faire la fontaine")]), _vm._v(", to make a circle of flour on a marble slab or pastry board, before making French pâte or pastry.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Frappé")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("iced.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Frémir, frissoner")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to come to simmering-point.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Friture")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("frying, or something fried.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("Fumet")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("stock of game or fish, or meat, sometimes of mushrooms, greatly reduced, and used to give good flavour to a dish.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Garniture")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("garnish, i.e. the small ornamental items that can be eaten and that give colour and attraction to a dish, e.g. small glazed onions or carrots, sliced sautéd mushrooms and so on, or for a fried dish, fried parsley. Often a dish will be named after the garniture.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Glacer, glacage")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(a) to reduce the gravy of a meat dish and use it, poured over the dish and exposed to great heat, to give a smooth, shining appearance.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(b) to give the same appearance to a dish covered with sauce.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(c) to ice a cake.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(d) to freeze a mixture.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(e) to dip fruit in very hot syrup and so give it a shining enveloping coat.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(f) to cook fruits or nuts over and over again in syrup successively strengthened, so that they become soaked in sugar, e.g. marrons glacés, fruits glacés.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Hâchis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("minced meat.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Hâtelet")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("ornamental silver skewer.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Hors-d’œuvre")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("appetizing morsels served at the beginning of a meal.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Infuser")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to steep: to extract flavour from material into a liquid by leaving it steeped in that liquid in a warm place – the liquid need not boil.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Jus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("gravy or reduced stock.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Kromeski")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("Polish name for a sort of croquette, sometimes dipped in fritter batter before being fried in deep fat.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Lard")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("bacon.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Larder")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to lard the surface or interior of a piece of meat or of a bird. (See Larding, "), _c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter04"
    }
  }, [_vm._v("Chapter IV")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#page_58"
    }
  }, [_vm._v("page 58")]), _vm._v(".)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Lardon")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a small slice of fat bacon used for larding.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Liaison")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("an element used for the binding together of a sauce, soup, or other liquid; it may be a roux, white, blond, or brown, beurre manié, egg yolk and cream, fécule or blood.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Macécioine")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("vegetables cut in even-sized dice, or fruits evenly divided.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Macérer")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to macerate: to soak a fruit in liqueur. The same process used for fish or meat is called "), _c('i', [_vm._v("mariner")]), _vm._v(" (q.v.).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Manier")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to manipulate butter to be used in pastry-making; to make beurre manié.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Mariner, marinade")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to steep meat, fish, or vegetables, before they are cooked, in an acidulated liquid containing vegetables and herbs (a marinade), which gives flavour and makes meat more tender.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Marmite")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a stock-pot of earthenware.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Mask")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to coat with sauce.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Menu")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("bill of fare.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Mijoter")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to cook gently.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Mirepoix")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("the preparatory foundation for a braise, sauce, or ragoût: vegetables cut in dice, diced fat bacon, gently cooked in butter.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Monter")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to increase, by beating, the volume of a substance or a sauce.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("Mouiller")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to add liquid to a dish in order to cook it; "), _c('i', [_vm._v("à court mouillement")]), _vm._v(", with little liquid.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Mousse")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a light mixture, savoury or sweet, which can be hot, cold, or iced.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Napper")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to coat with sauce.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Navarin")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a stew of lamb or mutton.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Noisettes")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("small rounds of meat taken from lamb or mutton cutlets; beurre noisette, nut-brown butter.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Pailles")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("straws: fried potatoes or cheese-straws.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Pain grille")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("toast.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Panache")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("with bands or stripes of different colours; salade panachée, made of several ingredients.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Panade")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("paste of flour and butter and a little liquid, or of soaked crumbs, used as foundation for croquettes or soufflés.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Papillotes")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("literally curl-papers: paper cases in which food is cooked or served.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Passer")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to sieve, strain, or put through a tammy cloth.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Pâte")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("dough or pastry.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Pâté")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("pie; patty case; raised pie or savoury mixture of game, liver, etc.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Pâtisserie")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("pastry made by a pastry-cook, i.e, delicate and attractive in appearance.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Paupiette")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a fillet of raw fish, or a thin slice of meat, spread with farce, rolled up, tied, and cooked.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Piqué")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("larded.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Plat")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("dish.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Pocher")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to poach.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Pot-au-feu")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("traditional beef broth.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Poussin")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("baby chicken.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Praline")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("flavoured with almond rock.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Purée")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a vegetable or other soup put through a sieve, or a sieved substance.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Quenelles")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("farce of meat or fish made into small oval shapes, poached, and used as a garnish or served as a dish.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Rafraîchir")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to refresh: to pour cold water over vegetables, fruit, or meat after they have been blanched.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Ragoût")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a stew.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Ravioli")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("small squares or triangles of nouille paste enclosing a savoury mixture, boiled and served with a sauce.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Réchauffé")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a reheated dish, made with previously cooked food.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Réduire")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to reduce by rapid boiling.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Relevé")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("remove: a course consisting of a large fish, a dish of venison or hare, or a joint.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Renversé")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("turned out from a mould on to a dish.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Rissole")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("minced mixture, usually of meat, enclosed in pastry and fried in deep fat.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Rissoler")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to colour light brown in hot fat.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Rôti")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("roast: a course of meat, poultry, or game, plainly roasted.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Roux")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("hot butter or fat mixed together with flour and used as one of the liaisons; may be white, blond, or brown.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("Ruban")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("ribbon: to beat to the ribbon is to beat yolks and sugar together until they fall like a ribbon from the spatula or whisk.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Saignant")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("underdone: almost raw.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Salamandre")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("salamander: used red-hot to brown the surface of a dish.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Salmis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("game stew.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Salpicon")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a mixture used to make croquettes, rissoles etc., made of diced chicken, veal, game, sweetbreads, mushrooms, truffles, etc. Also used to fill vol-au-vents, bouchées, and so on.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Sauter")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to cook in hot fat, oil, or butter by tossing in sauté pan.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Socle")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a pedestal of rice, bread, ice, etc., often not to be eaten, made to support an ornamental dish.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Soubise")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("purée of onions, sometimes mixed with a béchamel sauce.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Souchet")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a fish dish served in a soup-plate, made with vegetables and herbs and cooked in salted water.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Suer")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to sweat: to cook slowly in a covered pan.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Suprême")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("choice pieces of chicken, or of fish; a delicate sauce.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Tamis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("sieve or tammy cloth.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Tartine")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a slice of bread and butter.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Timbale")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a mixture cooked in a high mould.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Tournedos")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("beef fillet.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Tourner, i.e. to turn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(a) to give a turn in pastry-making: that is, to fold and roll.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(b) to cut vegetables in an oval shape or like olives.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("(c) to stone an olive by taking off the flesh in a spiral, and then reforming the olive.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Tourte")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a shallow open tart.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Travailler")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to work: to mix a paste so that all its elements are combined; to reduce a sauce by rapid boiling in an uncovered pan, stirring and beating meanwhile so that the surface is kept smooth.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Tutti-frutti")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a mixture of fruits.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Vanner")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("to stir a sauce after it has been cooked until it is cool, so that no skin forms, and its texture remains uniform.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Velouté")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("one of the foundation sauces, usually made with meat stock.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Vol-au-vent")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("a case of puff pastry, large or small.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Zest")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("the thin coloured skin of an orange or lemon used to give flavour; very thinly pared without taking any of the bitter white pith. Also the oil extracted from the skin with loaf sugar. See "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#page_40"
    }
  }, [_vm._v("page 40")]), _vm._v(".")])])])])])])]), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "h1.1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("TABLES OF WEIGHTS AND MEASURES")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('p', {
    staticClass: "h4"
  }, [_vm._v("French Weights and Measures")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The following table is approximate only. 1 oz = 28.352 grammes, but for practical purposes it is here taken as 25 grammes.")]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_51.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "h4"
  }, [_vm._v("American Measures")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td1"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  }, [_vm._v("An American pint")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td1"
  }, [_vm._v("= 16 fl oz")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  }, [_vm._v("An English pint")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td1"
  }, [_vm._v("= 20 fl oz")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  }, [_vm._v("An American tablespoon")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td1"
  }, [_vm._v("= 8 fl oz")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  }, [_vm._v("All American spoon measures are a flat spoonful")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  }, [_vm._v("An American tablespoon")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td1"
  }, [_vm._v("= 3 flat teaspoons")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-tdb"
  }, [_c('i', [_vm._v("Weight of 1 American Cup")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-tda"
  }, [_c('i', [_vm._v("Weight of 1 American Tablespoon")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  }, [_vm._v("Flour")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  }, [_vm._v("115g/4½ oz")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td2"
  }, [_vm._v("15g/½ oz")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  }, [_vm._v("Sugar")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  }, [_vm._v("200g/7 oz")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td2"
  }, [_vm._v("20g/¾ oz")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  }, [_vm._v("Butter")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td"
  }, [_vm._v("200g/7 oz")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-td2"
  }, [_vm._v("20g/¾ oz")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("Oven Temperatures")]), _vm._v(" "), _c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_51a.jpg"
    }
  })])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("N.B. Most modern electric stoves are fitted with thermostatic oven controls. The control knob may be set to the temperature required and a light shows when the oven is turned on; when the required temperature has been reached the light automatically goes out.")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("For those stoves which are not fitted with this device, the following scale may be useful:")]), _vm._v(" "), _c('div', {
    staticClass: "tablea"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Slow:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("Switch on at high for 7-10 minutes, then turn to slow.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Moderate:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("Switch on at high for 12-15 minutes, then turn to moderate.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para"
  }, [_vm._v("Hot:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td-para1"
  }, [_vm._v("Switch on at high for 20-25 minutes, and leave.")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It should be noted that some stoves heat up more quickly than others, so that the above notes can only serve as a guide and should not be taken too literally.")])])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  })])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter04"
    }
  }, [_c('p', {
    staticClass: "ch-num"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("IV")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('p', {
    staticClass: "ch-titlea"
  }, [_vm._v("Kitchen Processes")]), _vm._v(" "), _c('p', {
    staticClass: "ch-subtitle"
  }, [_c('i', [_vm._v("Roasting-Grilling-Sautéing-To flambé with wine and brandy-Braising and Stewing-Marinading-Larding-Barding-Boiling-Simmering and Poaching-Steaming-Bain-marie-Frying-Tammying-Boning")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Notes on cooking processes divorced from actual recipes make dull reading. The young cook will hardly be tempted to read this chapter; nevertheless, time will be saved in the long run if she makes herself familiar with the general principles involved, and the recipes which follow on for fish, meat, game, and poultry will assume a more familiar air.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("ROASTING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The days of real roasting are gone by: no more roasting-spits and jacks, no one with time to turn them and to baste unceasingly, not even the little Dutch oven to hang on the bars of an open range, in which to cook the smaller birds; even if one could find such a utensil and just use it modestly to grill bacon as we used to do in my young days, where should we find the open range, or if we did, think how we should be accused of roaring away the fuel! No! What we do nowadays in the name of roasting is to bake, really to bake, but as basting is part of the process we miscall it roasting.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For this the oven should be hot, an average temperature of 230°C/450°F/gas 8, with certain exceptions noted in the recipes. The fat is heated in the baking pan, the meat put in, and basting carried out at regular intervals. Cooking according to the size of the joint, allow 10–15 minutes per 450g/lb. for a small joint, 20 minutes for a large one.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Some cooks set the meat on a grid in the pan, and this is good when potatoes are to be cooked with the meat, and it was a common custom when a Yorkshire or suet pudding was cooked with the joint. Potatoes should be put in approximately three-quarters of an hour before the meat is done, and the same amount of time should be allowed for a pudding cooked in this way.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To baste.")]), _vm._v(" Lift the tin from the oven, place on a board on the table, and close the oven door. Spoon the hot dripping several times over the meat, using a basting-spoon. The object of basting is to keep the meat moist and juicy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Frothing.")]), _vm._v(" Flouring and salting of the surface of a joint to give additional crispness is carried out during the last quarter of an hour of cooking; a sprinkling of salt and a dredging of flour is made over the surface which is then immediately basted. This process applies particularly to game birds, pork, and mutton. This is known as frothing.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("POT ROASTING")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This is a method of cooking suited to meat which is on the tough and dry side. The method is simple: in a heavy saucepan heat a spoonful or two of dripping, add an onion stuck with one or two cloves and a bay-leaf. Put in the joint, baste, and cover tightly. Cook over very low heat or in the oven, allowing approximately 30 minutes to the pound.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("GRILLING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This simple but excellent method of cooking is less good now as one is so rarely able to use an open fire, for perfect grilling is done over red-hot coals or over a charcoal grill. In the United States one buys such grillers for cooking in the open air, but nowadays most of our grilling is done with gas and electric grills.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The procedure requires a preliminary searing of the surface of the meat to keep the juices in, and continued cooking just long enough to achieve the degree of grilling required. The process, calling for strong radiant heat, requires that the heat shall be strong at the very outset. A fire is allowed to burn through until quite red, and a gas or electric grill should be heated until red-hot. The meat, to begin with, is put close to the heat, having first been brushed over with oil or butter. Each side having been cooked for the requisite time, gauged not by the weight but by the thickness of the piece of meat or fish, the griller may be put lower down, farther away from the heat, for any final cooking that may be called for. The turning of the meat should be done with a pair of tongs, or with two spoons, but never with a fork.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A grilled steak may be called for in one of three degrees of cooking. Some people like to have it brown on the outside, but practically raw inside; others like it well seared on the outside, and cooked throughout till pinkish red in colour and juicy; this is described as being cooked "), _c('i', [_vm._v("à point")]), _vm._v(". When it is required to cook the steak to a further degree than this, the last few minutes of cooking are carried out an inch or two lower, away from the hot grill.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For white meat, veal, pork, or fish a more moderate heat throughout is required. These meats require thorough cooking to make them digestible, and if the fire is too strong to begin with, the hard surface formed will prevent the heat from reaching the innermost part of the meat. Fish should be scored across if round, and cut down nearly to the backbone if flat, and it may be lightly floured except for salmon, herrings, mackerel, and mullet, which are oily fish and not likely to be too much dried by the heat of the grill. Then in every case the fish is brushed over with oil or melted butter. When the flesh comes readily away from the backbone, the fish is cooked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Here are some general points:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("1. Steak or cutlets must be cut thick, never less than an inch, and they may be marinaded in a little sherry or brandy or good olive oil; or they may simply be brushed over with clarified butter or oil.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("2. Salt should not be used as it will prevent browning and tends to harden the meat.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("3. The grill should be red-hot before the griller is placed underneath it. Raise the griller to within two inches of the meat to sear, and then, if further cooking is required, the griller may be lowered slightly for an extra last minute before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("4. Grills should be served at once. Tomatoes, mushrooms, etc., may be grilled to serve as an accompaniment. Maitre d’hôtel butter may accompany chops and kidneys.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MIXED GRILL")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("For mixed grill, cutlets, kidneys, sausages (especially chipolatas), tomatoes, bacon and so forth may be used. Start with the ingredient which takes the longest time to cook. Grill, for instance, the cutlet and ")]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("the kidney and follow on with the chipolatas and tomatoes. At the same time the mushrooms may well be sautéd on top of the stove. The dish should be garnished with watercress, and the juices from the griller poured on.")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("See fish chapter (")]), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter16#page_377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 377")]), _vm._v(") for the discussion of grilled herrings, mackerel, salmon, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To grill over a fire.")]), _vm._v(" Make the fire up beforehand so that a layer of red-hot coals is available. Open the top of the grate and heat the grill thoroughly. When a thick piece of red meat is to be grilled, it is a good precaution to have some red-hot cinders available to add to the fire if the heat dies down.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("To grill with a gas or electric grill.")]), _vm._v(" Make the grill red-hot before starting, lay the object to be grilled on the heated rack in the grill pan, and when moderate heat is required for the actual cooking, the gas or electricity may be turned down as the case requires.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SAUTÉING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The word "), _c('i', [_vm._v("sauter")]), _vm._v(" is used to indicate two methods of cooking. The first, pedantically correct, is a process by which meat is cooked in hot butter and/or oil, uncovered, in a sauté pan or "), _c('i', [_vm._v("sautoir")]), _vm._v(", which is a deep, straight-sided frying-pan.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The second process to which this term is applied involves a preliminary cooking in this way which is followed by further cooking in a small quantity of liquid.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Examples of the first method may be found in tournedos, escalopes, and some chicken dishes. The second method is often called for when meat requires slightly longer cooking, for example for rabbit, veal sauté, kidneys, and certain chicken dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the case of vegetables, some of these are sautéd by the first method only, in hot butter from start to finish, others, in particular root vegetables, are previously cooked before being finished in the sauté pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("The pan.")]), _vm._v(" The correct pan is a deep, straight-sided pan called a "), _c('i', [_vm._v("sautoir")]), _vm._v(" or sauté pan; it should be heavy, and the straight sides are from 6.5-9cm/2½-3½ inches deep. While it is convenient to use a frying-pan for vegetables, the "), _c('i', [_vm._v("sautoir")]), _vm._v(" is more convenient for meat, because being deeper it will more readily hold the necessary gravy or sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Fat.")]), _vm._v(" Clarified butter, or a mixture of clarified butter and the best olive oil, are the correct frying media for this purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Liquids.")]), _vm._v(" The recipes indicate where white wine or red wine is required, and this, together with a rich stock, gives the proper results. It is required that the liquor shall reduce greatly during the simmering and finishing of the sauce, so that it acquires the texture of a demi-glace, becoming syrupy in consistency and clear in appearance.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here are the stages of cooking for a sauté in order:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("1. Birds or rabbits are jointed and the meat neatly cut up or sliced.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("2. The pieces are browned on both sides, over moderate heat, in the fat; they must be laid flat on the bottom of the pan, and not superimposed one over another. The time required for this process varies according to the dish in hand. Chicken, rabbit, partridge, and chops may take 25 minutes, while escalopes de veau will call for much less, perhaps for 5 minutes. Actual times are given in the recipes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("3. After this cooking in the hot fat, some recipes indicate that meat is to be flambéd with brandy or sherry (see note on "), _c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#page_56"
    }
  }, [_vm._v("page 56")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("4. If the meat is to be cooked by the first process only, that is to say entirely in the fat, it is dished when ready, and the process known as ‘to déglacer’ carried out, that is to say the pan is swilled out, after any remaining fat has been poured off, with a liquid, sherry, white wine or red, stock and so forth, in "), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("order to dissolve the sticky glaze which is left on the bottom of the pan. This liquid is then reduced a little and may be thickened in ways indicated in the different recipes. When the right consistency is reached the gravy is strained, and whatever garnish is called for in the recipe is added.")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("5. When further cooking is necessary, after this preliminary process of browning in hot fat, the pan is déglacéd in the way described with sherry or wine, though in this case the meat is usually left in the pan while the process is carried out, then barely covered with the liquid and simmered for the time given in the recipe. This process may be carried out on the stove top or in the oven.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("6. When cooked the meat is dished; the gravy is rapidly reduced, the necessary liaison and garnish added, and the whole spooned over the dish.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Typical examples of the second method of making a sauté are:")]), _vm._v(" "), _c('div', {
    staticClass: "disp-quote-a"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Poulet sauté à l’Estragon")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Lapin sauté Chasseur")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Sauté de Veau Marengo")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Rognons sauté Turbigo")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("These will be found in their proper chapters.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TO FLAMBÉ WITH WINE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This operation is called for in certain braises, sautés, and ragoûts. It has for its object the removal of any rough taste or harshness in the wine, and it burns out the alcohol. It is a process usually applied to vin ordinaire and the cheaper types of red wine, and it is not normally carried out when a vintage wine is called for in the recipe.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The wine is put into a saucepan, brought to the boil, and lighted. Boiling is continued until the flame burns out; the wine is then ready to add to the dish, or it may be added while flaming. Sometimes a recipe calls for reduction after flaming.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TO FLAMBÉ WITH BRANDY (OR SHERRY)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("While the burning has the same result in that the alcohol is burnt out, in this process the liquid is poured flaming over the object being treated. The slight singeing of the surface of the flesh gives added good flavour. The brandy is heated in a silver spoon or in a very small saucepan (in which case the pan is shaken briskly), set alight, and poured over the birds or meat in the pan.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BRAISING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Braising is a method of cooking applied to meat, fish, game, poultry, and some vegetables; it involves the application of both top and bottom heat, and the process is long, rendering the object cooked extremely tender, so tender and melting that it can be cut with a spoon. While choice meats so cooked are among the classic dishes, it is obvious that this method has its particular value when the cheaper cuts of meat, the older game and poultry are concerned. It is excellent for thick cuts and whole fish, although English cooks seldom adopt this method; braised whole codling, for instance, is excellent. In the appropriate chapters will be found details of suitable joints for braising.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("This process, which is really a combination of steaming and baking, is carried out, in France and in big kitchens, in a proper "), _c('i', [_vm._v("braisière")]), _vm._v(", a pan with a concave lid which will hold hot charcoal or, in more modern fashion, boiling water. In domestic kitchens a heavy saucepan or cocotte is used, thick enough to ensure that the heat shall not become too fierce. Although for a part of the time cooking may be carried ")]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("out on top of the stove, for the most part it is done in the oven.")])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("Meat for braising, particularly if taken from a lean cut, is sometimes larded and barded (see ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#page_58"
    }
  }, [_vm._v("pages 58")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#page_59"
    }
  }, [_vm._v("59")]), _vm._v(") and sometimes subjected to a preliminary marinading (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter23#page_635",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 635")]), _vm._v(") which improves both flavour and texture.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The following gives an outline of the method when a whole joint is to be braised:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("1. Heat the fat, brown the meat on all sides, then remove from pan.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("2. Lay one or two slices of bacon on the bottom of the pan (this is optional, but improves the flavour); on this arrange a bed of sliced or diced root vegetables to the depth of 1–2cm/½–1 inch, the vegetables chosen in such proportions that no one flavour will predominate. Allow these to sweat gently in the fat with the lid on until softened, without browning, about 10–15 minutes. This mixture of vegetables is called a mirepoix and is not usually served with the finished dish.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("3. Season vegetables, lay the browned meat on them, moisten with the liquor called for in the recipe, wine or stock or both, which should come a quarter or more up the side of the joint. Add bouquet, cover, and allow to simmer anything up to an hour on top of the stove and then for 2–3 hours in the oven. The time depends, of course, on the size of the joint and is indicated in the recipe.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("4. When the meat is cooked the gravy is strained, skimmed with a metal spoon of all fat, reduced if necessary, and poured over the meat in a deep dish with the appropriate garnish. In some cases the straining is done half way through the cooking, and vegetables added, this time to be served with the meat. In this way one ensures that the garniture does not get overcooked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Braising is a method of cooking frequently used for ragouts. In this case the meat is cut up into squares 4–5cm/1½–2 inches in size; these are browned, the vegetables then added and browned also on a lower heat, a small quantity of flour stirred in, and the whole moistened with stock or wine. The pan is then put into the oven until the meat is thoroughly tender and the gravy rich and thick.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The word salmis indicates a mixture of two processes, roasting and braising, the roasting being done first for a short time so that the flesh is "), _c('i', [_vm._v("saignant")]), _vm._v(". The sauce is added to the meat, together with all the juices from the bird. It is a suitable process for young birds.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("STEWING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("There are two main kinds of stew, white and brown, e.g. beef ragoût, a brown, Irish stew, a white stew. The chief difference between a brown stew and a braise is that the stewing may be carried out on top of the stove, but as it may also be done in the oven, it will be seen that the margin between certain braises and stews is narrow. The meat is cut up and, although vegetables enter into its composition, a stew does not involve the meat being cooked on a mirepoix. There is a certain elasticity about these terms, but this roughly marks out the difference between the two processes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The principles are slow, gentle cooking either on top of the stove or in the oven; enough liquid to cover meat and vegetables; herbs and seasonings to flavour. Vegetables and herbs vary, of course, according to the main ingredient. Thickening is achieved by the use of potatoes or barley, as in the case of Irish stew, or by the addition of a small quantity of flour added in a brown stew after the meat has been coloured. In some cases rice or small suet or force-meat dumplings are added for both thickening and flavour.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Meat for stewing is usually from less good cuts; it should have a small quantity of fat; if it is entirely lean extra care has to be taken in its preparation or it may become hard and dry. Suitable cuts of meat for both braising and stewing will be found in the appropriate chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("BROWN STEW OR RAGOÛT")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Choose a thick aluminium or iron casserole or stew-pan, that is to say a shallow pan, but not a frying-pan, which is too shallow (earthenware may well be used for this, but then the meat, vegetables, and flour must first be browned in a metal pan). The meat is trimmed and cut in large squares and a small proportion of fat left on. The pieces are browned in hot dripping or oil, 3 minutes on each side; a common fault is to over-brown, and then the meat becomes dry and chippy and the gravy too dark in colour. The meat is now taken out and any fat beyond a good tablespoon poured off, the heat lowered, and the vegetables browned lightly. Flour, ½–1 tablespoon, is now added and allowed to brown. The meat is returned to the pan with liquor, bouquet, and seasoning, and any other ingredients called for in the specific recipe. The whole should now be gently simmered on top of the stove or in the oven. Navarin is the French word for a mutton ragoût or stew.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("WHITE STEW")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("This is made in the same way as a brown stew except that the meat is not coloured in the hot fat. Irish stew is an example, as is also a blanquette. The latter is finished with a sauce velouté made from the liquor in which the meat is cooked. The following preliminary preparation has the effect of whitening the meat and removing any strong flavour. It may, in particular, be adopted for such cuts of meat as scrag or middle neck of mutton, and breast of veal, also for rabbit. Soak the meat, after it has been cut and trimmed, for some hours, preferably overnight, in salted water containing a little vinegar, approximately 1–2 tablespoons vinegar to 3 or 4 quarts water and a dessertspoon of salt. The effect of this is to whiten the meat and to remove any strong flavour. The meat is then rinsed and dried with a cloth. It is now put into enough water to cover it by about an inch or two and brought slowly to the boil. During this time ½ cup cold water may be added to facilitate the rising of scum to the surface, and careful skimming is carried out; this clears the liquid and helps to whiten the meat. When boiling-point is reached flavouring vegetables and salt are added and the meat is simmered for the required time. It is important to emphasize the word simmer, for if the water gallops the meat will immediately be toughened. This cooking is always done on the top of the stove. Blanquette of Veal (see recipe on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter17#page_504",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 504")]), _vm._v(") is an example of a stew prepared in this way.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A goulash is an Hungarian stew in which paprika is sometimes used for flavouring, though this is not invariably the case.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MARINADING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("See "), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XXIII")]), _vm._v(", Devils, Barbecues, and Marinades, "), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter23#page_629",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 629")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("LARDING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Larding is the introduction of thin strips of fat bacon into the surface of meat or game with the object of supplying surface fat; it is a process used therefore for lean meat and the drier birds, as, for example, fillet of beef, veal, guinea-fowl, etc. This preparation is sometimes carried out by the supplier, or it can be done at home. It has importance since it adds considerably to the quality of certain dishes. If for instance one is cooking a proper filet de bœuf rôti, one will try to do the whole thing properly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Larding means the threading through, on the surface of the meat, of thin strips of solid bacon called lardons. These are cut from a small solid block of fat bacon and are occasionally marinaded and flavoured before being used. As well as adding fat, they keep the meat moist and give extra flavour. One buys from "), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("the poulterer, provision merchant, or delicatessen shop a small block of prepared bacon, entirely fat and salted; this, blanched and kept in a cool place (for it is easy to cut when cold and hard), is ready for cutting into lardons. (If the larding bacon is strongly salted, and only if this is so, it may be blanched by being put into cold water, which is brought slowly to the boil; the bacon is boiled gently for 5–10 minutes, then plunged into cold water, drained, and dried. )The rectangle of fat is put on a board, rind side downwards, then, with a sharp knife dipped into hot water, cuts are made right down to the rind in regular slices of "), _c('span', {
    staticClass: "entity"
  }, [_vm._v("⅛")]), _vm._v("-¼inch thick; next, horizontal slices of the same thickness are made; the length of the block of fat, which may be from 5cm/2 inches upwards, represents the length of the lardons.")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("A larding-needle is used to introduce the lardons and to pull them through the surface of the meat. This needle is first plunged shallowly into the meat, a very thin morsel only being taken up; then the lardon is introduced into the split eye of the needle and pulled in a direction away from yourself. Repeat the process with the lardon left in the meat, working from right to left and leaving regular gaps, but each lardon almost touching the next. Larding is done across the grain of the meat.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BARDING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This is a process more commonly carried out to-day than larding, and in place of the special larding bacon an ordinary fat rasher may be used. This is securely fastened with string over the breast of the bird or the top of the meat in question, and it is employed for dry birds or lean, dry meat.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BOILING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Boiling is a term sometimes carelessly applied in cooking, for instance we talk of boiled beef, boiled fish, boiled fowl, when we really mean simmered beef, simmered fish, and so forth. If meat is subjected to fast boiling throughout the cooking process it becomes tough, ragged, and retains little nutritive value. It may be brought to boiling-point, 100°C/212°F, even kept at this temperature for a short time, but the subsequent cooking is carried out at a lower temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Boiling is indicated as a short preliminary process in many recipes; for example, in the case of some meats the preliminary process of boiling is required to seal the surface in order to retain the juices; while, as an opposite example, salt meat will not be so sealed, because it is desirable to draw out and dissolve some proportion of the salt. Boiling is also required for certain of the heavier types of pudding, and for green and other vegetables. Boiling-point is a temperature essential for syrups, jams, jellies; and infusions. In addition, liquid is allowed to boil strongly when its reduction is required, when, in other words, water is to be driven off in the form of steam, rendering the ingredients, in consequence, more concentrated.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SIMMERING AND POACHING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A liquid is said to simmer when the movement on the surface may be described as a gentle agitation with possible bubbling at one point, but not the pronounced rapid bubbling and strong movement that starts when boiling-point is reached. Simmering temperature may be from 85-93°C/185-200°F, but a cook is generally guided by the appearance of the liquid rather than by a thermometer.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Poaching")]), _vm._v(" is a term used to indicate a gentler cooking still; the water or other liquid should show only the gentlest quivering movement and the temperature should be between 77-82°C /170-180°F. Either process may be carried out, according to the dish in hand, on top of the stove or in the oven. Poaching is a process used for materials of delicate consistency which might be spoiled if subjected to strong heat. It is used primarily for eggs, fish, meat, vegetable creams, gnocchi, etc. The recipe usually indicates ")]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("whether the process is to be carried out in the oven or on top of the stove, but as a general rule eggs, gnocchi, and quenelles are poached in water on top of the stove, and fish, whole or filleted, whether in wine, water, or fish stock, is usually poached in the oven. Meat, fish, and vegetable creams, cooked in moulds, and custards, plain baked, or renversées, may be said to be poached when they are set in a tin of boiling water, put in the oven, and cooked gently until set.")])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("STEAMING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Steaming is a long, slow, and thorough method of cooking in which food is directly exposed to and surrounded by concentrated steam. This process is carried out with a special utensil. The steamer itself has a perforated base which fits tightly over a saucepan, and it is covered with a well-fitting lid. This method is employed for puddings, certain meat, fish, and vegetable creams, and potatoes and some other vegetables. The points to be observed in steaming are that the water in the saucepan should never be allowed to go off the boil, because cooking then ceases; it is therefore necessary to have at hand a kettle of boiling water for replenishment, which may be required once or twice during the cooking. The lid should fit tightly and it is inadvisable to remove it at frequent intervals for inspection. If it should become necessary to look at the contents of the steamer the lid should be lifted off quickly and immediately turned upside-down, so that the water condensed inside it does not drip on to the object being cooked, an occurrence which may give an unpleasant surface, for instance, to a suet pudding. The basin or mould which is set in the steamer is covered with grease-proof paper, and this may be pleated down the centre to allow for expansion.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To facilitate the removal of the contents of a steamer it is a good plan to arrange a strip of cloth under the basin or mould, bringing the ends of the cloth over the edges of the steamer. It is also necessary to select a basin which fits easily into the steamer and allows reasonable space for the steam amply to surround the basin.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A method of gentle steaming is to place the tin or mould on a thick piece of paper in a saucepan, with water half way up the side of the mould; the pan, with the lid on, is then stood over the heat until the water boils; it is then drawn aside and only a quarter of it is allowed to stand over the heat. If the contents are to be turned out of the mould it should be allowed to stand for a few minutes after it is taken from the saucepan. This more gentle method is suitable for delicate meats, fish creams, and set custards, and it is an alternative to cooking "), _c('i', [_vm._v("au bain-marie")]), _vm._v(" in the oven.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fish for invalids is sometimes cooked between two plates over a pan of boiling water. This too is referred to as steaming, but is also a gentler process. More elegantly this may be done with a bell-glass over the plate, the thick glass cover that is used for chicken or mushrooms "), _c('i', [_vm._v("sous cloche")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("COOKING AU BAIN-MARIE OR IN A HOT-WATER BATH")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("This is a process designed to protect food from strong direct heat, either on the stove or in the oven. The food is insulated from fierce, dry heat by being surrounded by hot water. The words "), _c('i', [_vm._v("au bain-marie")]), _vm._v(" call for a little explanation. The kitchen utensil called a bain-marie is properly used for sauces and liquids which are to be kept hot but must not be allowed to reboil, as for instance certain sauces which have been thickened with egg or cream. This useful piece of equipment, more often seen in the kitchens of catering establishments than in English homes, consists of a large shallow pan containing an array of small saucepans of different sizes. When we speak of cooking by bain-marie we really mean cooking in a water bath. This is usually done in the oven in order to get top heat. To cook in this way the mould or basin containing the ingredients is placed in a baking-tin of water; the water is brought up to the ")]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("boil, and the tin then put in the oven. This method is used for such dishes as custards, crème caramel, and vegetable and delicate fish creams, and it is a slightly drier method than steaming. Cooking in a double boiler, a method much advocated in American cookbooks, is another example of cooking by bain-marie, and it is applied to custards, sauces, frostings, etc.")])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("FRYING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Frying is cooking in hot fat and it is done by two methods, shallow and deep fat frying. Shallow frying is carried out in a frying-pan with enough hot fat to come half way up the object to be cooked, or in some cases the fat may be much shallower. Deep fat frying is done in a deep saucepan, the object to be fried being submerged in the fat or floated on the surface, as the case may be. The following rules are common to both methods:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("1. The fat should always first be heated to the degree indicated in the recipe, the heat being judged sometimes by the blue vapour or smoke rising from the centre of the pan, and sometimes by a test made with a small piece of bread; sometimes the heat is tested by a thermometer.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("2. Moderation should be shown in the number of objects fried at one time. If too much is put into the pan at once the fat is cooled, and this may result in greasiness and heaviness.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("3. For each batch of frying the fat must be reheated to the required degree, and in some cases it is necessary to strain the fat between each batch of frying to remove any crumbs or other objects which have become burnt.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("4. The food should always be thoroughly drained on a wire rack or on crumpled kitchen paper.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("5. When frying is finished the fat should be strained through muslin into a bowl when it is cool, and the pan then wiped out first with crumpled paper and then with a dry cloth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following rules are applicable to "), _c('i', [_vm._v("shallow fat frying")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("1. Choose a heavy type of pan and heat well before putting in the fat.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("2. The fat to be used may be clarified fat, dripping, lard, butter, oil, or oil and butter mixed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("3. Food cooked in this way must be turned when brown on one side, and care taken not to pierce the object during the cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("DEEP FAT FRYING")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("This is a more economical method of cooking, for the fat used can be strained for repeated use. The temperature of the fat becomes so high that no flavour of the food that has been cooked remains in it, whereas in shallow frying this is not always so. For this operation a deep, thick iron or aluminium pan is required, preferably with a basket which fits it. If too thin a pan is used, the fat heats too quickly and is liable to boil over and catch fire. It is necessary to have the pan deep enough to hold sufficient fat to cover the food completely. Particular care is required in this operation. If the fat bath is overfilled, and the food put into it causes the fat to overflow the sides, serious accidents may result. If wet objects are introduced into the fat they cause fierce crackling and spitting, and again sometimes cause the fat to overflow its bounds. It should always be borne in mind that this highly heated fat is extremely inflammable. The fat should be melted first over gentle heat and then submitted to greater heat and brought gradually to the right temperature for cooking. It should be closely watched while coming up to cooking temperature. Where much cooking of this type is to be done, a frying thermometer should be employed. This registers up to 204°C/400°F. It should be stood in a pan of hot water and carefully dried before ")]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("being put into the frying bath. The hot water warms the glass so that there is not too great a shock when it is plunged into the fat, which may be well over 100°C/212°F.")])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Fats saved from the skimming of stocks and so forth are not recommended for deep fat frying, but may, at need, be added to other fats after clarifying. The following rules sum up the points to be observed in deep fat frying:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("1. The pan should be thick iron or aluminium and never too thin; it should be ample in size and have, if possible, handles at each side which make it easier and safer to lift. It should be fitted with a frying basket in which the food to be cooked may be laid before immersion.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("2. A wire skimmer or spoon should be at hand, so that crumbs or morsels of food detached from the main object cooking may be carefully removed; otherwise, remaining in the fat, they will burn and give a dark colour and bitter taste.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("3. Suitable fats are clarified dripping, lard, or lard and dripping mixed, and oil (vegetable oil is excellent, especially for dishes cooked "), _c('i', [_vm._v("au maigre")]), _vm._v("). A mixture of beef suet and lard is excellent. Two pounds of suet to one pound of lard is a suitable mixture. The fat in the pan must come half way, or possibly two-thirds of the way, up the side, in order that the food fried may be totally immersed or can float easily as the case requires.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("4. The fat must be perfectly clean and free from sediment and should always be strained after use. It may be used many times, provided it does not get overheated and burnt and that reasonable care be taken of it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Nearly all food requires a protective coating before being cooked in deep fat. This serves to keep in the moisture and to prevent the food from bursting under the high temperature; exceptions to this are potato chips, ribbons, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("5. Great care must be taken not to allow water or other liquid to get into the fat.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("6. Great care must be taken in moving the pan of hot fat on the stove, as it is highly inflammable.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TEMPERATURES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Frying temperatures vary from 165° to 204°C/330° to 400°F. When frying food already cooked, such as fishcakes, all that is required is that the fat shall give a crisp coating and that the inside shall be heated through. Therefore in these cases a hotter temperature may be employed. But where the food has to be cooked through, as well as acquiring a crisp outside, a somewhat lower temperature will be called for, because the duration of cooking is longer. It is important to test the temperature. With a frying thermometer the temperature is easily judged, but in the average kitchen it is more usual to test in other ways. When the fat is at its hottest, i.e. 199°-204°C/390°–400°F., a blue haze will rise from the surface. No other indication is necessary, and the fat is ready for small croquettes, fritters (other than apple), fillets of whiting, whitebait, and smelt, croûtons, game chips, and the final frying of French fried or chip potatoes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For other foods the following test may be carried out:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("1. Take a small cube of bread such as a soup croûton and drop it into the fat bath; if the bread sinks to the bottom and does not frizzle at all the fat is not ready for use.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("2. If, however, the bread frizzles gently, the fat is ready for beignets and the first frying of potatoes. This is just before haze point.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("3. At haze point a light blue haze rises from the surface. The fat is now at moderate heat and the cro ton will brown in about a minute. Large croquettes, rissoles, large fillets of fish, apple fritters, etc., may now be fried.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("The following table of temperatures is intended to be a general indication; the recipes themselves will give more detailed instructions.")])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("FRYING TEMPERATURES")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hangb"
  }, [_vm._v("Choux paste (beignets soufflés, etc.)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hanga"
  }, [_vm._v("165-190°C/330-375°F (rising gradually, see recipe, "), _c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter30#page_812",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 812")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hangb"
  }, [_vm._v("First frying of potatoes")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hanga"
  }, [_vm._v("165-171°C/330-340°F")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hangb"
  }, [_vm._v("Croquettes, rissoles, large fillets of fish, fruit fritters, cutlets")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hanga"
  }, [_vm._v("182-199°C/360-390°F")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hangb"
  }, [_vm._v("Second frying of potatoes, small fritters, croûtons, etc.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hanga"
  }, [_vm._v("190-200 °C/390-400°F")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("COATINGS FOR FRIED FOOD")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Certain foods, if put directly into boiling fat without a coating of some kind, would disintegrate and the fat would boil over. If fish were put straight into hot fat, the agitation brought about by the introduction of the wet surface would cause the fat to boil up and overflow the sides of the pan. (Potatoes which have been soaked should be drained and thoroughly dried in a cloth before being introduced into hot fat.)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The simplest coating-of all is seasoned flour and milk. The food to be fried is first brushed over with milk, then tossed in a cloth or a sheet of paper in flour mixed with salt and pepper, to which may be added flavourings in the form of grated lemon rind, chopped parsley, or other herbs.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("Flour, beaten egg, and dried white breadcrumbs is another and usual coating (see Egging and crumbing, ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03"
    }
  }, [_vm._v("Chapter III")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#page_33"
    }
  }, [_vm._v("page 33")]), _vm._v("), and a third method, suitable for fillets of fish and fritters both sweet and savoury, is to dip the food to be fried into batter. It should be noted that when batter is used as a coating the frying basket is not used, because scraps of the batter would cling to the wire and, exposing the raw surface of the food, possibly cause an accident, besides allowing the fat to penetrate the food. Moreover the particles so separated would become burnt and cause burning of the fat, spoiling both colour and flavour.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Certain foods for deep fat frying may be encased in pastry, which may be left plain or coated in egg and rolled in vermicelli (see recipe for rissoles, "), _c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter22#page_624",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 624")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("GENERAL CARE OF THE FAT BATH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("1. The fat should be allowed to cool and be strained through muslin into a clean, dry, enamel bowl. This should be done after every occasion of frying.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("2. It should be covered when cold, and kept in a cool place.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("3. The fat used should be perfectly clean (see instructions on clarifying fat, "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#page_34"
    }
  }, [_vm._v("page 34")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("OIL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This is more difficult to clean. It reaches a high temperature more rapidly than the solid fats and therefore may burn. It cannot of course be treated with water. The potato method is applicable, but must be carried out with care.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SOLID FAT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("To clarify solid fat, for example the trimmings of cutlets, beefsteak, etc., cut into small pieces, put into a roasting-tin, and set in a slow oven until all the fat is extracted and the pieces of fat brown and crisp; then cool slightly and press.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TAMMYING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("By this process certain liquids, such as the finer cream or velouté soups and sauces, which require to be "), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("particularly finely strained, are passed through a tammy cloth or a tammy strainer, whichever may be called for in the recipe. The process improves both gloss and consistency, and the use of the tammy cloth also helps to bind or amalgamate the liquid passed through it.")])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("The tammy strainer.")]), _vm._v(" This is made of gauze and is conical in shape. It should be reserved exclusively for the use for which it is intended. After use it should be washed immediately and thoroughly in clean hot water. If this is not done the gauze becomes clogged and is then very difficult to clean. This strainer is used for certain stocks, especially fish, velouté soups, the juice from the bones for a salmis, and for any sauce where fine straining and good finish is wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("The tammy cloth.")]), _vm._v(" This is a piece of special material of slightly rough texture, like a hard non-hairy flannel. In the absence of this a piece of coarse linen is sometimes used. Before use the cloth is scalded and wrung out in hot water. After use it is well washed in warm water, then scalded again and well dried before being put away. For use the cloth is laid over a bowl, the liquid to be tammied is poured into the centre, the edges are folded neatly over, then the ends are twisted in opposite ways until all the liquid has been forced through. This process is applied to velouté and cream soups where a particularly fine and velvety finish is required, and to such sauces as cardinal or nantua in which lobster or shrimp butter is added. The process is carried out when the sauce has been completed, and it is then carefully reheated before being served.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BONING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("For this process a small, sharp vegetable knife may be used.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TO BONE MEAT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Unless other instructions are given a small incision is made at the point where the bone is nearest to the surface, for example at the edge of the blade of a shoulder of mutton or at the edge of the chine bone of a loin or neck of lamb. The knife should be kept firmly against the bone the whole time and the flesh worked away in short, clean cuts. The fingers of the left hand should be kept well under the flap of meat being lifted, peeling it back gently from the blade of the knife. Generally speaking the object of boning is to make room for a force-meat or stuffing and the bone should be removed with a minimum amount of cutting, leaving as small a gap as is reasonably possible. In the case of a shoulder or leg of lamb, for instance, the space left by the removal of the bone should be as much like a pocket as is possible.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TO BONE GAME AND POULTRY")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It is not necessary to draw the bird before boning; the process is easier if this is not done.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("1. For a galantine when the flesh is to be rolled.")]), _vm._v(" The first cut is made down the centre of the back of the bird. The flesh is cut and worked off the bone in the way described above. When the leg is reached the bone is taken out from the thigh downwards. The working off is continued until the centre breastbone is reached, then the process is repeated on the other side from the back cut, working again to the centre. When all the flesh is loosed and ready to be lifted right off the carcass, care must be taken not to cut through the skin at the edge of the breast-bone where it is thin.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("2. When the bird is to be stuffed and reshaped.")]), _vm._v(" For this more stuffing is used and it is not easy to keep a good shape. Sometimes, to help to keep an attractive shape, the drumstick bones and wing pinions are left in. For this method start the boning at the wing joint and work the flesh backward towards the tail, working all round the bird, and turning the flesh and skin inside out. When all flesh is off the carcass the flesh and skin are turned back again and stuffed according to the recipe, then shaped and trussed as neatly as possible. After boning, the carcass is cleaned, washed, and broken up for making into stock with the giblets.")])])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  })])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter05"
    }
  }, [_c('p', {
    staticClass: "ch-num"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("V")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "ch-title2"
  }, [_vm._v("Soups and Soup‐making")]), _vm._v(" "), _c('p', {
    staticClass: "h1-x1"
  }, [_vm._v("I. SOUPS IN GENERAL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("R. H. and I both think it would be small wonder if young students thought soups and soup-making to be among the least interesting of culinary matters. In the last decade there have been some poor concoctions ladled out in the name of soup: quite enough to cause all interest in this course to die. We have passed through a period when we were short of materials, and we are still often short of time, and as a result what used to be a first-class item of food has deteriorated and is too often looked on as a mere fill-in.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the days when soup was Beautiful Soup I do not believe a Victorian music-hall audience would have appreciated that crack of the late Billy Bennett: ‘There were three kinds of soup, noodle, poodle, and cock-a-doodle. The soup was thrown in – it should have been thrown out.’ I am not sure if that is the exact wording, but it is near enough.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We cannot, and I doubt if we want to, go back to the heavy richness of some of the Victorian recipes, but there is a half-way house between those and some of the uninteresting mixtures one meets with to-day.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It will, we think, be more generally helpful, more in keeping with contemporary taste, if, contrary to usual practice, we leave the subject of the preparation of stocks, consommés, and soups which call for meat as a main ingredient till later in the chapter, and pay primary attention to soups in which vegetables play a main part, and to those which may suitably be made in small quantities and do not call for lengthy preparation.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But it would, we think, be a pity if in our anxiety to be practical we were to restrict ourselves entirely to utility models. There is no fun, no inspiration in that, so although due attention is paid to what must be, there will be found later on recipes for some party soups as well as for a few of the great classics.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In all circumstances, one point cannot be over-emphasized: whether the soup be rich or plain, for dinner-party or homely luncheon, the classic method should be followed. Short cuts, unnecessary omissions will give disappointing results. We all know the kind of cook who, on being given the recipe for some dish which we have liked particularly, has indicated immediately that she thinks the whole process quite unnecessary, the instructions too full of frills, and that she for her part could never be bothered with all that nonsense. We know also how often she fails to produce good food. I do assure you that no instructions are given for fun, for effect, to make it harder, or for any other reason than that it is by observing the details of preparation that one gets the best results.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To emphasize certain points in a practical way, I am using as an example the most simple recipe for a French potato soup, Potage Purée Parmentier, and after giving the ingredients and method I am taking the instructions apart and amplifying each one. To anyone with a little experience this may seem like making heavy weather over so small a matter, but a beginner may find it of use, and the instructions will serve as a model for other soups of a similar type.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("POTAGE PURÉE PARMENTIER")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb peeled potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 medium-sized onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 bay-leaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Liaison")]), _c('br'), _vm._v("1 egg yolk"), _c('br'), _vm._v("5 tablespoons cream"), _c('br'), _vm._v("croûtons")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("Slice the potatoes and onion finely and evenly, melt the butter in a stew-pan, add the vegetables, cover, and cook very slowly for about 7 minutes. The potatoes must on no account brown. When softened, draw the pan aside, add the bay-leaf and milk. Cover and simmer for 20 minutes. Then pass through a fine wire sieve. Return to a clean pan, season, reheat to boiling-point, whisk well with a sauce whisk, and add the liaison (see note on liaisons, ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06#page_116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 116")]), _vm._v("). Serve with an appropriate garnish.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This soup, containing butter, milk, cream, and egg, is moderately rich, but on "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_66"
    }
  }, [_vm._v("page 66")]), _vm._v(" there is another version of it which is simpler in procedure and is made principally with water or light stock and a small proportion of milk. It is possible, of course, to dilute the milk with water in the above recipe, but this sometimes causes the soup to curdle.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Here are the instructions taken apart and amplified so that they may be taken as a guide to the making of potages purées generally.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Instruction 1: Slice the potatoes and onion finely and evenly.")]), _vm._v(" The object of this is to facilitate the absorption by the vegetables of the butter. This is more thoroughly accomplished when the slices are evenly thin than when they are thick and uneven. Moreover the cooking process is completed sooner and more thoroughly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Instruction 2: Melt the butter, add the vegetables, cover, and cook slowly.")]), _vm._v(" During this process the vegetables are required to absorb the butter. If the butter is too hot the surface of the slices will become fried and resistant, thus defeating this object. The butter therefore should not be too hot and the vegetables should cook slowly or, as cooks say, sweat. This will take about 7 minutes to accomplish. The vegetables should become soft but in no circumstances brown. The French have a good word to describe the appearance of vegetables so cooked, "), _c('i', [_vm._v("fondant")]), _vm._v(", meaning ‘melting’. Sometimes this process of sweating may be facilitated by the addition of a sheet of buttered paper pressed down closely over the top of the vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Instruction 3: Cover and simmer.")]), _vm._v(" Simmering a liquid means just letting it move gently, bubbling only in one part of the pan; this process usually continues for about 20–30 minutes. This may be taken as a general rule. Certain vegetable soups when overcooked lose a good deal of flavour, and in the case of green vegetables lose colour as well. There is a choice of liquids for this type of soup: in this recipe it is milk. Sometimes a vegetable stock is used, and in particular the water in which potatoes, carrots, artichokes and so forth have been boiled.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Instruction 4: Pass through a fine sieve.")]), _vm._v(" The correct way to sieve a soup is as follows: Take a sieve (the suitable type is generally indicated in the recipe; it may be wire, hair, or now nylon in place of hair); place this over a large bowl and pour all the liquid through from the pan, keeping the vegetables back with the lid; now place the sieve over an adequately sized plate or dish and rub or push a little of the vegetable through at a time with a wooden spoon or curved spatula. All the time you are doing this the lid should be kept on the pan, so that the heat is retained. When all the material has been pressed through, scrape every bit of purée from underneath the sieve with a wooden spoon, thoroughly rinse out the pan, and return the purée from the plate. Dilute this purée by degrees with the liquid from the "), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("bowl, adding gradually and stirring well. In this way you get a perfectly smooth soup. In this recipe a wire sieve is called for; when potatoes are being sieved there is a danger that if they are worked too vigorously they will become gluey. The action is one of crushing and pressing rather than of rubbing.")])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Instruction 5: Add the liaison.")]), _vm._v(" A note on liaisons is given on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06#page_116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 116")]), _vm._v(", but to complete these instructions it may be repeated here. The yolks should not be added directly to the boiling soup, or they will curdle. Put the yolks in a small bowl, beat them slightly, add the cold milk or cream, and mix well. Now remove the pan of soup from direct heat, take from it one at a time 3 or 4 spoonfuls of soup, and add them to the egg mixture. Now, with the soup still away from direct heat, strain into it the contents of the bowl. Serve the soup at once. There is no flour in this soup, so you will note that it is not reboiled after the liaison has been added. The heat of a purée of this type is generally sufficient to cook the egg in the liaison.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In certain recipes there may be found an instruction to bring back to boiling-point a liquid to which a liaison of egg and milk has been added. That is because it is considered that the amount of flour, cornflour, or fécule in the liquid is sufficient to prevent curdling.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When additional enrichment in the form of butter is to be added at the end of cooking, it is important that the process should be carried out properly if the texture, appearance, and goodness of the soup are to be right. The butter should be divided into fragments which should be whisked well into the soup with a sauce whisk.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Do I hear, ghost-like on the air, the words ‘What a performance’? It certainly sounds rather like that, but once it is set out so that those who have ‘never boiled an egg’ cannot go wrong, we can leave it; for once you have carried out these rather minute instructions you will appreciate their relative value, and will carry them out in all the variants of potage purées, or, alternatively, skip or skimp them according to your will; but at any rate you will have a sort of measuring-rod to help you if you wonder one day why your purée falls short of perfection.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I want to go on with the recipes for purées, but first I will give the simpler version of the Parmentier. There are, of course, other soups with a base of potatoes, but with richer additions, and these will be found in the party section of this chapter, i.e. Potage Purée Bonne Femme and Crème Vichyssoise, a most delicious cold cream soup.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Here then is the simpler version of Parmentier:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE PURÉE PARMENTIER")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("Simplified version")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("2 medium-sized onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("350g/12 oz potatoes weighed after peeling")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a pinch of mace")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints light stock or water or potato water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("300ml/½ pint boiling milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a piece of butter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Slice the onions and potatoes very thinly. Melt the butter in a thick stew-pan, add vegetables, cover and cook very slowly for 7–10 minutes, stirring from time to time, without allowing the vegetables to colour, add stock or water and seasoning, bring to boil, and simmer with the lid on for 40–50 minutes. Adjust seasoning, add boiling milk, whisk in a piece of butter, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chopped chives are a good addition; the soup should be creamy and should not resemble porridge.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A good simple potato soup is made by using a potato mousseline as thickening for a thin béchamel "), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("sauce. The sauce should be well seasoned and flavoured, and the amount of potato to be beaten in is judged as the mixing proceeds.")])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Certain root vegetables are lacking in starch, and though these may be treated in the same way as in the preceding recipes they call for the addition of a thickening ingredient; this may be flour, arrowroot, cream of rice, sago, or cornflour.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE CRÈME AUX CHOUX")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 good green cabbage, weighing about 450g/1 lb when trimmed")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("30g/1¼ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25-50g/1-2 oz onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25-50g/1-2 oz chopped potato")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a pinch of nutmeg or ground mace")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("20g/¾ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("750ml/1¼ pints milk or milk and water, and a little extra milk if necessary")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 tablespoons cream (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("grated Parmesan cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut cabbage into four, trim away a little of the stalk. Blanch in boiling water for 6 minutes. Drain, refresh, drain again, and press well. Chop. Melt the butter in a pan, add the onion, and allow to soften without colouring. Add the cabbage and potato and stir over a moderate heat for a few minutes. Add the spice and seasonings, the flour and liquid. Bring to the boil and simmer for 10–12 minutes. Rub through a nylon sieve. Turn into a clean pan, reheat, adjust the seasoning, and the consistency by adding a little boiling milk if necessary. Lightly whip the cream, and just before serving add a spoonful to each soup-bowl. Scatter the top with a small spoonful of the parsley and a light dusting of the cheese over all.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A Cream of Brussels Sprouts may be made in the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here is a recipe for Potage Palestine where the same process is adopted as before in making the purée, and flour is added for thickening. This is followed by a second recipe for a richer Palestine, and then by a recipe for a carrot soup in which a small quantity of potato and cream of rice is used, and in addition a final liaison is made with yolk of egg.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE PALESTINE (1)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("450-550g/1-1¼ lb Jerusalem artichokes (weighed before peeling)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("600ml/1 pint water or potato water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a pinch of salt and sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("600ml/1 pint boiling milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz cornflour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 tablespoons cold milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("20g/¾ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 dozen fried croûtons (stale bread)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Wash, peel, wipe, and slice the artichokes. Slice the onions. Cook the onions in butter for 5–6 minutes, do not colour; add artichokes and shake over gentle heat for 15 minutes. Add water and seasoning, cover, bring to the boil, and simmer for 15–20 minutes. Rub through a hair or a fine wire sieve and add boiling milk. Blend cornflour with cold milk, add, bring to the boil, stirring with the sauce whisk, adjust seasoning, then simmer for a few minutes, adding butter in small pieces. Strain and serve with fried croûtons.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("POTAGE PALESTINE (2)")])]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb artichokes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("30g/1¼ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz onion, finely sliced")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("6 hazelnuts, grilled or baked to remove skins, and crushed and pounded")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a good pinch of sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("450ml/¾ pint warm water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("450ml/¾ pint boiling milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 level teaspoon arrowroot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2–3 tablespoons cold milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Liaison")]), _c('br'), _vm._v("2 yolks of egg"), _c('br'), _vm._v("3–4 tablespoons cream"), _c('br'), _c('i', [_vm._v("   or")]), _c('br'), _vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang1a"
  }, [_vm._v("soup croûtons served separately")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Wash artichokes well, peel, dry, and slice thinly. Heat the butter in large thick pan, add the onion, and cook gently for a few minutes, then put in the artichokes, and continue cooking very gently on a low heat. On no account allow to colour. At the end of 10 minutes add the crushed nuts, salt, and sugar. Pour in the water, and simmer 15–20 minutes. Rub through a nylon sieve, return to the rinsed-out pan, boil the milk, and whisk into the artichoke purée.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mix the arrowroot with the cold milk, pour into the soup, and bring to the boil, whisking all the time. Simmer 3–4 minutes. Adjust seasoning, skim if necessary, and add the liaison; if it is omitted, add the butter in small pieces off the fire, whisking vigorously.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CRÈME DE CAROTTES")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb carrots")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 clove of garlic, crushed, with a pinch of salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 potato")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon cream of rice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints milk and water mixed in equal quantities")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 tablespoons cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 yolk of egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("small squares of dried toast")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Melt the butter in a stew-pan. Add the finely sliced onions and carrots, and the crushed garlic. Season with salt and black pepper and cook slowly with the lid on for 10 minutes, stirring occasionally. Then add the sliced potato and cook for another few moments. Add the cream of rice and stir until smooth. Pour on the liquid and stir over the fire until it comes to the boil. Draw aside and simmer for 20 minutes. Rub through a nylon or fine wire sieve. Mix the cream and egg yolk and make the liaison. Return soup to the pan, add liaison, and stir over the fire until it thickens without boiling. Pour into the soup marmite. Sprinkle the top with freshly chopped parsley and serve with small squares of dried toast.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here is a recipe for a simple carrot soup in which bread is used as thickening and no final liaison is required:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE CRÉCY")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz carrots (if these are old and large the red part only should be used, and weighed when cut)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a thick slice or crust of bread cut from the bottom or sides of a loaf, as it should not be too hard or brown, with about 5mm/¼ inch of crumb attached and weighing about 75g/3 oz")])])]), _c('div', {
    staticClass: "space"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("50g/2 oz butter")])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1.7L/3 pints vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a pinch of sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a bouquet of parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 tablespoons rice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a little chopped chervil or mint")])])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Slice and chop the onion finely. Slice the carrots thinly and evenly (or if using old carrots peel off the red part thinly as though peeling an apple and work down until the core is reached; this can be done most efficiently with a potato-peeler). Put half the butter with the onion and carrot into the pan, cover, and cook very gently till the carrot is quite soft, about 20 minutes. If the cooking is too fast and the carrot fried you will not get the best results. Cut the crust in dice and dry in the oven. Add the dried dice to the carrots with a quart of the stock, the parsley, and the pinch of sugar. Simmer gently 35–40 minutes. While the cooking proceeds, prepare the rice by boiling till tender in salted water. Put the contents of the stew-pan through a fine sieve and return to the rinsed saucepan. Add remainder of stock. Adjust seasoning and simmer again for 10–15 minutes, skimming frequently. Remove from the fire, whisk in the rest of the butter, add cooked, drained rice and chervil or mint, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CELERY SOUP")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("There is a possibility that soup made with heads of celery may curdle. For this reason many celery soups are made with root celery (celeriac) (see Potage Savoyarde, ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_82"
    }
  }, [_vm._v("page 82")]), _vm._v("). The following recipe calls for a head of celery and the procedure is arranged to minimize the risk of curdling, that is to say the celery is not boiled in milk but is made into a purée and then added to a creamy béchamel. A fresh, crisp head should be chosen, and the piece of root, so often thrown away, used.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE CRÈME DE CÉLERI (CREAM OF CELERY)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 good head of celery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 medium-sized onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("60g/2¼ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints milk, or milk and water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 blades of mace")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 bay-leaves")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("6 peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("30g/1¼ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Liaison")]), _c('br'), _vm._v("2 yolks of egg"), _c('br'), _vm._v("5 tablespoons cream"), _c('br'), _vm._v("croûtons")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Slice celery and onion finely. Melt 20g/¾ oz butter in a stew-pan, put in the vegetables, cover with a buttered paper and the lid, and stew very gently 20–30 minutes, or until the vegetables are very soft.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Meanwhile put the milk into a saucepan with the spices and bay-leaves, bring very slowly to the boil with the lid on. When well flavoured strain and cool. Rinse out the pan, melt the remaining butter in this, and stir in the flour. Pour on the flavoured milk, blend well, and stir on the fire until boiling; reduce heat and simmer 4–5 minutes. In the meantime, rub the celery and onion through a nylon sieve; draw the sauce aside and whisk in the purée by degrees, adjusting the seasoning.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Work the yolks and cream together for the liaison and add as directed ("), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_67"
    }
  }, [_vm._v("page 67")]), _vm._v("). Serve at once with the croûtons.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following, a delicious soup made with young turnips, requires the addition of a liaison, as there is little thickening quality in the vegetable itself:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("POTAGE FRÉNEUSE")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("350g/12 oz young turnips (weighed when peeled)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints vegetable stock or potato water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Liason")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("2–3 yolks of egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("2–3 tablespoons thick cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("salt and pepper")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("Cut the turnips and onion in quarters and blanch for a few minutes in salted water. Meanwhile melt the butter in a stew-pan. Add the flour, mix, and pour on the liquid; stir until boiling. Then add the vegetables and simmer until absolutely soft, about 40 minutes. Pass through a nylon sieve. Rinse out the pan well, return the soup, mix the yolks and cream together and make the liaison in the usual way (")]), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06#page_118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 118")]), _vm._v("). Thicken carefully over a slow fire or in a bain-marie. Adjust the seasoning.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This soup should be very smooth and creamy and should be put through a hair or nylon sieve: a wire one would not give the right texture.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Serve with croûtons of fried bread or tiny crisp cheese profiteroles.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Thick soups are made with vegetables other than roots, and with these come variations in method.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE ST GERMAIN")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("a handful of spinach leaves and a head of lettuce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 leeks (green part only) or seedling leeks")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints large shelled peas")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a bouquet of chervil, and some small sprigs for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 flat teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 good teaspoon sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz butter (this quantity may be modified)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("150ml/¼ pint cold water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints white or vegetable stock or water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 cup small fresh green peas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Wash the spinach, lettuce, and green parts of the leeks and shred finely. Put these with the large peas, the bouquet of chervil, the pepper, salt, and sugar, 50g/2 oz of the butter, and 150ml/¼ pint of cold water into the pan. Bring to the boil and draw away from heat. Cover and let the contents simmer gently and regularly for 35–45 minutes. Put the contents through a fine sieve. Return to a clean pan and add the white or vegetable stock or water. Stir thoroughly and bring to the boil. While this is going on, the small green peas should be cooked in boiling salted water till tender, then drained. Now add the remainder of the butter to the purée, verifying the seasoning; add the small green peas and serve in a hot tureen.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here is a recipe for Danish Green Pea Soup, given to us by Lorna Francis:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("DANISH GREEN PEA SOUP")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("600ml/1 pint shelled peas")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 sprigs of parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 sprig of mint")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints good chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("20 baby carrots, or 2 large carrots cut in 16 pieces and shaped like baby carrots")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon finely chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("150ml/¼ pint cream or top of milk")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("Simmer peas in the stock till tender, with the herbs. Strain the peas from the stock and rub them through a nylon sieve. Melt the butter in a clean pan, mix in the flour, pour on the stock, stir until boiling, whisk in the purée, season, and simmer for a few minutes. Add the baby carrots, previously simmered in a little stock, and the parsley. Finish with cream or top of milk. Serve hot or chilled.")])]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Celery, broad beans, French beans, cauliflowers, chestnuts, pumpkins are all vegetables which in season may suitably be used for soup.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here are some further recipes:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE PURÉE DE FÈVES (BROAD BEAN SOUP)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb broad beans (weighed after shelling)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("600ml/1 pint light stock (veal or chicken)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 sprigs of savory or thyme")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon arrowroot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("150ml/¼ pint milk or cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The thick skins of the beans would give a bitter taste to the soup; they would also give it a granulated appearance and a bad colour. They must therefore be removed and this should be done with a small pointed knife. Then cook the beans with the sprigs of savory quickly in boiling stock, with the lid off the pan, for 20 minutes. When the beans are beginning to break, take off and drain, keeping the liquor and reserving a few of the best beans for the garnish. Rub the rest of them through a fine sieve. Return to the pan with the liquor. Bring to the boil, season, simmer 10–15 minutes, skimming frequently. Mix the arrowroot with the milk, pour into the soup, and allow to boil up for a minute or two. Then add the butter in small pieces, and the broad beans kept back for garnish. A liaison of egg yolks may be added to the soup.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE PURÉE DE MARRONS")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("350g/12 oz peeled chestnuts (The small English ones will do. You will then need about 550g/1¼ lb unpeeled)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz sliced onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz butter or bacon fat")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 sour apple, peeled, cored, and sliced")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz carrot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a little thin cream or top of milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints stock or water")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("To peel the chestnuts put them into cold water and bring to the boil. Take off the fire, take 1 or 2 out of the boiling water at a time and remove the skins. Directly the water begins to cool and the chestnuts become hard to peel, bring the water up to the boil again. Put the peeled nuts in a stew-pan with the sliced onion, the carrot, and the stock. Cover, season, and simmer until the nuts are absolutely soft. Put all through a hair or fine wire sieve and return to the pan with the top of the milk or the cream. Reheat slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If no hair sieve is available and a wire one must be used, put the chestnuts through as rapidly as possible, as they are apt to discolour in contact with metal.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When immature nuts are used the soup may need a little thickening – arrowroot, cornflour, or an egg liaison will be suitable. This should be done before the addition of the cream.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For the garnish, melt the butter or fat in a frying-pan and fry the slices of apple in this quickly. They should be a nice brown. Add them to the soup just before serving and sprinkle the top of the soup with chopped parsley.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("POTAGE ANDALOUSE (PUMPKIN SOUP)")])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("900g/2 lb pumpkin")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("175g/6 oz potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints water or potato water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz rice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("600ml/1 pint salted water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 tablespoons cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Peel and cut up the pumpkin, potatoes, and onions and chop the tomatoes. Put them into a saucepan with the quart of water, salt, and pepper. Bring to the boil and cook until tender, about 20 minutes. While the vegetables are cooking, boil the rice in a pint of salted water. When cooked, strain and rinse with cold water. Put the cooked vegetables through a fine sieve, return them to the pan, and reheat. Add the rice, a nut of butter, and the cream. The soup should be of a creamy consistency and a rich golden colour.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Small fried croûtons, served separately, may replace the rice if this is not available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When green peppers are plentiful this Creole Soup is one of many good uses for them:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CREOLE SOUP")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 heaped tablespoons finely chopped onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 heaped tablespoons finely chopped green peppers")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints stock, preferably vegetable")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a dash of vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 teaspoons freshly grated horse-radish")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Garnish")]), _c('br'), _vm._v("croûtons")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Heat the butter and cook onion and peppers gently for 5–7 minutes till softened; do not allow to brown. Sprinkle with flour and continue cooking for 3 or 4 minutes. Peel and chop the tomatoes, and add with stock. Simmer for 1 hour. Season very well. Add finally the dash of vinegar and horse-radish which may be modified to taste. Add the garnish and serve. This soup is sometimes put through a sieve but is nicer left unsieved.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("In making a green vegetable soup with such materials as lettuce, spinach, cucumber and so forth there are variations in method. Sometimes the vegetables are boiled in water, drained, and pressed through a sieve, and the resulting purée added to a roux-thickened liquid, really a thin béchamel. In this case a roux is made with the addition of chopped onion or a vegetable mirepoix (see béchamel, ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06#page_130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 130")]), _vm._v("), liquid added, and the whole simmered 10–15 minutes. It is then strained and returned to the pan, the purée beaten in, and a liaison of fécule or egg added if desired. A rough guide to proportions is 25-40g/1-1½ oz each of butter and flour for each pint of liquid. This may vary to some small degree depending on the amount and strength of the vegetable purée to be added, and whether or not a liaison is to be used. If it is borne in mind that the consistency of a vegetable cream soup should resemble that of thin cream, it is easy after a little practice, using the above quantities as a guide, to experiment with various green vegetables. In some cases, e.g. Potage Crème de Laitue, the flour is added to the vegetables immediately after the preliminary softening.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To obtain a more creamy finish to purée soups, a little more butter than is given in the recipe may be used. This extra butter should be added in small pieces just before the soup is served, and stirred in, "), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("but on no account should the soup continue cooking after this addition has been made.")])]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Sometimes a mixture of milk and water or milk and vegetable stock is called for in a vegetable soup. It should be observed that this mixture sometimes causes a slight granulation in the texture of the soup, and although this is not a very serious defect, it is advisable, when possible, to use all milk or stock and, particularly in the latter case, an egg liaison for finish.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE CRÈME DE LAITUE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("2 large heads of lettuce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz chopped onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("20g/¾ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Liaison")]), _c('br'), _vm._v("1 teaspoon arrowroot or 2 egg yolks"), _c('br'), _vm._v("5 tablespoons cream or top of milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Garnish")]), _c('br'), _vm._v("fried croûtons"), _c('br'), _vm._v("freshly chopped mint")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Finely shred the lettuce, melt the butter, add the lettuce and onion, cover, and stew gently 5–7 minutes. Draw aside, add the flour and seasoning. Add liquid and simmer 15–20 minutes, pass through a fine sieve. Return to the pan, add the liaison, and bring up to the boil. Sprinkle with freshly chopped mint and serve with fried croûtons.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE PURÉE D’ÉPINARDS")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb spinach")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("20g/¾ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("450ml/¾ pint stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon finely chopped shallot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("150ml/¼ pint milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a little nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 tablespoons cream or top of milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("quartered hard-boiled eggs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("slices of lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Prepare the spinach and cook in plenty of boiling water until tender; drain well. Blend the butter and flour, add the stock, and stir until boiling. Add the prepared spinach and the shallot, and simmer gently 20 minutes. Pass through a fine sieve, return to the pan, adding the milk, a grating of nutmeg, and the cream. Reheat carefully and serve with quartered hard-boiled eggs and slices of lemon.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PARSLEY SOUP")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz good parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints stock or water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz potato")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225ml/8 fl oz top of milk")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Slice the onion and coarsely chop the parsley. Put the stock or water into a pan with salt and bring to the boil, add the onion and parsley and simmer 30 minutes uncovered. Rub through a nylon or fine wire sieve. Melt the butter in the pan, add the flour, pour on the liquid, season, and stir until boiling. Dice the potato, simmer them in the milk until soft with the lid on the pan, then add to the soup.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("POTAGE CRESSONIÈRE (I) (WATERCRESS SOUP)")])]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 bunch of watercress")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Peel the potatoes, quarter them, and boil them in salted water until tender. Drain, crush them with a potato-masher, and when free from all lumps add the boiling milk and the salt. While the potatoes are cooking, wash and pick the leaves off the watercress and chop roughly. Add to the soup and cook for 5–6 minutes. Take off the fire and add the butter. Pour into a hot tureen and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE CRESSONIÈRE (2)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("2 bunches of good cress")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 chopped onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints milk and water mixed")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Liaison")]), _c('br'), _vm._v("1 heaped teaspoon arrowroot, slaked with 5"), _c('br'), _vm._v("tablespoons cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Coarsely chop the cress. Melt butter in a pan, add the onion, cover, and cook a few minutes. Now add cress and cook a further 5–6 minutes. Draw aside, add flour and liquid. Blend and simmer 15 minutes. Rub through a fine sieve. Rinse out pan, return the soup, and add liaison if called for.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Potage Germiny is a soup made of sorrel, spinach, and spring onions, but as it is particularly good made with chicken stock and calls for 3 yolks for the liaison, it will be found in the section on party soups; another sorrel soup, Soupe à l’Oseille à la Paysanne, is to be found in the section on peasant soups.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CREAM OF TOMATO SOUP")])]), _c('div', {
    staticClass: "space"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb ripe tomatoes or 1 small can of tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25-50g/1-2 oz onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25-50g/1-2 oz carrot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("600ml/1 pint water or vegetable or potato stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 bay-leaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 lumps of sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a pinch of ground mace or nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon arrowroot (if called for)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3–4 tablespoons cream or evaporated milk")])]), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("cheese croûtes (see ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_76"
    }
  }, [_vm._v("next page")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Wipe, slice, and pip the tomatoes. Finely slice the onion and carrot. Melt the butter in a pan, add the onion and carrot, cover, and allow to soften for 5–6 minutes. Draw aside from the heat, stir in the flour, add the tomatoes, liquid, bay-leaf, sugar, spice, and seasoning. Stir until boiling, simmer for 20–30 minutes. Rub through a nylon sieve or aluminium strainer, pour back into the rinsed-out pan, and reheat. Adjust seasoning and thicken slightly, if necessary, with a teaspoon or more of arrowroot slaked with a tablespoon of water. Reboil.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Add cream or evaporated milk, or this may be added to each bowl of soup, with a little chopped chives sprinkled on the top. If the tomatoes are not very full of flavour, a teaspoon of concentrated tomato purée may be added with them.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Serve cheese croûtes either separately or in the soup.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('span', {
    staticClass: "h3-italic"
  }, [_vm._v("Cheese croûtes")])])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('div', {
    staticClass: "space1"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz grated cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("10-15g/¼-½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("pepper, salt, mustard, cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1-2 rounds of bread, cut 6-12mm/¼–½ inch thick")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Work the cheese and butter together on a plate with a palette-knife. Season highly. Toast the bread fairly slowly on one side, spread the cheese mixture thickly on the other. Toast quickly to a golden brown, then cut each round into small squares (6-12mm/¼–½ inch), and serve at once.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Now follow some recipes where a slight variation of method, or more particularly some trick of flavouring or finish, gives results a little out of the ordinary, and while economical enough for everyday use, these soups are also good for special occasions.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In some of them long simmering is called for and this is done with the lid half off the pan. In this way some evaporation takes place and consequently the liquid is partially reduced and concentrated.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("First comes a tomato soup made interesting by the addition of a garnish of blanched shredded orange peel. Then comes a piquant, spicy soup, very warming in winter and good for a party, and then another tomato soup called Potage Véronique, where the addition of fresh tomato at the end of cooking gives a refreshing taste.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The flavouring of the following soup is essentially delicate and is obtained in the first place by rubbing one lump of sugar on to the rind of an orange in order to get some of the richly flavoured oil which is the zest. It is important not to overdo this flavouring or the delicate balance of the final effect will be spoiled. It is all too easy to overdo the orange. The garnish, consisting of a small quantity of the rind thinly pared, shredded, and then blanched, adds the final delicate touch.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE DE TOMATES À L’ORANGE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("900g/2 lb tomatoes, fresh or canned")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 medium-sized carrot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 medium-sized onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 bay-leaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 strip of lemon rind")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("6 peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.4L/2½ pints stock, chicken or vegetable")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 lump of sugar with orange zest and a little additional sugar to taste")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("150ml/¼ pint cream or top of milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("orange rind for garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Choose ripe red tomatoes. Wipe, cut in half, and squeeze lightly to remove the seeds. Slice the onion and carrot finely and put in a stew-pan, together with tomatoes, bay-leaf, lemon rind, peppercorns, and stock. Add a little salt, cover, and simmer for about 1 hour with the lid half off. Rub through a fine sieve. Rinse out the pan. Melt the butter in it, add the flour, mix well, and dilute with the tomato pulp. Take the zest of orange on the lump of sugar, add, and put in a little more sugar to taste. Simmer 5 minutes, or longer if it is necessary to concentrate or thicken the soup a little more. Add cream gradually, stir round once, and pour quickly into bowls.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Serve with the following garnish: Shred finely a small quantity of the rind of an orange. Simmer for 6 minutes in boiling water, drain, and sprinkle over the soup.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("The following is excellent:")])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("SPICY TOMATO SOUP")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a blade of mace")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4–6 peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 clove")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon paprika")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a bouquet garni")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("750ml/1¼ pints chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz sago")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 glass port or red wine")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Melt butter, add sliced onion and soften. Add flour, spices, salt, paprika, and tomatoes, herbs and stock, and cook for 20 or 30 minutes. Strain, add the sago, and simmer until sago is transparent. Finally add the port.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Potage Véronique is a tomato soup to which the addition of a little fresh shredded tomato towards the end of cooking gives the distinguishing note.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE VÉRONIQUE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb ripe tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 clove of garlic, bruised")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 bay-leaves")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints vegetable stock or water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon tomato purée")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 lump of sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz rice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Garnish")]), _c('br'), _vm._v("25g/1 oz grated cheese"), _c('br'), _vm._v("2 slices of bread"), _c('br'), _vm._v("mustard and pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Take three-quarters of the tomatoes, cut in quarters, and squeeze out the seeds. Put into a pan with the bruised clove of garlic, the bay-leaves, and 15g/½ oz butter. Simmer very slowly with the lid half off for about 40 minutes. Rub through a sieve or strainer. Meanwhile finely slice the onions, put into a stew-pan with 20g/¾ oz butter, cover, and stew slowly for 15 minutes without colouring. Add the flour off the fire, the stock, and the tomato purée. Season with the sugar, salt, and freshly ground black pepper. Add the rice and simmer for 20–30 minutes. Scald and skin the remaining tomatoes, cut in quarters and remove the seeds, cut in shreds and add to the soup. Spread the cheese on the slices of bread buttered with the remainder of the butter, season well with mustard and pepper, and brown under the grill. Cut into strips and serve separately.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE SOLFERINO")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("350g/12 oz tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("the white part of 2 leeks")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints vegetable stock, water, or water potatoes or beans have been cooked in")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("cayenne")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("Wipe tomatoes, cut in two, remove all seeds and water, and cut out any hard stalk or core. Chop coarsely. Cut the onion and leeks into thin slices. Melt half the butter in a large saucepan, add the onion and leeks and cook gently until turning yellow, but do not allow to brown. Add the liquid and a little salt if the stock is not already salted. Boil, then add the tomatoes, the finely chopped garlic, and the potatoes cut into thin slices. Cover and simmer for a good half-hour. Pass through a nylon or fine wire sieve, rinse out the pan, pour back the soup, and stir until boiling, thinning down if necessary with a little stock or water. The purée should be clear looking and the consistency that of cream. Draw aside and stir in the rest of the butter in small pieces. When thoroughly incorporated adjust the seasoning, adding a touch of cayenne.")])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("A particularly good Tomato Soup is given on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31#page_864",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 864")]), _vm._v(", and a recipe for Cold Tomato Soup will be found on "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_90"
    }
  }, [_vm._v("page 90")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Crème Olga is a delicate soup tasting of fresh mushrooms. Here a flavoured potato and milk broth is made, and then the raw mushroom added and cooked for 2 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CRÈME OLGA")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz spring onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900g/2 lb potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 bay-leaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Liaison")]), _c('br'), _vm._v("1 egg yolk"), _c('br'), _vm._v("5 tablespoons cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang1a"
  }, [_vm._v("croûtons of fried bread")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Slice the onions and potatoes and cook in the butter until soft but not coloured. Add the milk and bay-leaf and simmer for 20 minutes. Rub through a fine sieve, return to the pan, and add the raw sieved mushrooms. Stir, season, bring up to boiling-point, and simmer for 2 minutes. Remove the pan from the fire, and add the liaison of egg yolk and cream (see note on liaisons, "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06#page_116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 116")]), _vm._v("). Reheat carefully, correct the seasoning and serve with croûtons of fried bread.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE CRÈME D’ASPERGES (ASPARAGUS CREAM SOUP)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 bundle of asparagus, about 30 medium-sized heads")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 shallot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints veal or vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Beurre manié")]), _c('br'), _vm._v("25g/1 oz butter"), _c('br'), _vm._v("25g/1 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Liaison")]), _c('br'), _vm._v("110ml/4 fl oz cream"), _c('br'), _vm._v("2 egg yolks")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Wash and trim the asparagus, lightly scraping the white part of the stalks and reserving about half a dozen of the smaller tips for the garnish. Cut the stalks into inch lengths and slice the shallot finely. Put together in a pan with the stock. Cover and simmer 30 minutes. Meanwhile blanch the tips for 1 minute and cook in water until just tender. Rub the soup through a fine sieve, rinse out the pan and return it. Reheat and season. Work the butter and flour together to a soft paste ("), _c('i', [_vm._v("beurre manié")]), _vm._v("), divide into small pieces and whisk into the soup off the fire. When thoroughly blended stir over a moderate fire until boiling. Beat the yolks, add the cream, and make the liaison in the usual way. Whisk for a minute or two over the fire, but do not allow to boil. Add the tips and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("CRÈME DE CONCOMBRES")])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("600ml/1 pint vegetable or light stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 large cucumber (or 2 small)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon chopped shallot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("20g/¾ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("liquid green colouring")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Liaison")]), _c('br'), _vm._v("2 yolks or 2 teaspoons arrowroot"), _c('br'), _vm._v("5 tablespoons milk or cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Garnish")]), _c('br'), _vm._v("freshly grated cucumber"), _c('br'), _vm._v("finely chopped mint")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Boil up the strained stock and add the cucumber, peeled and cut in 12–mm/½–inch slices, and chopped shallot. Simmer gently until the cucumber is soft (15–20 minutes) and rub through a hair sieve. Rinse the saucepan. Blend the butter and flour and add the sieved cucumber and stock. Stir until boiling and simmer for 5 minutes. Cool a little, add the liaison, and thicken the soup carefully. Colour delicately, correct the seasoning, add the garnish, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The following recipe is for a classic cream soup, having as a base milk thickened with crème de riz or cream of rice (not to be confused with ground rice). Crème de riz has not been easy to obtain lately, so a velouté base has had to be used: that is to say, a white stock in place of milk thickened with a roux.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE CRÈME DE RIZ")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("65g/2½ oz crème de riz")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 small onion stuck with a clove")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a bouquet of 2–3 parsley stalks, a sprig of thyme, and ½ bay-leaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("175g/6 oz white mushrooms, cups or buttons")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("150ml/¼ pint single cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a nut of butter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix the cream of rice to a smooth paste with a little of the cold milk. Put the remainder of the milk on to boil, and when boiling draw aside and whisk in the cream of rice. Add the onion, bouquet, and a little salt and pepper, cover and simmer very gently 12–15 minutes. Meanwhile peel the mushrooms and rub through a wire sieve with the stalks, reserving 2 mushrooms for a garnish. Cut these into fine ‘filets’ or julienne strips and cook in a nut of butter. Remove the bouquet and onion and strain the soup through a fine or tammy strainer. Return to the rinsed pan, add purée, bring to the boil, and simmer for a few minutes, adding the cream. Add garnish and serve at once.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("Attention is drawn to the cream soups given in the chapter on modern kitchen appliances, ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter37#page_1024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 1024")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter37#page_1028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1028")]), _vm._v(". These soups made in an electric blender are particularly smooth and good, and for small quantities this is a practical method.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("II. BROTHS AND PEASANT SOUPS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The following are the simplest soups of all. They are rustic but good, excellent for family meals, and in some cases, for example the Italian minestra, will serve as a substantial course for luncheon.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MINESTRA")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This differs from the well-known minestrone in that it is made from vegetable stock and contains no meat.")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("1 tablespoon oil")])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz carrot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 sticks of celery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz leek")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.7L/3 pints boiling water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ bayleaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("6 French beans or a quarter of a cabbage or 6–8 Brussels sprouts (or all three if available)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz potato")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz tomato")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 clove of garlic crushed with ½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a spoonful chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("grated cheese")])])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Heat a tablespoon of oil in the stew-pan. Add the carrot, onion, celery, and leek, all cut into thick strips. Cook until just turning colour, shaking and stirring occasionally, then pour in about 1.7L/3 pints boiling water (the liquid should well cover the vegetables). Add salt, bay-leaf, the cabbage and beans, also cut into strips, and the Brussels sprouts if available, then simmer 30–40 minutes with the pan covered. Add the potato cut in the same way and simmer again for another 20 minutes. Peel the tomato, cut in quarters, and add to the soup with the crushed garlic and a good spoonful of chopped parsley. Simmer another 10 minutes and then serve. More water must be added during the cooking if necessary, preferably during the early stages, but the soup should be thick with vegetables. Grated cheese is served separately.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("On the whole cabbage is not carefully cooked in this country, and the recollection of the smell of its cooking is prejudicial to a general appreciation of cabbage soup. Yet the French Soupe aux Choux is really excellent.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SOUPE AUX CHOUX")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 small onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 rasher bacon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 cabbage")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("approx1.4L/ 2½ pints vegetable stock or water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz French or runner beans")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("French bread")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("grated Parmesan cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Melt the butter in a casserole. Add the sliced onions, crushed garlic, and coarsely cut-up bacon. Sauté over a slow fire for a few moments, and add the cabbage, previously blanched and coarsely shredded. Pour on the stock, season, and bring slowly to the boil. Cover and simmer in a slow oven for 50 minutes. Add the shredded beans, and continue cooking for another 50 minutes. Take out and serve in the pot with slices of the toasted bread floating on the top. Serve the grated cheese separately.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The following soup is simple, good, and really suitable for a "), _c('i', [_vm._v("maigre")]), _vm._v(" day:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE FERMIÈRE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("3 carrots")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 turnips")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 leeks")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 or 6 potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints boiling water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("seasoning")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("2 heaped tablespoons chopped mixed herbs (chives, chervil, and parsley, with a little lemon thyme, summer savory, basil and dill, make a good mixture)")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("Prepare the vegetables and cut all except the potatoes into neat dice; sweat the diced vegetables in the butter till softened but not coloured. This should be done over very gentle heat and takes about 20 minutes to half an hour. Add the boiling water and simmer until the carrots are tender, then add sliced potatoes and cook another 20 minutes. Season well, pour into a hot tureen, and sprinkle the surface with the finely chopped herbs.")])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The following excellent Garbure Paysanne is made interesting by the serving of the special croûtons described.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("GARBURE PAYSANNE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 large leeks (white part)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz carrots")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz turnip")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("the heart of a small cabbage")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning and a pinch of sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 sticks of celery or the root of celeriac")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.7L/3 pints water or vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 French or breakfast roll")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz gruyère cheese, grated")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This garbure is made with certain basic vegetables, but other vegetables, such as broad beans, peas, and French beans, may be added when these are in season.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Melt half the butter in a stew-pan, slice the leeks, carrots, turnip, cabbage, and onion thinly. Add to the pan with a good pinch each of salt and sugar, cover and cook very slowly for 20 minutes. Moisten with half the liquid, bring to the boil, add the potatoes cut in slices and any other seasonable vegetables. Cover and simmer for 1 hour. Cut the bread into croûtons 12mm/½ inch thick, fry until a delicate brown in half the remaining butter, and set aside to keep warm. When the vegetables are soft take out 2 or 3 spoonfuls and push through a wire sieve to make a very thick purée. Heap this purée on the croûtons, smoothing it over with a knife, sprinkle on the cheese, and brown in the oven. Meanwhile sieve the remainder of the soup, return to the pan with enough of the remaining liquid to give a creamy consistency, and bring to the boil. Adjust the seasoning, add the rest of the butter off the fire, pour the soup into the tureen, and hand the croûtons separately.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The author of the letter in the preface gave us a recipe for a Garbure Basque, an all-the-year-round soup, to be made with whatever vegetables are in season, or available. It needs long cooking: 4–5 hours is not unusual unless one is using young vegetables early in the year. The measurements are in cups, as given to us, and the recipe calls for a great deal of garlic, which may be modified to suit English tastes, but by no means omitted. The soup is very thick and substantial and forms the main dish of a midday meal in the Basque country.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("GARBURE BASQUE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("a piece of butter the size of an egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a breakfast-cup each of leeks, carrots, potatoes, peas, beans, turnips, tomatoes, etc. cut in small pieces")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a tea-cup each of onions and celery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a coffee-cup of garlic, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a pinch of salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("milk or butter to finish")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon chopped chervil")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("Melt a piece of butter the size of an egg in an earthenware casserole. Gently cook the leeks in this and then add the other vegetables, the garlic, 2 tablespoons olive oil, chopped parsley, and a pinch of salt. Pour on enough water to cover well, put the lid on the casserole and cook on a very low fire 4–5 hours. Do not sieve. The garbure is finished when the vegetables have disappeared and the soup is a fairly thick purée. Finish with a piece of fresh butter or a cup of fresh milk added at the last minute. Sprinkle over a tablespoon of finely chopped chervil before serving.")])]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("SOUPE À LA SAVOYARDE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("175g/6 oz celeriac, weighed after peeling")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz potato")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz leek (white part)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz dripping or butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a flat teaspoon salt and a pinch of sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints warm water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("300ml/½ pint freshly boiled milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a dozen fingers of brown bread and butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz grated gruyère cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Slice all the vegetables very thinly: this is important. Put all together into a saucepan with the dripping or butter, salt, and sugar. Soften the vegetables in the dripping or butter, cooking gently and not allowing them to brown. As they take about 20–25 minutes, it is necessary to stir and shake the pan frequently. At the end of this cooking they should be "), _c('i', [_vm._v("fondant")]), _vm._v(" – melting. Add the warm water, cover, and leave to simmer gently for 10 minutes. Then add the milk and continue simmering gently for 3 or 4 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Lightly brown the fingers of bread and butter in the oven, sprinkle them with cheese, and brown under the grill or in the oven. Adjust the seasoning of the soup and serve with croûtons on top.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following is a slightly richer vegetable soup by reason of the addition of eggs:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE JULIENNE ST MAUR")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz leeks")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz carrots")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz turnip")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 sticks of celery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 very small cabbage or heart of a cabbage")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.7L/3 pints stock or water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz rice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 very small lettuce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 small handful sorrel")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut the leek, carrots, turnip, celery, and onion into small julienne shreds. Melt 40g/1½ oz of the butter in the stew-pan, put the vegetables into this, and shake over a brisk fire for a few minutes; this is required to brown the vegetables lightly before the addition of the liquor. Add salt and pepper; cover and cook on a very slow fire for 10 minutes. Blanch the cabbage whole, then cut in shreds and add to the vegetables in the pan with the stock and rice. Simmer 30–40 minutes. Meanwhile shred the sorrel and lettuce, cook for a few minutes in the remainder of the butter, then add to the soup 5 minutes before serving. Beat the eggs in the tureen or soup marmite, re-season the soup if necessary and pour gently into the marmite, stirring briskly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sorrel and lettuce may be omitted when out of season, also lightly toasted bread or rolls may be put in the marmite when eggs are unobtainable. This, of course, alters the character of the soup, but the bread is quite a satisfactory substitute.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_82"
    }
  }), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("VEGETABLE BORSCH OR SUMMER BORSCH")])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("raw beetroot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("carrot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("celery or celeriac")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("parsnip")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2–3 quarts ham or veal stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a bouquet garni")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("cabbage")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("tomatoes or tomato purée")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chopped parsley or Hamburg parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("sour cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a little flour")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The vegetables (except the cabbage and tomatoes) should be cut into coarse match-like pieces, and the beetroot should, for choice, be the round, deep red variety. Take a 2-pint pudding basin, fill a half with the cut-up beetroot, a quarter with onion, half the remaining quarter with carrot, and divide the rest of the space between celery (or celeriac) and parsnip. Put 2–3 quarts ham or veal stock into a large pan, and when boiling turn the bowl of vegetables into it. Add a bouquet of herbs and the garlic crushed with salt. Simmer for about 20 minutes. Fill up the bowl with coarsely shredded cabbage, turn this into the soup, and continue cooking for another half-hour. Now add fresh, peeled tomatoes, coarsely chopped (enough to fill a quarter of the pudding basin), or a large spoonful of concentrated tomato purée. Add also salt, sugar, and plenty of chopped parsley. Cook a little while longer. Take a little sour cream and blend it with a very small quantity of flour. Add to the borsch off the boil, then reboil. This should not make it in any way thick, but should just take away the clear, watery look. If you wish, serve with more sour cream.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("For Consommé Borsch and Bortchok see ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_110"
    }
  }, [_vm._v("pages 110")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_111"
    }
  }, [_vm._v("111")]), _vm._v(" (Party Soups).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following Soupe à l’Oignon is excellent and the brown sticky cheese top has a most appetizing savour. It is a good dish to serve after a theatre party. A real party onion soup is given on "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_106"
    }
  }, [_vm._v("page 106")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SOUPE À L’OIGNON")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter or good dripping")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints boiling water or vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("bay-leaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("slices of French bread")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("grated cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Finely chop the onions. Melt the butter in a thick pan. Add the onions and brown slowly and well. This will take at least 15–20 minutes. Dust in the flour, and pour on the boiling water or vegetable stock. Simmer for about half an hour, adding seasoning and bay-leaf. Put several slices of French bread at the bottom of a casserole, pour on the boiling soup, first removing the bay-leaf. Dust thickly with grated cheese, then set the casserole in the oven for 15–20 minutes to brown. Serve very hot.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following cream of onion soup is a speciality of the Île de France:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("LE THOURIN")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("20g/¾ oz flour")])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('i', [_vm._v("Liaison")]), _c('br'), _vm._v("2 tablespoons top of milk or cream"), _c('br'), _vm._v("2 egg yolks")])]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3–4 very thin slices of bread")])])]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Boil the milk and slice the onions finely. Melt the butter, and when frothing add the onions and cook very slowly to soften completely, without colouring. When the onions are almost cooked, add the flour and mix in well over the fire for 3–4 minutes. Add the boiling milk a little at a time, stirring well to avoid lumps. Bring to the boil and allow to simmer 15–20 minutes. Remove from the fire, add the liaison of egg yolks and cream, reheat carefully, and adjust the seasoning. Meanwhile cut the bread into rounds, bake to a golden brown in a cool oven, place at the bottom of a soup marmite, pour the soup over, and serve at once.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Potage Périgord is an interesting soup because of the farci which is added:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE PÉRIGORD")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("2 large onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 clove of garlic crushed with ½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1L/1¾ pints water or stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("farci (see below)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a few drops of vinegar or a little lemon juice")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Slice the onions finely, and separate them into rings. Make the butter hot in a saucepan, cook the onion rings in this over gentle heat, stirring them about with a wooden spoon so that all cook equally golden brown. Add the crushed garlic, the water or stock, salt, and pepper and simmer for 10 minutes. Add farci and cook for half to three-quarters of an hour; take out. Blend the egg yolk with a tablespoon of the soup, add a few drops of vinegar or lemon juice. Pour this mixture into the soup and stir, but do not boil. Put the egg white into a greased cup and steam until firm. Then chop finely and add to the soup. Cut the farci into slices and serve in the terrine with the soup.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "h3-italic"
  }, [_vm._v("Farci")])]), _vm._v(" "), _c('div', {
    staticClass: "space1"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("a slice of stale bread")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ rasher of bacon, finely minced")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon chopped chives")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon chopped thyme")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon chopped onion or shallot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 egg yolk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 large cabbage leaf")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Make the slice of stale bread into fine crumbs, mix with it the bacon, the parsley, chives, thyme, and chopped onion or shallot, and the clove of garlic. Mix well together, add a little pepper, and bind with yolk of egg. Blanch the cabbage leaf and spread this farci over it; fold the leaf neatly and tie it up with thin string or cotton. Drop it into the soup and cook for half to three-quarters of an hour. Take out when the soup is ready for the liaison, remove the string, and cut the farci into slices. Serve a slice or two of farci in each plate of soup.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Some people consider that sorrel soup is an acquired taste. If so, I think it is worth acquiring, but perhaps for beginners, so to speak, it is wise to start with a soup made half of sorrel and half of spinach or young nettles, because this addition modifies the sharp flavour of the sorrel, and also improves the colour of the soup. Here is a recipe for the real thing, and another made half with sorrel and half with spinach:")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_84"
    }
  }), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("SOUPE À L’OSEILLE À LA PAYSANNE")])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("150g/2 oz roughly chopped sorrel")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("20g/¾ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2½ pints boiling water or potato water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a good pinch of sugar and salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 or 2 eggs (whole)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("150ml/¼ pint milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("croûtons or thin slices of French roll dried in the oven")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("Put half of the butter and the sorrel together in a pan, cover and cook gently for about 25–30 minutes, stirring from time to time. Sprinkle with flour and allow this to colour, still stirring, add boiling liquid and salt and sugar. Cover and simmer for 15 minutes. Whisk in remaining butter, beat eggs with milk, strain, and add in the way described on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06#page_118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 118")]), _vm._v(". Serve immediately with croûtons.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE DE SANTÉ")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("3 large handfuls spinach")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 large handfuls sorrel")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 bundle spring onions and/or ½ bundle watercress")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ handful parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz flour (scant weight)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.4L/2½ pints liquid (750ml/1¼ pints ham stock, 750ml/1¼ pints of the water the herbs have been boiled in)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("hard-boiled eggs or savoury fritters")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Boil the spinach, sorrel, onions, and parsley in 1.7L/3 pints boiling water for 5–7 minutes. Drain, press, and sieve, reserving the water. Melt the butter in a large saucepan, add the flour off the fire, pour on the liquid and bring to the boil. Season and simmer 5 minutes. Whisk in the purée, reboil, and serve with a spoonful of cream and a little chopped hard-boiled egg on each plate, or hand the savoury fritters separately. See "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#page_8"
    }
  }, [_vm._v("page 8")]), _vm._v(" (Savouries).")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("III. VEGETABLE PURÉES MADE FROM DRIED VEGETABLES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The following notes on the preparation, and preliminary cooking of dried vegetables are applicable to any dish, not only to soups.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("HARICOT BEANS, BROWN OR RED BEANS, LENTILS, GREEN PEAS, WHOLE OR SPLIT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Preparation")]), _vm._v(" Dried vegetables should be washed well, picked over, weighed or measured for the dish in hand, and then soaked in plenty of water which should be just tepid. The more thorough the soaking (24 hours is not too long), the less time they will take to cook.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Cooking")]), _vm._v(" Fresh water should be taken for this and the vegetables well covered in the pan. If the water is hard, a pinch of bicarbonate of soda may be added.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Boiling-point should be reached very slowly: this should take not less than 40 minutes. If this rule is not observed and the dried vegetables are allowed to cook fast in the early stages they are apt to harden.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When, after 40 minutes, boiling-point is reached, further gentle simmering for 1½–2 hours is required before the vegetables are treated for the final dish.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("Probably the most generally popular of soups made from dried vegetables are those made from dried peas. There are various ways of making these taste and look something like soup made from the fresh vegetable. For one thing, the colour may be improved by the addition of some fresh spinach juice, which should be put into the bottom of the tureen and the hot soup poured on to it. It is not a good thing to put the spinach juice into the saucepan, as the boiling liquid will spoil the colour. This juice is obtained by pounding a good handful of spinach leaves and then squeezing out the juice through a fine strainer or a piece of muslin. The addition of a few young, canned peas as a garnish is another way of improving this soup, and chopped fresh mint added finally as well as a sprig used while cooking make all the difference to the flavour. In fact, the addition of fresh herbs and, where suitable, of fresh raw vegetables, such as carrot or celery finely grated, or the sprouted peas mentioned on ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_87"
    }
  }, [_vm._v("page 87")]), _vm._v(", gives an agreeable fresh taste to these soups.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Before giving recipes for these and other soups of dried vegetables, I ought to say that French authorities point out that this type of soup should be very carefully skimmed, and indicate that this should be done for the last half-hour before it is served; they say that unless this skimming is carried out carefully the soup will have a rough taste. Other authorities make no reference to the necessity for this skimming, so it must be left to the individual cook to test the soup and decide whether she thinks it worthwhile or not.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I think it is doubtful whether the title Potage St Germain should be given to soup made of dried peas; so perhaps it would be best if the following were called Purée of Pea Soup.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PURÉE OF PEA SOUP (I)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz green split peas weighed before soaking (soaked in tepid water overnight)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints boiling water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a bouquet garni")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 carrot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("green part of 2 leeks")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 piece of lump sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("croûtons")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("freshly chopped mint")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Put the soaked peas into cold water and bring them to boiling-point. Strain off the first water, cover again with the boiling water without salt, and add the bouquet. In another pan heat the butter, add the finely sliced carrot and onion, and cook gently for 10 minutes. Then add with the finely sliced leeks to the liquid. Add sugar, cover, cook gently till all vegetables are tender. The peas will take anything between 2 and 3 hours to be adequately cooked. Pass through a sieve, reheat, season with salt and pepper; put, if you wish, the spinach juice mentioned above in the bottom of the tureen, pour on the hot soup, and serve with small croûtons of fried bread.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PURÉE OF PEA SOUP (2)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 carrot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz dried peas, weighed before soaking (soaked for 12 hours and cooked for 1–1½ hours)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 or 4 sprigs of mint")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("300ml/½ pint single cream or good milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a few cooked canned peas for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("Melt the butter in a stew-pan. Add the finely chopped carrot, onion, and garlic. Cook for a few minutes and then add the strained peas. Pour on the stock, also the stock from the peas, add mint (reserving 1 sprig) and sugar. Stir over the fire until it comes to the boil. Draw aside and simmer until the peas are tender. Remove mint. Rub through a fine sieve and return to the pan. Heat over a slow fire, adding the cream by degrees and lastly the cooked peas. Add finely chopped mint and season. Approximate time 2½ hours.")])]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("PURÉE OF PEA SOUP (3)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("600ml/1 pint dried peas measured before soaking (soaked overnight and cooked for 1–1½ hours)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.7L/3 pints vegetable stock or water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 carrot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 turnip")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 onion stuck with cloves")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 head of celery or root of celeriac")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 large potato")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a lump of sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 bay-leaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter to add at end of cooking")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("spinach juice for colouring")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("croûtons")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Proceed as in the previous recipe except that the vegetables are cut up and added raw, not cooked in butter. Colour with juice of spinach and serve with croûtons.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It is an old-fashioned trick, and a good one, to sow early in the year, shallow seed trays thickly with seed peas (home-saved seed is economical). These are put in a warm corner of the greenhouse, and covered with paper, until they germinate, and when the tips are 2-5cm or an inch or two high they are cut over like mustard and cress and used to give a fresh flavour to soups made with dried peas or beans.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PEA-LEAF SOUP")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("175g/6 oz green split peas")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 carrot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("600ml/1 pint stock or water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 or 3 sprigs of mint")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("300ml/½ pint milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 handfuls green pea tops, grown in greenhouse")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Soak the peas overnight and give 1 hour’s preliminary cooking. Slice onion and carrot and soften in half the butter. Drain the peas and add to the pan, cook for a few minutes, then add the stock with mint, salt, and pepper. Cover and simmer until the peas are tender. Rub through a fine sieve. Melt the remaining butter in a pan and add the flour, then add the pea purée, season, bring to the boil, and finish with the hot milk. Meanwhile cook the tops in boiling water for 10 minutes, drain and sieve. Add to the soup, reheat, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here is a recipe for a soup made from little red beans known as ‘rognons de coq’. It may also be made from brown Dutch beans or from the mature seeds of runner or French beans after these have been well dried.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("POTAGE ROGNONS DE COQ (RED BEAN SOUP)")])]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz red beans (weighed before soaking)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 carrot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a dessertspoon tomato purée")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a bouquet of mixed herbs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.7L/3 pints water or vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("grated cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Soak the beans for 12 hours, then drain. Melt the butter in a casserole, add the sliced onion and carrot, the beans, and the seasonings. Toss over the fire for a few moments, then add the skinned and quartered tomatoes, the tomato purée, and the herbs. Pour on the water and simmer until the beans are soft (approximately 2–3 hours). Remove the herbs, season, and serve with grated cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here is a recipe for a soup made from white haricot beans:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE DAUPHINOISE OR SOISSONAISE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz peeled potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz white haricot beans (soaked overnight)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and freshly ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a bouquet garni")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.7L/3 pints vegetable stock (or ham stock when available is excellent)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 dessertspoon chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("150ml/¼ pint cream or top of milk (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("croûtons")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Melt the butter in a stew-pan, add onions, potatoes, and garlic, finely sliced, then the well-drained beans. Cover the pan and sweat the vegetables gently over low heat for 10–15 minutes. Add salt, freshly ground black pepper, the bouquet, and the stock. Bring to the boil, cover, and simmer until the beans are absolutely soft (about 2–3 hours). Then rub all through a fine wire sieve. Return the soup to the pan, bring to the boil, finish with chopped parsley. A little cream or top of the milk added at the last moment is a great improvement. Fried croûtons may be served with this soup.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("And, finally, a recipe for Lentil Soup:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE PURÉE DE LENTILLES (LENTIL SOUP)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("600ml/1 pint lentils")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.7L/3 pints cold water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("10g/¼ oz salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a small bacon bone, if possible")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("mint, fresh or dried")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Liaison (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("2 yolks of egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("5 tablespoons cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 rashers of streaky bacon for the garnish (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("croûtons")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("Pick over the lentils and wash well; they may either be soaked overnight or, since they are very small, cooked straight away. Put into a stew-pan with the sliced onion, water, salt, and the bacon bone. If they have not been previously soaked, add 5 tablespoons cold water to the pan every half-hour, bringing the ")]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("pan up to the boil each time. This accelerates the cooking, though it is slightly more extravagant on fuel; but it is a useful method when time is short.")])]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("When the lentils are thoroughly soft, drain off the liquid into a bowl and pass them through a fine sieve. Rinse out the pan, return the purée, and add the liquid by degrees. If the soup is too thick add a little potato or vegetable stock to clear it; if too thin a very small quantity of arrowroot mixed with water may be used as liaison. Reheat and serve with finely chopped or dried powdered mint in the soup. The liaison of egg yolks and cream may be added if the soup is to be richer.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dice the bacon finely, fry till crisp, and powder over the top of the soup when in the bowls or marmites. Fried bread croûtons may also be served.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Vegetable stock can be very good and is most useful. If made with care it can be an excellent clear soup. It may also be served with the garnishes appropriate to a real pot-au-feu bouillon, such as are called for in Croûte-au-pot, Julienne, and Paysanne. It is admirable as a basic stock for vegetable soups, a point of especial value when milk is in short supply. Vegetable bouillon or stock takes some time to make properly and has one drawback – it should not be kept beyond one day in hot weather, or two days at most in winter, for not only does it lose flavour quickly, but it is liable to turn sour.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("VEGETABLE BOUILLON OR STOCK")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb carrots")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ head of celery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a small piece of turnip")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a bouquet garni and a few peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a level dessertspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3.4L/6 pints hot water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon Marmite (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Melt butter in a large stew-pan. Peel and wash the vegetables, dry, and slice them in big pieces, add to pan and shake over a slow fire until brown. Add the peppercorns, salt, bouquet, and hot water. Bring to the boil, half cover the pan, and simmer 3 hours, or until the bouillon has a good flavour: it should reduce by about one-third. Strain off, and when cold remove any fat before using. Marmite may be added to improve colour and flavour.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("Another recipe for this pot-au-feu bouillon will be found on ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_102"
    }
  }, [_vm._v("page 102")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("IV. COLD SOUPS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Probably on account of the exigencies of our climate, cold soups, with the exception perhaps of jellied consommé, are not so universally popular in this country as in America. This is a pity, for they can be so very good. Just as hot soup should be served very hot, so cold soups should be served really cold: they lose considerably if they are just ‘room’ cold rather than ice-cold. For special occasions, and in very hot weather, it is nice if one can serve the soup-cups surrounded by crushed ice, but this necessitates an outer bowl to hold the ice in which the soup-cup, marmite, or glass bowl sits. Or one can have all the soup-bowls arranged in a long entrée dish containing the crushed ice, and either handed in this or taken out at the last minute and put on saucers.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("These soups are sometimes thick and creamy like Crème Vichyssoise ("), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_109"
    }
  }, [_vm._v("page 109")]), _vm._v("), sometimes thin but with a final addition of cream as in Winkfield Tomato Soup ("), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31#page_864",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 864")]), _vm._v("), and sometimes in jelly form as in Consommé Madrilène or Consommé en Gelée ("), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_101"
    }
  }, [_vm._v("page 101")]), _vm._v("). The two last-named should be "), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("accompanied by quarters of lemon, as the addition of fresh lemon juice is considered by many to be a great improvement.")])]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The following is a delicious summer soup which may be made with outdoor cucumbers:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("ICED CUCUMBER SOUP")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 large cucumber or 2 or 3 small outdoor ones")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 shallot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints water or light chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 sprig of mint")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 dessertspoon arrowroot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 tablespoons top of milk or thin cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("green colouring")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("shredded mint")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Thinly peel the cucumber and cut into small pieces. Chop the shallot and put it into a pan with the water or stock. Cover and simmer 10–15 minutes. Add the cucumber with the mint and cook until just tender. Rub through a fine sieve. Return to the pan, slake the arrowroot with the cream, strain into the soup, bring to the boil, season, simmer half a minute, then pour off into a bowl. Colour lightly and delicately with a little green colouring and chill thoroughly before serving. For the garnish have diced blanched cucumber or cucumber ‘peas’ cut out with a small vegetable scoop. Shake shredded mint over the soup at the last moment.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The final addition of grated lemon or orange rind to the following Cold Tomato Soup is refreshing:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("COLD TOMATO SOUP")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("900g/2 lb ripe tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 bay-leaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("6 peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 cloves")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 strip of lemon rind")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 level tablespoon arrowroot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints potato water or vegetable stock or, when available, chicken stock set in a jelly (the arrowroot may then be cut down)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5-7 tablespoons cream or evaporated milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning, including freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("lemon juice and cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("grated lemon or orange rind")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Wipe tomatoes, cut into two, squeeze to remove seeds, and cut out any stalk or green part. Put into a stew-pan with onion, bay-leaf, peppercorns, cloves, lemon rind, and stock. Cover and simmer very gently for an hour. Rub through a fine sieve. Slake the arrowroot in 2 or 3 spoonfuls of water, add to the pan, and reboil. Adjust seasoning, adding some freshly ground black pepper, a squeeze of lemon juice, and a touch of cayenne. Pour off and cool. Then chill thoroughly. Serve in bowls with a spoonful of cream in each. Grate a little lemon or orange rind on top.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Soupe Verte is delicious green soup made either with a clear bouillon half of ham and half beef, carefully cleared and skimmed, or with vegetable or chicken stock. The soup may suitably have a whole hard-boiled egg served in the middle of each plate. Half an egg is given here, and this may be sliced or quartered if preferred. This soup may be served hot or ice-cold, and rolls of brown bread and butter are good with it.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SOUPE VERTE (RUSSIAN)")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("Have ready some bouillon: half ham, half beef is best. When hot put into it 2 parts of spinach, 1 part ")]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("of green onions, and 1 part of sorrel, all finely chopped, and celery tops and parsley to flavour. Add a bouquet garni. Simmer for about 1 hour. Thicken with sour cream and flour mixed, season, and serve half a hard-boiled egg in the middle of the soup-plate.")])]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("This is not a precise recipe. One requires enough of the vegetables to impart a good flavour, and about three times as much liquid as solid in the finished soup. R. H. takes to each quart of liquid approximately a double handful of spinach, one each of onion and sorrel, and half that quantity of celery and parsley.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The following cold Spanish soup, Gazpacho, has not so much oil in it as is used in the real Spanish article. But it is difficult to get the thin, clear, perfect olive oil in this country, and in this recipe the oil is modified to suit English palates.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("GAZPACHO ANDALUZ")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 cup breadcrumbs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("red wine vinegar to taste")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 small outdoor cucumbers")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 green pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ glass salad oil")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("iced water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900g/2 lb tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("croûtons of toasted bread and a bowl of cubes of ice")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Soak the crumbs in 2 tablespoons vinegar. Pound the garlic to a cream with a teaspoon of salt. Chop roughly 1 cucumber, ½ the green pepper, and the onion and put them, with the crumbs, into the mortar. Pound to a paste, then rub the paste through a fine sieve. Add the oil a few drops at a time as for mayonnaise. Season with a little more vinegar if necessary and pour into a tureen. Add the iced water and the tomatoes rubbed through a sieve: the amount of water depends on the juiciness of the tomatoes, but the soup should be of fairly thin consistency. Season with salt and pepper and chill well. The remaining cucumber and pepper, cut up, may now be added to the soup or served separately. Small croûtons of toasted bread and a bowl of cubes of ice are also handed out to be added to the soup.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CHERRY SOUP")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Fruit soups are popular abroad, but little known here. They are refreshing and palatable, and deserve a trial. Cherry, perhaps, is one of the nicest in flavour, and may be made from fresh or canned cherries. For fresh choose a good red cherry, for canned, morellos.")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb cherries (weighed when stoned)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4–5 lumps of sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 orange")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 glass red wine (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 dessertspoon arrowroot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("sugar to taste")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Put the cherries into a pan. Rub the lumps of sugar over the orange to remove the zest. Add to the pan with the strained juice, the wine, and the water. Bring to the boil, simmer 5–6 minutes. Slake the arrowroot with a spoonful or two of water, add to the soup while just off the boil. Reboil and sweeten to taste. If the liquid is too thick with fruit, take out some and replace with a little water.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("Crème Vichyssoise is so delectable a dish that it finds its place in the party section of this chapter, ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_109"
    }
  }, [_vm._v("page 109")]), _vm._v("; also it calls for chicken stock and at least 300ml/½ pint cream, so it is by no means a dish for every day.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("Another party soup is a cold cream of curry soup which R. H. has kindly christened ‘Crème Constance’. A recipe for it is to be found on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31#page_863",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 863")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The advent of emulsifying apparatus has added to the possible repertoire of cold soups, and reference is made to these in the chapter on modern kitchen appliances, "), _c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter37#page_1024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 1024")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter37#page_1028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1028")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("V. MULLIGATAWNY AND CURRY SOUPS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The curry soups vary considerably in the degree of spiciness, but they should not, for the normal palate, be over-peppery – certainly not so peppery as a curry itself may be. Some of them may be quite bland in seasoning, tasting of nuts and spices and agreeable to the most sensitive palate. If you like cooking and like spices you will not be satisfied with having just a tin of curry-powder and one of paste in your store-room, but you will have, as mentioned in the curry chapter, the individual spices which together make the generally accepted curry-powder; and you will certainly have desiccated nuts of some kind, preferably coconut and almonds.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There are three distinct main types of mulligatawny; it can be in the form of:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("(a) consommé")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("(b) gravy broth")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("(c) thick soup")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The base of the first is good bouillon or stock, and the flavouring is imparted to it by the infusion in it of whole spices. The following recipe calls for beef bouillon, but Mulligatawny Maigre, which is not the real thing, may be made in exactly the same way, using vegetable stock.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CONSOMMÉ MULLIGATAWNY")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1.7L/3 pints well-flavoured beef")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("bouillon (see "), _c('a', {
    staticClass: "color1",
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_100"
    }
  }, [_vm._v("page 100")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz minced gravy beef")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 egg whites")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 tablespoons good Madeira")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Spices for infusing")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("15g/½ oz each of coriander and cardamom")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("10g/¼ oz each of cumin seed and fenugreek")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("12 peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("thinly peeled rind of 1 lemon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 bay-leaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("75g/3 oz rice")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("10g/¼ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("a little turmeric")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("quarters of lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Bruise or pound lightly the spices and garlic, and put together with lemon rind and bay-leaf into a muslin bag tied tightly at the neck so that they cannot escape. Put the bag into the bouillon; bring to boil and keep at simmering-point until the liquid is well flavoured with the spices. This takes from 40 minutes to an hour. Remove the bag; allow the bouillon to cool, and clarify in the following manner. Put the minced beef into an enamel or tin-lined pan, add whites whipped to a froth and the bouillon. Whisk over moderate heat until it boils. Then stop whisking and allow the liquid to boil up. Draw aside and set on very low heat for half an hour. Strain carefully through a wet cloth, season, add Madeira, and reheat without allowing soup to boil. Hand out boiled rice, mixed with butter and coloured lightly by the addition of a little turmeric, and also quarters of lemon.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("See also reference to Oxtail Soup with addition of spices ("), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_104"
    }
  }, [_vm._v("page 104")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("THICK MULLIGATAWNY (1)")])]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints strong beef stock, flavoured with vegetables")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Spices for infusing")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("10g/¼ oz cardamom, whole")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("6 peppercorns, whole")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("10g/¼ oz coriander, whole")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("5g/"), _c('span', {
    staticClass: "entity"
  }, [_vm._v("⅛")]), _vm._v(" oz fenugreek, whole")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 bay-leaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("the pared rind of ½ lemon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 tablespoons desiccated coconut steeped in a tea-cup of boiling water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz onion or shallot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter or dripping")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 heaped teaspoon curry-powder")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Bruise all the spices lightly and put them into a muslin bag with the bay-leaf and lemon rind. Simmer for half an hour in the prepared stock, then remove bag and set stock aside. Pour the boiling water over the coconut and allow to steep for half an hour. When required strain it through muslin.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chop the onion finely and fry slowly in the heated fat, add the curry-powder and continue frying for a few minutes. Add the flour off the fire, cook for a minute, then add the stock. Simmer a quarter of an hour, strain, add coconut milk. Return to pan to heat up, reduce a little if necessary, adjust seasoning, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("THICK MULLIGATAWNY (2)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints meat, fish, or vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1½ tablespoons desiccated or 3 tablespoons freshly grated coconut")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1½ tablespoons ground sweet almonds")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("300ml/½ pint boiling water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 small clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz finely chopped shallots")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz flour or cream of rice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon curry-powder or powder and paste mixed")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Spices for infusing")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("15g/½ oz each of cardamom and coriander")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("8 peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("10g/¼ oz fenugreek")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 bay-leaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("the thinly peeled rind of ½ a lemon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("75g/3 oz boiled rice coloured with turmeric")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("quarters of lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("As in previous recipe, bruise the spices, put with lemon rind and bay-leaf in a muslin bag, and infuse in the stock in a covered pan for 30–40 minutes after boiling-point is reached. Mix the nuts together, pour over the boiling water, and leave to steep until required. Melt the butter in a large saucepan, keeping back 15g/½ oz; add shallots and garlic and fry slowly until turning colour, then add curry-powder and continue cooking slowly for 5 minutes, stirring constantly. Draw aside, stir in flour, and add stock by degrees; bring to boil, skimming from time to time, then simmer uncovered 10–15 minutes. Strain carefully. Return to a clean pan. Strain the nut mixture through muslin and press to get as much milk as possible. Add this to the soup, reboil, adjust seasoning, and add a squeeze of lemon juice. If the soup is too thin, it may be reduced or thickened with a little arrowroot. Hand quarters of lemon and boiled rice into which you have stirred the remaining 15g/½ oz of butter cooked with the turmeric.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("N.B. This soup may be enriched by the addition of a liaison of egg yolks.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("THIN MULLIGATAWNY OR GRAVY BROTH")])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Proceed exactly as for the Thick Mulligatawny above, but use only 20g/¾ oz butter and 20g/¾ oz flour. Add 2 tablespoons boiled rice when the nut milk is added, and omit the liaison of egg yolks.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("N.B. A good fish stock well flavoured with onion and herbs is excellent for this, as for instance the court bouillon in which salmon has been boiled. Stock made from a cod’s head, plenty of root vegetables, and some lemon rind is also good.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following soup is delicately flavoured and not at all hot, though of course the amount of curry-powder may be increased. Three or four ripe coriander seeds crushed and added to the broth before it is sieved give it a distinctive and, I think, delicious flavour.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE PONDICHERRY")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("3 leeks")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon curry powder")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("600ml/1 pint white stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz rice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("150ml/¼ pint milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Liaison (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("1 egg yolk")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("5 tablespoons cream or 15g/½ oz butter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Blanch the leeks for 10 minutes. Melt the butter, add the finely chopped leeks, and cook them for a few minutes, shaking and stirring to help them to dry a little. Add curry powder and continue cooking for some minutes. Add stock, rice, and milk and continue cooking gently for about half an hour. Put through a fine wire sieve, return to pan, season, and add the liaison or beat in a little extra butter. A little plain boiled rice, very dry, may be handed with the soup.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("VI. FISH SOUPS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Fish soups are not, on the whole, greatly popular in England, except perhaps for lobster bisques and, before they became pearl-like in value, oyster soups. I had always had the idea that an oyster soup was only for very special occasions, something to be thought about beforehand, to be concocted with infinite care with silence in the kitchen. The first time I saw it made in an American kitchen I felt quite dazed. It was in the middle of a big cocktail party. From a fairly large room there led off a tiny kitchen; this kitchen was orderly, organized, equipped to the last degree with American ingenuity, and in it the cocktail savouries were laid out so that the guests ranged in and out helping themselves. In the middle of a bewildering noise of laughter and talk I heard my hostess ask a guest if he would like oyster broth instead of a drink; he accepted her suggestion, and then followed activity that seemed to me more like sleight-of-hand than plain cooking. This is what the hostess did, and in less time than it takes to write: she put a small double saucepan on the gas-ring, took from the ice-box a half-pint carton of milk, poured it in the pan, took another carton containing oysters, slipped a few of them into the boiling milk, added seasoning and cream, took a jar of small crackers from the shelf, crumbled them into the broth, and there it was, steaming, smelling good, and taking less time than making tea. It certainly revolutionized my ideas about oyster broths.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("All the same I think that perhaps in an English cookbook a few recipes for fish soup will suffice: a fish stock that can be adapted to various soups, a shrimp and potato soup, practical and homely, a Soupe aux Moules and a simple Mussel Broth, and, reserved for the party section, a Lobster Bisque. The famous ")]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("bouillabaisse, truly a fisherman’s soup, is made from an assortment of Mediterranean fish which it would be difficult to get in this country, so it was decided that to include a recipe would be too unrealistic.")])]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("FISH STOCK")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 or 2 sole bones or good fish trimmings")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 large bunch of parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 bay-leaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 large sliced onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("white wine, ½ bottle, is desirable; a smaller amount may be used")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("8 peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.7L/3 pints water (approx.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Wash bones well and put all ingredients in a pan (the water should cover the contents). Simmer gently until liquid is reduced by about a third, then strain off and use.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE DE CREVETTES (SHRIMP SOUP)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb. potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz leek (white part only)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints fish stock (see above) or milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("fennel")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 yolks of egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("150ml/¼ pint cream or top of milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("croûtons")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz picked shrimps")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("Peel and quarter the potatoes; slice the leek, put both into a pan with the stock and add fennel and salt as required. Cover and simmer gently for 20 minutes. Rub through a fine wire sieve, rinse out the pan, pour in the soup, and bring slowly to the boil, stirring in the butter in small pieces. Mix the beaten yolks with the cream or milk, add to the soup off the fire in the way indicated for liaisons, ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06#page_118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 118")]), _vm._v(", and add the washed and coarsely chopped shrimps. Serve at once with the croûtons.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following is a light cream soup suitable for dinner:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SOUPE AUX MOULES")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("sole or plaice bones")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225ml/8 fl oz white wine or cider")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("750ml/1¼ pints water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a bouquet garni")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a slice of onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("20g/¾ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints mussels (see note on preparation of mussels, "), _c('span', {
    staticClass: "color1",
    attrs: {
      "href": "#/xhtml/22_Chapter16#page_427",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 427")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("croûtons")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Liaison")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("7 tablespoons cream or top of milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("2 yolks of egg")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Make a stock with bones in the following way. Put the washed fish bones into a pan with half the wine and all the water. Add the bouquet garni, onion, and garlic. Bring to the boil and simmer for 20 minutes. Melt the butter in a pan. Add, off the fire, the flour and seasoning. Stir until smooth. Strain on the fish stock and bring to the boil. Leave to simmer for 15 minutes. Wash and scrub the mussels. Put them into a pan with the rest of the wine. Cover and bring to the boil. Shake over the fire for 2 or 3 minutes, "), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("strain the liquor into the soup. Shell the mussels and remove the beards, add to the soup, and simmer for 5 minutes. Mix the yolks and the cream and make the liaison in the usual way. Add croûtons and serve sprinkled with chopped parsley.")])]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("MUSSEL BROTH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This soup, which is suitable for luncheon, is not a very ‘fishy’ one, though fish in place of vegetable stock may be used if a more pronounced flavour is wanted. The mixture of a small quantity of court bouillon (to taste) with the vegetable stock is excellent, as the former offsets the sweetness of the latter.")])]), _c('div', {
    staticClass: "space"
  }, [_c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints good mussels")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("6 peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 large bouquet garni")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 glass white wine or dry cider")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a squeeze of lemon juice")])]), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("4 large tablespoons finely cut mirepoix (see ")]), _c('a', {
    staticClass: "color1",
    attrs: {
      "href": "#/xhtml/09_Chapter03#page_33"
    }
  }, [_vm._v("page 33")]), _vm._v("), made with carrot, leek, turnip, celery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints unsalted vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz good tomatoes, peeled, squeezed, and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 clove of garlic, crushed with salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 French roll")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon chopped parsley")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Well wash and scrub the mussels, removing all weed. Put into a large pan with the peppercorns, bouquet, wine, and lemon juice. Cover and bring to the boil, shaking frequently.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When the mussels are well opened, shell, removing the beards. Strain the stock through a fine muslin and leave to settle. Put mussels aside in a small covered bowl. Melt the butter in a large saucepan, add the mirepoix, cover with paper, then the lid, and sweat gently for about 7 minutes. Then carefully stir in the flour, add the vegetable stock, blend thoroughly, and pour in the mussel stock, being careful not to disturb the dregs in case of any sand. Stir until boiling, add the tomatoes and garlic, cover, and simmer 5 minutes or until the vegetables are quite tender. Draw aside, add mussels, and adjust seasoning.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cut the roll into thin slanting slices, bake lightly in the oven, put in the bottom of the tureen with the parsley. Pour on the boiling soup and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE POISSONIÈRE (CREAM OF WHITING)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("2 medium-sized whiting")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints milk or milk and water mixed")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz carrots")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz celery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz parsley roots")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon grated horse-radish")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 small glass white wine")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("20g/¾ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a little grated nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 tablespoons parsley sprigs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 tablespoons cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("fried croûtons")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Fillet and skin the whiting. Wash and break up the bones and heads of the fish, put bones with the skin into a pan. Add the milk and salt. Bring to the boil, skim, add the vegetables, sliced, with the parsley roots and horse-radish. Cover and simmer 30 minutes, then strain off through a fine strainer. Meanwhile poach the fillets of fish in the wine in a shallow pan, allowing the liquid to reduce well, and covering "), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("the fillets with a buttered paper. Then pound or beat the fish with half the butter until very smooth.")])]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Melt the remaining butter in a saucepan, add the flour, mix, then add the strained stock. Stir until boiling, then whisk in the purée. Adjust the seasoning and add nutmeg. The soup may now be rubbed through a fine wire or nylon sieve to give a smoother finish. Blanch the parsley sprigs for 1 minute, and lightly whip the cream. Fold into the soup with the parsley just before serving. (If an egg liaison is used, mix in the usual way.) Serve croûtons separately.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("VII. STOCKS, BOUILLONS, AND MEAT SOUPS")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("STOCKS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Ordinary household stock, which, it should be noted, can in no way replace the real bouillon made from pot-au-feu, may be made twice a week, or for large households, daily. It may contain cooked meat bones, chicken carcasses, vegetables and debris of vegetables which have been prepared for other dishes (the debris from tomatoes should be avoided as it may turn the stock sour), bacon rinds, and mushroom peelings. The carcasses of game and duck are best kept apart and used for separate stock or gravy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("The pot.")]), _vm._v(" A special pot, which may be of earthenware, enamel, or tin-lined copper, should be kept for stock. A small pot with a tap is most useful; the stock may then be drawn off and the fat and bits held back. The vegetables should form a third of the total raw materials of the stock.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The following household stock is suitable for the making of sauces, gravies, broths, and simple soups; as has already been said, it cannot replace proper bouillon. The vegetables may be varied according to supplies, but they should be so balanced that no one flavour predominates.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("The bones.")]), _vm._v(" The bones should be broken up in as small pieces as possible, and browned before using, either in the stock-pot or in a roasting-tin in the oven. In neither case is fat added, as there is sufficient on the bones to prevent burning. It is inadvisable to mix raw and cooked bones, as the resulting stock is cloudy and does not keep well.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("The vegetables.")]), _vm._v(" The stock is improved in flavour and colour if the carrots and onions are lightly coloured–fried in a little dripping–before being added to the stock-pot. The onions are stuck with two or three cloves each.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("HOUSEHOLD MIXED STOCK")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("cooked meat bones")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chicken carcasses")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("giblets")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("bacon rind")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("sliced vegetables (onion, carrot, leek, celery or celeriac)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("mushroom peelings")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a bouquet garni")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a few peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("water to cover")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-noindentc"
  }, [_vm._v("N.B. The sliced vegetables should form a third of the total materials of the stock.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Break up the bones in small pieces and brown in the oven or in the stock-pot. Fry the vegetables lightly in dripping. Put the bones, bacon rind, giblets, vegetables, mushroom peelings, bouquet, salt, and peppercorns into the pot and add the water. Bring slowly to the boil, skim, and simmer, half covered, for 3-4 hours. Strain at once, and when cold skim off all the fat. This fat may be clarified and used for dripping, etc.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_97"
    }
  }), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("This stock should be used within a day or two of making, and should be kept in a cool place. If the stock-pot is kept on the stove, so that the contents remains tepid for a long time, the stock will go sour.")])]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("BONE STOCK")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Stocks made entirely from bones, or those in which bones play a predominant part, should be used only for sauces. They are not suitable for clear soups and consommés, to which they would impart an unpleasant flavour and a gluey consistency. A small amount of bone, preferably veal, is permissible. One should use meat stock for real consommés and mixed household stock for simple soups.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Here follows a recipe for pot-au-feu suitable for bouillon and consommés. This is the proper foundation stock for soups and consommés, and for some sauces. From it derive such classic soups as Petite Marmite and Madrilène.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POT-AU-FEU")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 veal bone")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chicken giblets (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz rolled ribs of beef, with the bones")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3—3.5L/5½–6 pints water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 level dessertspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("cold water for skimming")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("175g/6 oz carrots")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("150g/5 oz turnips")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 leeks")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 stick of celery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz parsnip")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 onions, each stuck with 1 clove")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a bouquet garni")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Wash the bones and giblets, put into the bottom of a soup marmite, lay the meat on the top, pour over the water, and add the salt. Set on a gentle heat, uncovered, and bring to the boil: this must not take less than half an hour. Remove all the scum with a metal spoon as it rises to the surface, and when at boiling-point throw in a coffee-cup of cold water. Bring again slowly to the boil, skimming well; throw in another coffee-cup of water and repeat this process. This helps to clear the bouillon and removes any strong taste of meat or bone. Add all the vegetables, whole or quartered according to their size, bring up to the boil, skim again, and wipe round the inside of the pot. Put in the bouquet, and half cover with the lid; simmer continuously for 3 hours. Strain off the liquid, leave until cold, and remove all fat.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("If the meat is to be served separately")]), _vm._v(" it may be taken out of the bouillon after 1½ hours and served as boiled beef with the vegetables. The bouillon is then left to simmer with the bones for another 1½ hours before straining, and it is strong enough for Croûte-au-pot, Julienne, and Paysanne.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If the bouillon is required for consommé, the meat should be left for the full time.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When a large quantity of meat can be used, say 2.25—2.7kg/5–6 lb., two different cuts should be chosen; for example, 1.5kg/3 lb topside or top rump and 900g/2lb brisket will give a lean piece with a fatter one, which will make the bouillon richer. For this amount of meat 350g/12 oz bones should then be added, and the proportion of carrots and other vegetables increased to double the quantity mentioned above.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Many recipes call for the meat to be cut up in small pieces for the making of consommé, the idea being to extract more juices, but after long cooking the bouillon will probably be cloudy.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the early summer, when the winter vegetables are not obtainable, onions alone may be used, with 1 large clove of garlic, well crushed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The colour of the bouillon may be improved by adding a well-grilled sliced tomato with the vegetables. The slices of tomato should be sprinkled with sugar before grilling.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_98"
    }
  }), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("CROÛTE-AU-POT")])]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_c('p', {
    staticClass: "h4"
  }, [_vm._v("for 850-1200ml/1½–2 pints")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 long French roll")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("vegetables from the pot-au-feu")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("¼ of a small cabbage cooked apart in a little bouillon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chopped chervil")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Slice the roll and bake lightly in the oven. A little of the fat from the bouillon may be poured over the slices of bread before baking. Cut the vegetables and the cabbage into neat, even-sized dice and put them into the tureen or soup marmite. Boil up the bouillon and pour it over the vegetables; then add the croûtes with a good pinch of chopped chervil.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PETITE MARMITE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The stock for this classic soup is from a pot-au-feu well flavoured with chicken. Chicken giblets, together with the carcass of a raw fowl, preferably, or failing this that of a cooked chicken, are added with the other meat.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The stock can be clarified as for consommé, but if it is clear, strong, and of a good colour this can be omitted, the stock being merely strained and skimmed well.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The soup should be served in little marmites and have a traditional garnish of shredded chicken and a julienne of carrot, turnip, the white part of a leek, and shredded cabbage, all cooked in a little of the stock before being added to the soup. Rounds cut from a ‘flute’ and lightly baked are served separately, as sometimes is grated Parmesan.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The addition of long thin strips of vegetables to a bouillon confers the name of Julienne.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE JULIENNE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 medium-sized carrot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 medium-sized onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 leek")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a small piece of turnip")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a spoonful or two of fat from the pot-au-feu")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a pinch of sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints bouillon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a little chopped chervil")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut the vegetables in long thin strips lengthwise, "), _c('i', [_vm._v("en julienne")]), _vm._v(". Put into a pan with the fat from the pot-au-feu, the seasoning, and the sugar. Cover as tightly as possible, put over gentle heat or into the oven, and cook until the vegetables are tender and slightly brown. Drain off any fat there may be. Add the thoroughly drained vegetables to the bouillon and leave on gentle heat for about 15 minutes. Serve with a little chopped chervil.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE PAYSANNE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Prepare in the same way as Julienne, but this time cut the vegetables into rounds the size of a shilling. They may be cooked in the bouillon itself instead of the fat in this case. Add chopped parsley in place of chervil.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CONSOMMÉ")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("To make a good consommé it is essential to have a specially strong, clear bouillon of a rich brown colour. This is usually taken from a pot-au-feu which has been made with the maximum quantity of beef, and ")]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("simmered for the full length of time before straining and cooling. When economy in meat is called for, the following recipe is useful and will give a strong, clear bouillon. For this the addition of a chicken carcass or giblets is required, particularly if the bouillon is to form the base of a Consommé Madrilène (a clear tomato soup with a strong chicken flavour) or a chicken consommé. The carcass may be raw and well broken up; the meat from it can be used for a chicken cream, for galantines, suprêmes, and in other ways.")])]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("SIMPLE BOUILLON FOR THE MAKING OF CONSOMMÉ")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz shin of beef")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 chicken carcass")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz carrot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 level teaspoons salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a bouquet garni tied to a stick of celery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("6 peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2.4L/4 pints water")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut the meat up into 6-8 pieces. Break up the carcass and cut the onion and carrot into thick slices. Heat a thick aluminium or iron pan, put in the meat and bones, and cook over moderate heat until thoroughly and evenly brown, adding the onion half way through the process. Draw aside, add the bouquet, salt, peppercorns, and water. Bring to the boil and simmer, uncovered, 3-4 hours, or until the liquid has reduced to a little over 1.2L/2 pints. Strain off and cool.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It is sometimes necessary to add a very small quantity of fat during the preliminary frying, if the meat is exceptionally lean.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After cooking the meat has little value; it can be made into rissoles or cottage pie, but in pre-war days it was not used again.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("LE CONSOMMÉ")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1.7L/3 pints strong bouillon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("350g/12 oz lean minced shin of beef")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 tablespoons good sherry or Madeira")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("whites of 2 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("additional sherry to add at end")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("Put the bouillon into an enamel or tin-lined pan, with the beef and 5 tablespoons sherry or Madeira. Whip the whites to a light froth, add to the pan, then whisk over a moderate heat, whisking backwards, i.e. the reverse of the usual whisking movement, until the liquid is at boiling-point. Then stop whisking and allow the soup to come right up to the top of the pan. Draw aside, then boil up carefully once more, taking care not to break the crust which will form on the top. Draw aside and leave for a good hour on a very slow heat. This is to extract all the flavour from the meat. Scald a clean cloth, wring it out, place it over a bowl, and pour the soup through, at first keeping the crust back with a spoon, and then at the end sliding it out on to the cloth. Pour the soup again through the cloth and through the filter of egg white. (See notes on clarifying, ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_101"
    }
  }, [_vm._v("page 101")]), _vm._v(".) The consommé should now be clear. Add extra sherry at this point and any garnish called for. Reheat but do not allow to boil.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Certain garnishes added to consommé give it various names. For example, the addition of dice of a cooked savoury custard made with egg white gives it the name of Consommé à la Royale; with a garnish of tiny fine cooked dice of carrots, turnips, and celery it becomes à la Brunoise; and so forth. (See garnishes for soup, "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_111"
    }
  }, [_vm._v("page 111")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("CONSOMMÉ MADRILÈNE")])]), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb red, ripe tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints strong chicken bouillon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz minced gravy beef")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("whites of 2 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 tablespoons good sherry or white wine")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 strip of lemon peel")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("quarters of lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Put the prepared tomatoes (coarsely chopped but not skinned) into an enamel or tin-lined pan with the cold bouillon, minced beef, and the whites whipped to a froth. Mix thoroughly, add the sherry or white wine and lemon peel, and whisk steadily over a moderate fire until boiling. Stop whisking and allow to boil up. Draw aside and set to simmer very gently, so gently that there is barely any movement of the liquid, for half to three-quarters of an hour. Take off the fire and after 10 minutes drain carefully through a cold, wet cloth. Serve "), _c('i', [_vm._v("en gelée")]), _vm._v(" in soup-cups with small quarters of lemon handed separately (see Consommé en Gelée below).")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Madrilène may also be served hot, in which case blanched tarragon leaves may be added when reheating.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("N.B. Add 1 teaspoon gelatine if the chicken bouillon is not sufficiently gelatinous.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CONSOMMÉ EN GELÉE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This is prepared as for ordinary consommé, but it is unnecessary to have the bouillon set to a jelly before clarifying. To make it more gelatinous a slightly greater proportion of veal bone is required in the pot-au-feu. Bouillon should not be made to set by the addition of gelatine, which does not give the right consistency and detracts from the flavour.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A cold consommé should, when thoroughly chilled, barely set to a jelly; it should not be iced and should never be so firm that it can be cut with a spoon. It should be served with quarters of lemon.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The following summary is given to emphasize the foregoing points.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("NOTES ON CLARIFICATION OF BOUILLON")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("1. The bouillon")]), _vm._v(" should be cold and, for a successful result, of clear brown colour. It is impossible to clarify properly a grey, muddy bouillon.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("2. The utensil.")]), _vm._v(" An enamel or tin-lined pan should be used rather than one of aluminium, which is apt to cause the liquid to be cloudy. Both pan and whisk should be scalded before being used.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("3. The addition of raw minced beef.")]), _vm._v(" The presence of albumen in the beef helps clarification, as it coagulates and helps in the precipitation of fine solid particles. The beef also adds to the richness of flavour and is called for in the making of a fine consommé and of aspic.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("4. The addition of wine.")]), _vm._v(" Sherry, Madeira, white and red wines are called for in some recipes, and they help in the final clarification and improve the flavour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("5. Egg whites.")]), _vm._v(" These are whipped to a froth only; the shells are sometimes added, but this is not essential, although adding to the efficiency of the filter. Again it is the coagulation of the albumen which helps the precipitation of fine solid particles, the presence of which gives a cloudy appearance. The white crust which forms on top of the bouillon as a result of adding egg whites must not be broken. It should be gently slid from the pan on to the cloth or into the jelly-bag, as it acts as a filter.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("6. Method.")]), _vm._v(" The ingredients are all put together into the pan, the whites whipped to a froth, the pan set on a moderate fire, and the whole whisked steadily until the contents are on the boil. The whisking ")]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("should be backwards, i.e. the reverse of the usual movement; this results in a more thorough mixing of the egg white with the liquid. Immediately the liquid boils whisking is discontinued and the liquid allowed to come right up to the top of the pan; the pan is then drawn aside and left on a slow fire for the time indicated in the recipe.")])]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("7. Straining.")]), _vm._v(" For this purpose a clean cloth is used, although when a cloudy consommé is to be strained a jelly-bag is found more practical, as the liquid has to be strained several times. The cloth should first be scalded, then wrung out and placed over a bowl. The liquid is then poured carefully through, the crust being kept back at first and then tilted gently on to the cloth. If the liquid is not absolutely clear directly it comes through, the cloth should be moved quickly over another bowl and the liquid put back into it for re-straining through crust and cloth.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The cloth must be neither squeezed nor pressed. The liquid should drain through it slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("8. When a jelly-bag is used")]), _vm._v(" this should be well scalded before the liquid is poured in, then immediately a small quantity comes through it should be returned to the bag, and this should be continued until the liquid runs clear.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("VEGETABLE BOUILLON OR STOCK")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The following recipe for a bouillon de légumes, or a pot-au-feu made only with vegetables, gives a broth, or rather a bouillon, of good flavour. The quantities of vegetables are so balanced that no one flavour predominates, and the haricots are an important ingredient, forming as they do a good base. Small white haricots should be chosen, as the larger ones are apt to break in cooking and spoil the clearness of the liquid.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POT-AU-FEU BOUILLON MADE WITH VEGETABLES")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("600ml/1 pint haricot beans")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("175g/6 oz each of onions and turnips (the onion should be stuck with cloves, 3 or 4 according to size)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz leeks")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz carrots")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz celery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz parsnip")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2.8L/5 pints water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a bouquet of a good handful parsley stems, a sprig of thyme, 2 bay-leaves, and a small clove of garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Although it is unnecessary to soak the haricots, nevertheless this broth takes 6 or 7 hours to make.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("Cover the haricots with water and bring to the boil. Allow to boil for 2 minutes and then set aside for half an hour. Take half the number of carrots called for and slice. Cut the onions in thick slices and stick with cloves. Soften the sliced carrots and the onions in the usual way, allowing them to colour on a gentle heat and stirring and shaking from time to time so that they do not burn. They should colour to a deep golden brown, but not be allowed to catch. This will take anything from 15 to 20 minutes. When ready draw aside from the fire and add all the water. Add the drained haricots and the salt and bring to the boil. Add the remainder of the vegetables (with the exception of the leeks and the remaining half of the carrots) and the bouquet. Bring to the boil and allow to simmer very gently for 3 hours. Now add the remainder of the carrots split in two (not diced) and the white part of the leeks tied up into a bundle. Allow the simmering to continue for another 3 hours. At the end of this time the saucepan should be taken away from the heat, but it may be left on the corner of the stove, so that it does not get entirely cold, and remain there during the night. When required for use next day, lift out gently the ")]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("bundle of leeks and the long pieces of carrot. Strain the bouillon through a fine sieve, but be careful to take off the liquid without disturbing the deposit of fine vegetables and the thicker liquid at the bottom of the pan. Heat this clear liquid and serve with thin dry toast. At the same time the leeks and carrots may be handed separately.")])]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("N.B. This is an excellent and economical bouillon to use for the Iced Curry Cream Soup on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31#page_863",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 863")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("KIDNEY SOUP (1)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("giblets of 2 chickens cut in pieces")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 minced kidneys, and 1 sliced")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 large sliced onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("125g/4¼ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints stock or water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a bouquet garni")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz unskinned tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 clove of garlic, bruised")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 bay-leaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a few peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("150ml/¼ pint stock or water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/¾–1 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 tablespoons reduced sherry or red wine")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("croûtons of fried bread (10p size)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Toss the giblets and minced kidneys with the onion in 50g/2 oz butter until brown. Pour on 1.2L/2 pints of stock or water, add the bouquet, and simmer 40 minutes or until of good flavour and reduced by about a third.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Slice the tomatoes and red peppers and cook to a pulp with 25g/1 oz butter, garlic, salt, bay-leaf, peppercorns, and 150ml/¼ pint stock or water. Rub through a strainer. Strain the soup and add the tomato mixture. Work 25g/1 oz butter with 20g/¾ oz flour, or 25g/1 oz if the soup is very liquid. Add the kneaded butter in small pieces to the soup, whisking it well in. Reboil thoroughly, adding the sherry or red wine and the finely sliced kidney, sautéd in 10g/¼ oz butter, for the garnish. Dust the top with chopped parsley when serving, and hand round the croûtons of fried bread.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The following second Kidney Soup is a good winter dish. The blanching of the kidneys in the way described obviates any possibility of an unpleasant flavour. The recipe is suitable for adaptation to game, and provides a good way of using a badly shot bird.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE PURÉE DE ROGNONS (KIDNEY SOUP) (2)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("2 sheeps’ kidneys")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints well-flavoured stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 large dessertspoon dried mixed herbs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a pinch of ground mace")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 whole anchovy or 2 fillets (soaked in milk to extract the salt)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("20g/¾ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("20g/¾ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a small glass sherry")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 heaped teaspoon red-currant jelly")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a good squeeze of lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a little browning or caramel")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("croûtons of fried bread")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Skin the kidneys, drop into boiling salted water, and blanch for 2–3 minutes. Drain and dry. Put into a pan with a cup of the stock, the herbs, and the spice, and simmer gently until very tender. Then remove and mince finely with the anchovy, or pound until smooth in the mortar. Rub through a fine "), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("wire sieve. Strain the stock back into the remaining stock.")])]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Make a roux with the butter and flour, pour on the stock, stir until boiling, simmer a few minutes, then add the purée, the sherry, jelly, and lemon juice. Adjust seasoning, skim, add a little browning or caramel to deepen the colour, and serve with the croûtons.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PURÉE OF GAME SOUP")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Use the above recipe with the following modifications: Substitute for the kidneys 110-175g/4-6 oz raw or cooked game, hare, grouse, or pheasant. Use the bones for making the stock. If the meat is cooked proceed straight away to mince and/or pound finely. The anchovy may be included or not according to taste.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("OXTAIL SOUP")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This soup may be thick or clear. The former is made in the same way as an oxtail stew, but with, of course, more liquid. Nowadays, when oxtails are difficult to come by, it is an economy to make thick soup from the remains of an oxtail stew, or to make a clear oxtail from a fresh tail, and in the next day or two follow with a thick soup or ‘quick stew’ made from the left-overs and second stock. A tail is fairly large and so easily provides these two dishes for a family of four.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Oxtail makes an excellent clear soup, a little more "), _c('i', [_vm._v("recherché")]), _vm._v(" than a thick one. Both clear and thick can, however, be made from one tail. The recipes given here are on those lines. (If a clear mulligatawny is wanted, a simple method is to infuse curry spices in the stock during the simmering process, removing them when the stock is sufficiently flavoured. The drawback here is that all the stock and meat is then so flavoured. The spices are: 1 tablespoon whole coriander, 1 teaspoon whole fenugreek, 1 dessertspoon whole cumin, 1 dessertspoon whole cardamon, 2 whole cloves of garlic. Tie in muslin before adding.)")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CLEAR OXTAIL")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("to be made a day before it is needed")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 good-sized tail")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter or bacon fat")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz onions, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz carrots, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz swede or turnip, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 stick of celery, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("450ml/¾ pint good stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 glass good sherry or Madeira")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("about 3.6L/6 pints water or good clear stock (this improves the strength and quality of the consommé)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4–5 parsley stalks, 1 bay-leaf, and 2–3 sprigs each of savory and lemon thyme, all tied together")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4–6 peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz lean gravy beef")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("whites and shells of 2 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("an extra glass sherry")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Well wash and dry the tail, or it may be blanched for 3–4 minutes before being drained and dried. Cut into pieces and crush each piece slightly with the flat of a chopper. Choose a thick braising-pan, put in the butter, add the vegetables, and "), _c('i', [_vm._v("rissoler")]), _vm._v(" gently for 5–10 minutes. Now add the pieces of tail and continue to rissoler, allowing them to take colour. Pour in the stock and sherry and allow to cook, swirling the pan around from time to time until the liquid has reduced practically to a glaze.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_104"
    }
  }), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("Now cover well with water, add salt, herbs, and peppercorns, Bring slowly to the boil, skimming well. Simmer 2–3 hours or until the stock is really strong and good. Then strain off, reserving the pieces of tail and vegetables for a second stock.")])]), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("Next day skim off all fat from the stock and measure out a good 1.2L/2 pints. Put into a pan with the finely minced or scraped beef, the whites of egg beaten to a froth, and the shells. Clarify as for consommé (see clarification of bouillon, ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_101"
    }
  }, [_vm._v("page 101")]), _vm._v("). When strained, reheat and serve with a little of the shredded meat from the tail in the soup as a garnish, and a dust of cayenne. An extra glass of sherry may be poured into the soup just before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("THICK OXTAIL")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints oxtail stock, either remains of the first, or the second stock, well strained and skimmed")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("the meat picked from the tail, together with a little lean ham or boiled bacon, about 150g/4-5 oz in all")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("30g/1¼ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("30g/1¼ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 glass sherry or Madeira")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("cayenne")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Make sure the stock is well flavoured and strong: reduce if necessary. Mince and pound the meat until smooth. Make a roux with the butter and flour. Pour in the stock, blend, bring to the boil, and simmer to reduce for 10–15 minutes. Now add by degrees to the meat, adjust seasoning, and rub all through a wire sieve. Return to the rinsed-out pan, and finish with the sherry.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If a mortar is not used, it is best to rub the meat through a sieve after mincing, before diluting with the liquid.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Turtle soup is rarely made in the domestic kitchen, and as it can be bought for those rare occasions when it is required it was thought un-necessary to include a recipe here. It may be either thick or clear, but the latter is considered the finer soup. The garnish of small pieces of the green fat floating in the soup is considered a delicacy. Mock Turtle is also a good clear soup, made with calf’s head, which gives it the correct gelatinous quality. The soup is clarified and served with small squares of the jelly part of the head as the garnish. Quarters of lemon are served separately. The head can be used for a dish, such as Devilled Head (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter18#page_524",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 524")]), _vm._v("), during the next day or two.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MOCK TURTLE SOUP")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("to be prepared a day before it is required")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("½ calf’s head")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz bacon fat or dripping")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 gammon rasher of bacon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz veal trimmings, cut from the knuckle or shoulder")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("450g/1 lb lean gravy beef")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 stick of celery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz each of carrots, onions, and turnips, cut in quarters")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a large bouquet garni, parsley, thyme, savory, marjoram, and bay-leaf")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("6 peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2.4-3.6L/4–6 pints water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("For clarifying")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("the whites of 1 or 2 eggs, and the shells, and")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("half the beef already mentioned")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("1 glass Marsala")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("Bone the head after soaking well, tie up the meat neatly with tape, and blanch for 5–10 minutes, Take out, plunge into cold water, drain, and dry. Break up the bones, and allow to brown in the oven.")])]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Meanwhile heat the fat in a large pan, put in the bacon, veal, and half the beef cut into fairly large pieces. Fry briskly till turning colour, lower the heat and add the vegetables. Rissoler 5 minutes or so, then draw aside and add the herbs, peppercorns, salt, and water. Bring slowly to the boil, skimming thoroughly. Add the bones and the head, bring again to the boil, skim again, then simmer gently 3–4 hours. Take up the head and press gently under a weight.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("Strain off the stock, and leave till next day, when it should be a firm jelly. Skim off all fat, measure out 1.2L/2 pints and put into a pan with the remaining beef, finely minced. Add the egg whites whipped to a froth and the crushed shells and clarify as for consommé (see clarification of bouillon, ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_101"
    }
  }, [_vm._v("page 101")]), _vm._v("). Reheat, adding the Marsala, and small squares of the gelatinous parts of the head as a garnish.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SCOTCH OR MUTTON BROTH")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("750-900g/1½–2 lb neck of mutton, scrag or middle neck")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.7L/3 pints water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz pearl barley previously soaked overnight")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz each of carrot, leek, and turnip")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz celery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("freshly ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a level teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chopped parsley")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Remove as much fat as possible and cut the mutton up into small pieces. Put into the cold water and bring slowly to the boil, skimming well. When all the scum has been removed add the barley and salt, and simmer 20-30 minutes. Now add the vegetables cut into small dice, and freshly ground pepper. Continue cooking gently about 1½ hours with the lid on the pan. Now remove the mutton, cut a few good pieces off the bone, and return these to the broth. Skim to remove any fat, adjust seasoning, and add parsley; the soup should be thick, and full of vegetables and barley.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CHICKEN BROTH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Use strong chicken stock as a base and the same vegetables as in above recipe, but cut into finer dice and substitute rice for barley. An excellent addition is 2–3 tablespoons thick cream stirred in just before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("VIII. PARTY SOUPS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Now come some recipes for soups which we hesitated to give in the general section of this chapter, being afraid they might be dismissed with remarks of ‘no time,’ ‘too extravagant’ and so forth–and that would be a pity. But the frustrations and restrictions of everyday life have a way of melting when a party is in question. So here they are.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The first recipe given is to me most interesting. It was given to us by R. H.’s mother and is quoted exactly as she gave it to us. It is an onion soup into which raw eggs are beaten at the last moment, one egg for each person. A good vegetable bouillon may at need be substituted.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SOUPE À L’OIGNON")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A lunch or supper dish. By Baron de Grandmaison. Paris in the eighties or nineties.")]), _vm._v(" "), _c('div', {
    staticClass: "disp-quote-q"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_vm._v("‘This must be served in marmites, red rough earthenware, glazed inside, large enough for one portion. The marmites are placed in a soup-plate, one before each guest.")])]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("1. Warm gently sufficient bouillon for total quantity.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("2. Cut up onions in slices and place them in frying-pan; make them revenir to a golden colour, not brown: best butter should be used.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("3. When the onions are ready, put them into the bouillon and bring to boil.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("4. Have ready slices of French bread, toasted. In another plate gruyère and Parmesan cheese in equal parts, 15 grammes (Approx. ½ oz.) of each per portion.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("5. Put the bread into each marmite. Soak the bread with the bouillon boiling hot. Add, without stirring, the cheese in each marmite, heat above and below, or in the oven, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("6. Alongside each soup-plate put a raw fresh egg, which must be broken by the guest into the marmite, and the whole stirred with a fork, adding pepper and salt to their taste.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("7. It is wished that the dish should be served boiling hot, and that it should be eaten out of the marmite and not the soup-plate.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘The above was given to my aunt by her friend M. de Grandmaison, a frequent guest at her house at Dinard in the eighties and nineties. My aunt was a very good cook and entertained a great deal, especially the French society who went to Dinard in the summer. My uncle was a well-known gourmet and their house was very popular.’")])])]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The next two recipes are just plain expensive. The first is a Lobster Bisque, the second an American lobster soup.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BISQUE D’HOMARD (LOBSTER BISQUE)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz carrots")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 shallot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 small uncooked lobster")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 tablespoons cognac")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 wineglasses white wine")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz rice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2L/3½ pints court bouillon au vin")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 tablespoons cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning, including cayenne")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut the vegetables into a fine mirepoix. Melt half the butter in a large sauté pan, add the mirepoix, cook gently for some minutes, then put in the lobster split in two, cut side downwards. Keep out any spawn or coral and pound with the rest of the butter. Pass through a fine sieve and reserve. Increase the heat, cover, and sauté for 2 minutes. Heat the cognac, flame, and pour over with the white wine, a pinch of salt, and a touch of cayenne. Cover tightly and cook very gently for 15 minutes, shaking the pan occasionally. Meanwhile cook the rice in about 600ml/1 pint of the bouillon for about 30 minutes until really soft. Shell the lobster, cut up the meat finely, and put into a mortar with the creamy part from the head and any spawn or coral. Drain the liquid from the sauté pan and reserve it, adding the mirepoix to the mortar. Pound thoroughly. Then add the rice by degrees, pounding all the time, and being careful not to add any liquid. When really fine, add the reserved liquid and turn into a clean saucepan. Dilute with about 300ml/½ pint of the bouillon, and pass through a fine sieve or tammy through a piece of butter muslin. Return again to the pan, add the remaining bouillon, reheat, draw off the fire, and beat in the lobster butter; whisk in the cream, season, and serve.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_107"
    }
  }), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("The soup may be reheated after the butter has been added, but must on no account boil, as this would ruin the texture and flavour of the soup.")])]), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following recipe was given to us by the Arab cook mentioned in the Introduction:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SOUPE D’HOMARD À L‘AMÉRICAINE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 small uncooked lobster or 600ml/1 pint uncooked shrimps")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz fresh butter or good oil")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a large pinch of saffron, soaked overnight in an egg cup of water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 level teaspoon curry-powder")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 glass red wine")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon brandy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 large tablespoon rice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints good well-reduced court bouillon au vin")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 heaped teaspoon tomato purée")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a bouquet garni")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 dessertspoon freshly chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("croûtons of bread fried in butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("thin slices of lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Split the lobster in two and remove the bag from the head. Crack the claws. Melt the butter in a large sauté or stew-pan, put in the lobster split side downwards, cover, and cook on a low fire 7 minutes. Meanwhile slice the onion very finely and crush the garlic with a little salt. Then remove the lobster, and add the onions, garlic, and curry-powder. Sauté until brown. Add the flour, wine, brandy, saffron, rice, and court bouillon. Bring to the boil, add the bouquet, a little salt and pepper, and cook gently uncovered for about an hour. Meanwhile take the meat from the lobster and cut into small pieces. Add to the soup and leave to poach 20–30 minutes without boiling. Finish with the parsley and tomato purée, and serve the croûtons and slices of lemon separately.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If using shrimps do not sauté first, but add them to the soup when finished and leave to poach 30 minutes. Then remove, shell, and replace them in the soup. Press the shells well in a strainer to extract all the juice, which should be added to the soup.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Potage Purée Bonne Femme can fairly be described as a dinner-party soup. It is a smooth cream soup of which the main ingredients are leek and potato, but it is made with milk and a liaison of yolks of egg and cream is added.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE PURÉE BONNE FEMME")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("4 potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("6 leeks")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("450ml/¾ pint milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("450ml/¾ pint water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Liaison")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("2 yolks of egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("150ml/¼ pint single cream or top of milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang1a"
  }, [_vm._v("croûtons of fried bread")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("Slice the potatoes and shred the leeks. Melt the butter in a stew-pan, add the potatoes and leeks, reserving 1 leek. Season with salt and pepper and stir over a slow fire until the vegetables are nearly soft. Add the milk and water and stir until boiling. Draw aside and leave to simmer for 15–20 minutes. Rub through ")]), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("a sieve, add gradually the yolks of egg beaten into the cream, and thicken over a slow fire without boiling. Serve in a marmite with the remaining leek, shredded, blanched, and drained, scattered over the top of the soup, and with croûtons of fried bread.")])]), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Crème Vichyssoise is a cold soup of particularly delicious flavour. This also is made with leeks and potato, but it calls for chicken broth and a certain amount of cream. When these ingredients are available it is well worth making as it is one of the best of cream soups. It should be eaten ice-cold with finely minced chives on the top.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CRÈME VICHYSSOISE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("the white part of a dozen small leeks")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 or 4 potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 stick of celery (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("parsley and chives")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints strong chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt, pepper, and nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("300ml/½ pint cream, or top of milk")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Heat the butter slowly and add the finely sliced leeks. Cover and shake the pan gently over moderate heat for about 15 minutes, that is until the leeks are softened and pale yellow. They must not turn brown at all. You will need to watch and stir frequently. Add the finely sliced potatoes and celery, the chopped parsley, stock, and seasoning. Bring to the boil, stirring, and then simmer for 30 minutes or until all the vegetables are well cooked. Pass the whole through a nylon sieve and then through a tammy, for this soup should be velvet-smooth. Re-season, allow to cool, add cream, chill in the refrigerator or on ice, and serve with finely chopped chives sprinkled on top. It may be served hot, but is then less seductive, and a less rich soup might better take its place.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("See also ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter37#page_1025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 1025")]), _vm._v(" for this soup made in an emulsifying machine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Another soup which calls for chicken stock, this time with eggs as a liaison, is Potage Crème Germiny:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTAGE CRÈME GERMINY")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("2 large handfuls sorrel")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 large handfuls spinach")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 handful spring onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("20g/¾ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("900ml/1½ pints chicken stock, well strained")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 yolks of egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("300ml/½ pint thin cream or top of milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("very small egg croquettes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Well wash the sorrel and spinach. Trim the spring onions, leaving the green tops. Cut all in fine shreds. Melt the butter in a stew-pan, put in the vegetables and stock, cover, and stew gently for 20 minutes. Rub through a fine sieve. Rinse out the pan thoroughly, return the soup, and bring it to the boil. Draw aside. Beat the yolks well, add a small quantity of the cream and then several spoonfuls of the hot soup by degrees. Pour back into the pan with the remainder of the cream and stir continuously until very hot. Adjust the seasoning. On no account boil or bring near to boiling-point: it is really better to do this final thickening in a double saucepan. The consistency should be that of thin cream, and the flavour pleasantly acidulated. Garnish with very small egg croquettes served separately.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To make a good borsch with the proper accompaniments takes some time, so the following is a dish to try when you have a little leisure. It calls for strong, well-flavoured meat stock, but may be made with a liquid made with dried mushrooms and water in the proportion of 15g/½ oz dried mushrooms to "), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_vm._v("2.4L/ 4 pints water. The stock thus made should be cooked until the flavour is extracted from the mushrooms, and should be well seasoned. It is, of course, equally possible to make it with a good vegetable stock, but it cannot then be truly called a borsch. Here are recipes for Consommé Borsch and a Bortchok:")])]), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("CONSOMMÉ BORSCH")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("whites of 2 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz minced gravy beef")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 raw beetroot, the round, deep red variety")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints strong, well-flavoured beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("sour cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("piroshski (see below)")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_vm._v("Whip the whites to a froth, mix with the beef, and put into an enamel or tin-lined pan. Peel and grate the beetroot, add to the pan with the stock. Whisk over the fire until boiling, draw aside carefully and simmer for 30–40 minutes, taking care not to disturb the crust. Take off the fire and leave for about 5 minutes before straining through a scalded cloth (see clarifying notes, ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_101"
    }
  }, [_vm._v("page 101")]), _vm._v("). Reheat carefully, season, and serve with a bowl of sour cream and piroshski.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Piroshski are small turnovers or Russian pies made with a light yeast dough and filled with minced meat, mushrooms, rice, hard-boiled eggs, etc. They are made quite small in the shape of a turnover and handed hot in a napkin with either clear borsch or bortchok or any gravy soup.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PIROSHSKI")]), _vm._v(" "), _c('p', {
    staticClass: "h3-c"
  }, [_c('span', {
    staticClass: "h3-italic"
  }, [_vm._v("Dough")])]), _vm._v(" "), _c('div', {
    staticClass: "space1"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("10g/¼ oz yeast")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40ml/1½ fl oz milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz creamed butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("beaten egg")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Sift and warm the flour and salt. Cream yeast with the sugar and dissolve in the warm milk. Beat the egg and add to the flour with the milk. Beat thoroughly. The dough should be fairly soft. Work in the creamed butter and set to rise 30 or 40 minutes in an even temperature. It may then be put aside in an ice-box or refrigerator for use when wanted. In any case this preliminary chilling makes for easy handling. Roll out on a floured board, stamp out into large rounds, brush with beaten egg, and put a teaspoon of filling on each. Fold over and pinch the edges well together, and flatten each one lightly on the board so that the join will make a ridge along the top. Put to prove 10-15 minutes, then brush lightly with egg and bake in a hot oven, 230°C/450°F/gas 8. These may also be fried in the same way as rissoles.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "h3-italic"
  }, [_vm._v("Meat filling")])]), _vm._v(" "), _c('div', {
    staticClass: "space1"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("10g/¼ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ shallot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("15g/½ oz mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz cooked minced beef or ham")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Melt the butter in a small pan, add the shallot finely chopped, soften slightly, then add the chopped mushrooms. Cook briskly for a minute or two, then add the minced meat and seasoning and work well together. Cool before using.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_c('span', {
    staticClass: "h3-italic"
  }, [_vm._v("Maigre filling")])])]), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_c('div', {
    staticClass: "space1"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("10g/¼ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ handful small spring onions")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1–1½ tablespoons boiled rice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ hard-boiled egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Wash and slice mushrooms. Cook in the butter. Wash and trim the onions, keeping the green part, and cut in very small pieces with scissors. Mix everything together in a bowl and season well with salt and freshly ground black pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BORTCHOK")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1.2L/2 pints strong, clear, well-flavoured beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 large cooked beetroot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("sour cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("piroshski")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Put the stock in a pan and bring to the boil. Grate the beetroot fairly finely and add to the pan. Infuse on a very gentle heat for about half an hour. When a good flavour of beetroot is obtained, strain through a muslin, rinse out the pan, return the soup, and reheat. Serve with sour cream and piroshski of meat or containing a "), _c('i', [_vm._v("maigre")]), _vm._v(" filling of hard-boiled eggs and parsley. The soup should be almost clear and a good red colour; therefore the stock must be well made, as for consommé.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_vm._v("In the Winkfield chapter will be found other party soups, a Cold Tomato Soup (")]), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31#page_864",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 864")]), _vm._v("), a Cream of Curry Soup ("), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31#page_863",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 863")]), _vm._v("), and an almond soup, Potage Crème d’Amandes ("), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31#page_861",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 861")]), _vm._v("), etc.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("SOUP GARNISHES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Garnishes for soups in the domestic kitchen are a simpler affair than the classic garnishes of the "), _c('i', [_vm._v("haute cuisine")]), _vm._v(", as a glance at the subject in one of the important French cookery books will show. The important aspect of the matter in the domestic kitchen is really a comprehension of the principles that guide us in choosing a garnish. With this understanding there is plenty of opportunity for improvisation with the materials at hand. This section of the soup chapter, therefore, is chiefly concerned with these principles, but in passing we should note that however well we may experiment and invent, we should not misapply classic names. For example, the name Consommé à la Royale indicates a garnish of a firm, lightly cooked egg custard, added in small pieces or shapes to the clear soup; if in place of it you choose to use green peas, the correct garnish for Crème St Germain, or the asparagus tips for Consommé Princesse, there is no reason why you should not do so, but then the soup should not be labelled ‘Royale’. This would be a misuse of a classic name.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Generally speaking, a garnish is added to a soup for one of the following purposes, or possibly for a combination of them: (1) to embellish, (2) to add flavour, (3) to give contrast of texture, (4) to make a more substantial dish. In attempting to achieve any one of these objects, it is necessary to observe certain precautions. It is important not to detract from some essential quality of the soup by choosing an unsuitable garnish; for example, a strongly flavoured garnish might overwhelm a subtly flavoured soup. An ordinary fried crouton added to a clear and limpid consommé might spoil these very characteristics by dispersing a slight trail of grease over the surface of the soup. On the other hand, sometimes, when a clear consommé is to contain a julienne of vegetables, the recipe may indicate that these are to be cooked to a very light brown in a nut of butter; then, should a little of the delicate beurre noisette escape into the soup, this is "), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("not considered a detraction. It is not so much a case of hard and fast rules as of discrimination.")])]), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Here are some examples of the purposes enumerated:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("1. To embellish.")]), _vm._v(" In Consommé à la Royale the garnish, a small portion of a cooked egg custard, gives a pleasant appearance, as well as being of a good texture. A julienne added to a consommé is both an embellishment and an addition to the flavour; one has the agreeable colours of gold, green, and white from the carrots, green vegetables, and celery.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("2. To add flavour.")]), _vm._v(" Croûtes Mornay are a piquant addition to a tomato soup; picked shrimps add flavour to a bland potato soup.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("3. To give contrast of texture.")]), _vm._v(" Crisp croûtons provide a contrast of texture in any cream soup; shreds of raw celery do the same and are good also with a consommé.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("4. To make a more substantial dish.")]), _vm._v(" With some garbures, croûtes covered with a purée of the vegetables are served. With Potage Périgord cabbage leaves are filled with a stuffing and served with the soup. Cheese croûtes are served with Potage à l’Oignon. Sometimes tiny profiteroles made of choux paste, no bigger than a small marble, are split and filled with a mixture that will add contrast to a soup: for example, a tiny bit of beaten-up cream cheese or devilled cream (cream mixed with Worcestershire sauce, cayenne, and French mustard), a purée of mushrooms, a curry-flavoured cream, or a horse-radish cream. Even in these fillings there is scope for experiment. A plain broth may have croûtes the size of a 10p piece on which a purée of vegetables has been laid and then grilled; these are either put at the bottom of the soup-tureen or served separately. In certain cream soups a refreshing flavour is added by using the diced flesh of tomatoes or cucumber. As a garnish for a watercress soup a little dab of cream cheese added at the last moment is good: indeed, this is good in many soups needing a heightening of flavour.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the domestic kitchen a garnish is almost bound to depend on what you may have at hand, and for this very reason there is opportunity for invention and cleverness. Here are a few more suggestions for your consideration: A bland soup, such as spinach, may have tiny egg croquettes served in it, eggs and spinach presenting a good combination of flavour. Some people like a sweet element in a potato soup, and shredded prunes, French plums, or almonds may be added. As well as egg custard for Consommé à la Royale and the julienne of vegetables for Consommé Julienne, vermicelli, various pastas, sago, profiteroles, green peas, and asparagus points are all commonly used, and when fried croûtons are not wanted, croûtons of toast are sometimes substituted.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CUSTARD FOR CONSOMMÉ À LA ROYALE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 egg white")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 tablespoons cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Put the mixture into a dariole mould or a tea-cup and steam gently until set. For a yellow custard, take 2 egg yolks to 3 or 4 tablespoons cream, season, and cook in the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CROÛTES MORNAY")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Toast bread on one side only and on the untoasted side put a layer of mornay sauce; sprinkle with a little cheese and cook under the grill.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("Croûtes or croûtons may either be fried in deep fat or in just enough hot fat almost to cover them in a frying-pan. For flavour butter should be used, preferably clarified, but frying-oil or lard may be substituted. The fat, in a frying-pan, is heated over moderate heat; when hot the croûtons or croûtes are put in, and when lightly coloured lifted out and drained. Only the surface of the bread should be ")]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("coloured, and this should not be more than a light, golden brown. Fried bread deepens a little in colour when taken out of the fat, and this should be borne in mind. The whole of the cooking should be done over gentle heat, not too quickly.")])]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("TOASTED CROÛTONS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A slice of stale bread should first be lightly toasted, then cut in dice.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TO CUT POTATOES FOR POTATO CROÛTONS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Pare the potatoes thinly; cut in thick slices; cut these slices into sticks, put a bundle of the sticks together flat on a board and cut them across so that you have small dice; plunge these at once into cold water to wash away the starch, drain and dry them. Blanch the dice for 2 or 3 minutes, strain and allow to dry a little, then fry till golden brown and crisp in butter or oil; drain and sprinkle lightly with salt.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Unsweetened pancakes are sometimes used as a soup garnish; they may be cut into rounds or into thin strips. Little sprigs of chervil called pluches are used as a garnish for many soups.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("The Russian garnishes for soups are of quite substantial proportions. Both pirogi and piroshski are served. Pirogi means a pie and piroshski is its diminutive, meaning a little pie. The paste for these may be of brioche type or puff paste, or the dough given on ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#page_110"
    }
  }, [_vm._v("page 110")]), _vm._v(", and the filling is of rice, meat, hard-boiled eggs, cabbage, etc. The shape of the pie is like our Cornish pasty. If a large pirogi is served it may be sliced. The little piroshski are served whole. These accompaniments are commonly served with borsch, and they may equally form part of the cocktail savoury preceding the meal.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A short list of soup garnishes and the soups they usually accompany is added as a guide:")]), _vm._v(" "), _c('div', {
    staticClass: "tablex"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Garnishes")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Served with")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Bread and potato croûtons")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Any purée, especially pea and potato")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Brunoise")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Consommé or soups from the pot-au-feu")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Celery chips")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Tomato, potato, lentil soup")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Cheese profiteroles")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("As above, or any velouté creams")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Cheese-straws")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Tomato, carrot, potato soups")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Chopped hard-boiled egg")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Most purées, particularly green")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Fish or chicken quenelles")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Velouté cream soups")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Force-meat balls")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Game purées, e.g, hare, kidney")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Fried sliced apple")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Celery or chestnut soup")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Julienne")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Consommé or soups from the pot-au-feu")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Liptauer or creamed cheese")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Potato or other bland cream soups")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Mornay croûtes")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Tomato, carrot soup, or mixed purées")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Picked shrimps")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Any bisque, potato purée, tomato soup")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Royale")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Consommés")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Salted cucumber or gherkin")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Giblet, kidney soups")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Shredded pancakes (fried till crisp)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Green soups")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Small pats of green butter")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Cream of celery soup")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Tiny ravioli filled with any good force-meat")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("Gravy soups or consommé")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-a"
  }, [_vm._v("Vegetable purée on croûtes")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-b"
  }, [_vm._v("A clear gravy or game soup")])])])])])])])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(189),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781909166103',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(199)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(201);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 201 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.233edf8a5422f3a7fb19.js